(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77],{

/***/ 17881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-alerts/[slug]",
      function () {
        return __webpack_require__(50030);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ approveCoverage; },
/* harmony export */   "C1": function() { return /* binding */ rejectCoverage; },
/* harmony export */   "H$": function() { return /* binding */ fetchPendingCoverage; },
/* harmony export */   "eh": function() { return /* binding */ submitCoverage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);



var unwrap = function(res) {
    return res.data.data;
};
var submitCoverage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, url) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/coverage-submissions", {
                            alertId: alertId,
                            url: url
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function submitCoverage(alertId, url) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPendingCoverage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/coverage-submissions/pending", {
                            params: {
                                page: page,
                                size: size
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchPendingCoverage() {
        return _ref.apply(this, arguments);
    };
}();
var approveCoverage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id, param) {
        var title, publisher;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    title = param.title, publisher = param.publisher;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/coverage-submissions/".concat(id, "/approve"), {
                            title: title,
                            publisher: publisher
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function approveCoverage(id, _) {
        return _ref.apply(this, arguments);
    };
}();
var rejectCoverage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/coverage-submissions/".concat(id))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function rejectCoverage(id) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 11305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bf": function() { return /* binding */ fetchAlertDirectoryTopics; },
/* harmony export */   "KK": function() { return /* binding */ fetchDirectoryExcluded; },
/* harmony export */   "Z_": function() { return /* binding */ setDirectoryExcluded; },
/* harmony export */   "eF": function() { return /* binding */ saveDirectoryPageCopy; },
/* harmony export */   "gg": function() { return /* binding */ fetchDirectoryPageCopy; },
/* harmony export */   "re": function() { return /* binding */ saveAlertDirectoryTopics; },
/* harmony export */   "uD": function() { return /* binding */ fetchDirectoryStatus; },
/* harmony export */   "vF": function() { return /* binding */ fetchDirectoryTopics; }
/* harmony export */ });
/* unused harmony exports fetchMortgageBrokerHub, fetchMortgageBrokerTopic, fetchMortgageBrokerPage, fetchDirectoryProfile */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);



var unwrap = function(res) {
    return res.data.data;
};
var fetchMortgageBrokerHub = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/mortgage-brokers")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchMortgageBrokerHub() {
        return _ref.apply(this, arguments);
    };
}();
var fetchMortgageBrokerTopic = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/mortgage-brokers/topic/".concat(encodeURIComponent(slug)))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchMortgageBrokerTopic(slug) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMortgageBrokerPage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/mortgage-brokers/page/".concat(encodeURIComponent(slug)))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchMortgageBrokerPage(slug) {
        return _ref.apply(this, arguments);
    };
}();
// Town and topic back-links for a profile page; empty for anyone not listed.
var fetchDirectoryProfile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var timeout;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    timeout = (_arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}).timeout;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/mortgage-brokers/profile/".concat(encodeURIComponent(slug)), timeout ? {
                            timeout: timeout
                        } : undefined)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchDirectoryProfile(slug) {
        return _ref.apply(this, arguments);
    };
}();
// Admins only: whether the profile is listed, and the switch that takes it out.
var fetchDirectoryStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(profileId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/admin/profiles/".concat(profileId))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchDirectoryStatus(profileId) {
        return _ref.apply(this, arguments);
    };
}();
var setDirectoryExcluded = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(profileId, excluded) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/directory/admin/profiles/".concat(profileId, "/excluded"), {
                            excluded: excluded
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function setDirectoryExcluded(profileId, excluded) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDirectoryExcluded = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/admin/excluded")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchDirectoryExcluded() {
        return _ref.apply(this, arguments);
    };
}();
// Admins only: the editor copy of every directory topic and town page.
var fetchDirectoryPageCopy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/admin/page-copy")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchDirectoryPageCopy() {
        return _ref.apply(this, arguments);
    };
}();
var saveDirectoryPageCopy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(copy) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/directory/admin/page-copy", copy)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function saveDirectoryPageCopy(copy) {
        return _ref.apply(this, arguments);
    };
}();
// Admins only: the directory topic pages an alert's story is listed on.
var fetchDirectoryTopics = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/admin/topics")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchDirectoryTopics() {
        return _ref.apply(this, arguments);
    };
}();
var fetchAlertDirectoryTopics = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/directory/admin/alerts/".concat(alertId, "/topics"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchAlertDirectoryTopics(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var saveAlertDirectoryTopics = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, expertiseIds, townSlugs) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/directory/admin/alerts/".concat(alertId, "/topics"), {
                            expertiseIds: expertiseIds,
                            townSlugs: townSlugs
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function saveAlertDirectoryTopics(alertId, expertiseIds, townSlugs) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 57573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ alertIdFromSlug; },
/* harmony export */   "DE": function() { return /* binding */ editSponsorAnswers; },
/* harmony export */   "FI": function() { return /* binding */ fetchSponsorships; },
/* harmony export */   "Nl": function() { return /* binding */ fetchSponsorForm; },
/* harmony export */   "TD": function() { return /* binding */ startFaqSponsorCheckout; },
/* harmony export */   "Vp": function() { return /* binding */ declineSponsorAnswers; },
/* harmony export */   "sM": function() { return /* binding */ startFaqSponsorRenewal; },
/* harmony export */   "so": function() { return /* binding */ approveSponsorAnswers; },
/* harmony export */   "wK": function() { return /* binding */ submitSponsorAnswers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);



// Evergreen Sponsor. Called on the raw axios instance, like api/newsroom.js,
// so the API's message and status reach the page.
var unwrap = function(res) {
    return res.data.data;
};
// The slug comes from the URL, so it must not be able to steer the request elsewhere.
var alertIdFromSlug = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var alert;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/alerts/slug/".concat(encodeURIComponent(slug)))
                    ];
                case 1:
                    alert = unwrap.apply(void 0, [
                        _state.sent()
                    ]);
                    if (!Number.isInteger(alert === null || alert === void 0 ? void 0 : alert.id)) throw new Error("Alert not found");
                    return [
                        2,
                        alert.id
                    ];
            }
        });
    });
    return function alertIdFromSlug(slug) {
        return _ref.apply(this, arguments);
    };
}();
// The Stripe Checkout URL for a responder buying the slot. 409 when it is gone.
var startFaqSponsorCheckout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var _, _1, _2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post;
                    _2 = (_1 = "/stripe/checkout/session/faq-sponsor/").concat;
                    return [
                        4,
                        alertIdFromSlug(slug)
                    ];
                case 1:
                    return [
                        4,
                        _.apply(api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, [
                            _2.apply(_1, [
                                _state.sent()
                            ])
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function startFaqSponsorCheckout(slug) {
        return _ref.apply(this, arguments);
    };
}();
var startFaqSponsorRenewal = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        var _, _1, _2;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post;
                    _2 = (_1 = "/stripe/checkout/session/faq-sponsor/").concat;
                    return [
                        4,
                        alertIdFromSlug(slug)
                    ];
                case 1:
                    return [
                        4,
                        _.apply(api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, [
                            _2.apply(_1, [
                                _state.sent(),
                                "/renewal"
                            ])
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function startFaqSponsorRenewal(slug) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSponsorForm = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/faq-sponsor/".concat(alertId))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchSponsorForm(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var submitSponsorAnswers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, body) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/faq-sponsor/".concat(alertId, "/answers"), body)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function submitSponsorAnswers(alertId, body) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSponsorships = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/faq-sponsor", {
                            params: {
                                page: page,
                                size: size
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchSponsorships() {
        return _ref.apply(this, arguments);
    };
}();
var editSponsorAnswers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, body) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/faq-sponsor/".concat(alertId, "/review"), body)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function editSponsorAnswers(alertId, body) {
        return _ref.apply(this, arguments);
    };
}();
var approveSponsorAnswers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/faq-sponsor/".concat(alertId, "/approve"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function approveSponsorAnswers(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var declineSponsorAnswers = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, reason) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/faq-sponsor/".concat(alertId, "/decline"), {
                            reason: reason
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function declineSponsorAnswers(alertId, reason) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 2359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ releaseBank; },
/* harmony export */   "GB": function() { return /* binding */ fetchBankStats; },
/* harmony export */   "LM": function() { return /* binding */ fetchMyBankHistory; },
/* harmony export */   "QK": function() { return /* binding */ fetchMyBanks; },
/* harmony export */   "gz": function() { return /* binding */ unbankRaw; },
/* harmony export */   "jz": function() { return /* binding */ bankRaw; },
/* harmony export */   "kv": function() { return /* binding */ fetchLiveBanks; },
/* harmony export */   "pJ": function() { return /* binding */ fetchBankStatus; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);



var unwrap = function(res) {
    return res.data.data;
};
var bankRaw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/raw-banks", {
                            alertId: alertId
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function bankRaw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyBanks = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raw-banks/mine")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchMyBanks() {
        return _ref.apply(this, arguments);
    };
}();
// Every Raw the journalist has banked: each can be banked only once.
var fetchMyBankHistory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raw-banks/mine/history")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchMyBankHistory() {
        return _ref.apply(this, arguments);
    };
}();
var fetchBankStatus = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raw-banks/alerts/".concat(alertId))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchBankStatus(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLiveBanks = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raw-banks")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchLiveBanks() {
        return _ref.apply(this, arguments);
    };
}();
var fetchBankStats = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raw-banks/stats")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchBankStats() {
        return _ref.apply(this, arguments);
    };
}();
var unbankRaw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/raw-banks/".concat(id, "/unbank"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function unbankRaw(id) {
        return _ref.apply(this, arguments);
    };
}();
var releaseBank = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/raw-banks/".concat(id, "/release"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function releaseBank(id) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 30694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ authorRole; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_news_article_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72638);
/* harmony import */ var styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51495);
/* harmony import */ var styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var authorRole = function(author) {
    return !author.isOrganization && author.jobTitle ? "".concat(author.jobTitle, ", Newspage") : null;
};
// Who wrote the story, under it; on their own page (onPage) it heads the page.
var AuthorBlock = function(param) {
    var author = param.author, _onPage = param.onPage, onPage = _onPage === void 0 ? false : _onPage;
    var photo = (0,utils_news_article_schema__WEBPACK_IMPORTED_MODULE_2__/* .webUrl */ .wo)(author.photoUrl);
    var linkedin = (0,utils_news_article_schema__WEBPACK_IMPORTED_MODULE_2__/* .webUrl */ .wo)(author.linkedinUrl);
    var role = authorRole(author);
    var href = (0,utils_news_article_schema__WEBPACK_IMPORTED_MODULE_2__/* .authorPath */ .tw)(author.slug);
    var Name = onPage ? "h1" : "p";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: [
            (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorBlock),
            !onPage && (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorFoot)
        ].filter(Boolean).join(" "),
        "aria-label": onPage ? undefined : "About the author",
        children: [
            photo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorPhoto),
                src: photo,
                alt: author.name,
                width: 96,
                height: 96
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Name, {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorName),
                        children: onPage ? author.name : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: href,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: author.name
                            })
                        })
                    }),
                    role && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorRole),
                        children: role
                    }),
                    author.bio && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorBio),
                        children: author.bio
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorLinks),
                        children: [
                            !onPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: href,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    children: [
                                        "More from ",
                                        author.name
                                    ]
                                })
                            }),
                            linkedin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: linkedin,
                                target: "_blank",
                                rel: "noopener",
                                children: "LinkedIn"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AuthorBlock);


/***/ }),

/***/ 844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_newsroom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93889);
/* harmony import */ var styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51495);
/* harmony import */ var styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3__);




// The expert who seeded a Raw from their own intel, linked to their profile.
var SourceCredit = function(param) {
    var seededBy = param.seededBy;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/".concat(seededBy.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sourceCredit),
            children: "Source: ".concat((0,utils_newsroom__WEBPACK_IMPORTED_MODULE_2__/* .sourceCredit */ .sX)(seededBy))
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceCredit);


/***/ }),

/***/ 16302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DateProgress; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/modules/DateProgress.module.scss
var DateProgress_module = __webpack_require__(73269);
var DateProgress_module_default = /*#__PURE__*/__webpack_require__.n(DateProgress_module);
// EXTERNAL MODULE: ./components/CrosshatchLine.js
var CrosshatchLine = __webpack_require__(74459);
;// CONCATENATED MODULE: ./helpers/getDatePercentageDifference.js
var getDatePercentageDifference = function(createdAt, deadline) {
    var start = new Date(createdAt);
    var end = new Date(deadline);
    return "calc(".concat(Math.round((new Date() - start) / (end - start) * 100), "% - 4px)");
};

;// CONCATENATED MODULE: ./components/DateProgress.js





var DateProgress = function(param) {
    var createdAt = param.createdAt, deadline = param.deadline, height = param.height, isFTEditor = param.isFTEditor;
    if (!deadline || !createdAt) {
        return null;
    }
    var ref = (0,react.useState)(getDatePercentageDifference(createdAt, deadline)), width = ref[0], setWidth = ref[1];
    (0,react.useEffect)(function() {
        setWidth(getDatePercentageDifference(createdAt, deadline));
        var interval = setInterval(function() {
            setWidth(getDatePercentageDifference(createdAt, deadline));
        }, 60000);
        return function() {
            clearInterval(interval);
        };
    }, [
        createdAt,
        deadline
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (DateProgress_module_default()).progressWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CrosshatchLine/* default */.Z, {
                style: {
                    height: height
                },
                className: (DateProgress_module_default()).line
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    (DateProgress_module_default()).progress,
                    isFTEditor ? (DateProgress_module_default()).ftEditorProgress : "", 
                ].join(" "),
                style: {
                    width: width,
                    height: height
                }
            })
        ]
    });
};
/* harmony default export */ var components_DateProgress = (DateProgress);


/***/ }),

/***/ 45702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30909);
/* harmony import */ var styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var LoginInfo = function(param) {
    var label = param.label, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: (styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2___default().info),
        tabIndex: 0,
        "aria-label": label,
        "data-nosnippet": true,
        children: [
            "i",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (styles_modules_LoginInfo_module_scss__WEBPACK_IMPORTED_MODULE_2___default().popover),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        children,
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/login",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Log in"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginInfo);


/***/ }),

/***/ 34576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Svg_Star__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76997);
/* harmony import */ var styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86157);
/* harmony import */ var styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Svg_diamond__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5019);





var LegendIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "7",
        height: "7",
        viewBox: "0 0 7 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.01331 5.03125L5.90109 5.51797C5.87812 5.61728 5.78974 5.6875 5.6878 5.6875H1.3128C1.21087 5.6875 1.12249 5.61728 1.09952 5.51797L0.987305 5.03125H6.01331Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.55715 2.67442L6.11418 4.59395H0.886052L0.443083 2.67442C0.423614 2.58976 0.455989 2.50139 0.52577 2.44955C0.59577 2.3977 0.689614 2.39223 0.764864 2.43533L2.11871 3.20905L3.3179 1.41026C3.35705 1.35164 3.4218 1.31533 3.49202 1.3127C3.5629 1.30964 3.62961 1.34158 3.67271 1.39714L5.07905 3.20533L6.22246 2.4432C6.29705 2.39376 6.3944 2.3942 6.46811 2.44517C6.54205 2.49614 6.57705 2.58714 6.55715 2.67442Z",
                fill: "white"
            })
        ]
    });
};
var ProfileTag = function(param) {
    var image = param.image, plan = param.plan, name = param.name, _classes = param.classes, classes = _classes === void 0 ? [] : _classes, _isEmbed = param.isEmbed, isEmbed = _isEmbed === void 0 ? false : _isEmbed;
    var getAvatarClassName = function() {
        var baseClass = isEmbed ? (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imgEmbed) : (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().img);
        if (!plan) return baseClass;
        var planClasses = {
            legend: isEmbed ? (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().avatarLegendEmbed) : (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().avatarLegend),
            platinum: isEmbed ? (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().avatarPlatinumEmbed) : (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().avatarPlatinum)
        };
        return planClasses[plan.type] || baseClass;
    };
    var renderTag = function() {
        if (!plan) return null;
        var tagConfig = {
            contributing_editor: {
                className: (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imgTag),
                Icon: _Svg_Star__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
                text: "Pro"
            },
            platinum: {
                className: (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imgTagPlatinum),
                Icon: _Svg_diamond__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                text: "Platinum"
            },
            premium: {
                className: (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imgTagPremium),
                Icon: _Svg_Star__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
                text: "Plus"
            },
            legend: {
                className: (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imgTagLegend),
                Icon: LegendIcon,
                text: "Legend"
            }
        };
        var config = tagConfig[plan.type];
        if (!config) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: config.className,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(config.Icon, {}),
                config.text
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_modules_ProfileTag_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imgWrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: [
                    getAvatarClassName()
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes)).join(" "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: image,
                    alt: name
                })
            }),
            !isEmbed && renderTag()
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileTag);


/***/ }),

/***/ 31773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A8": function() { return /* binding */ useUnbankRaw; },
/* harmony export */   "cn": function() { return /* binding */ releaseTime; },
/* harmony export */   "qx": function() { return /* binding */ useBankRaw; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10092);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var api_raw_banks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2359);
/* harmony import */ var api_newsroom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37665);
/* harmony import */ var store_ux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30807);






// The copy the newsdesk asked for, word for word: banking is a head start, not secrecy.
var BANK_COPY = "It comes off the Newspage archive so other journalists can&rsquo;t find it here while you write. " + "The alert page itself stays public. You can hold two at a time. Please only bank a Raw you intend " + "to run: while it&rsquo;s banked it&rsquo;s out of public view, and if it doesn&rsquo;t run that&rsquo;s " + "a story nobody gets.";
var UNBANK_COPY = "It goes back into the Newspage archive straight away, where other journalists can find and bank it. " + "Each Raw can be banked once, so you won&rsquo;t be able to bank it again.";
// "Fri 14:05": a bank lasts a day, so the weekday tells today from tomorrow.
var releaseTime = function(iso) {
    return new Date(iso).toLocaleString("en-GB", {
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit"
    });
};
var useBankRaw = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    return function(alertId, param) {
        var onBanked = param.onBanked, onError = param.onError;
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .setPopupConfig */ .iH)({
            title: "Bank this Raw for 24 hours",
            body: BANK_COPY,
            confirmTitle: "Bank it",
            cancelTitle: "Cancel",
            onConfirm: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .setPopupLoading */ .BI)(true));
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                (0,api_raw_banks__WEBPACK_IMPORTED_MODULE_1__/* .bankRaw */ .jz)(alertId)
                            ];
                        case 2:
                            onBanked.apply(void 0, [
                                _state.sent()
                            ]);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            err = _state.sent();
                            onError((0,api_newsroom__WEBPACK_IMPORTED_MODULE_2__/* .newsroomError */ .tt)(err, "Could not bank this Raw."));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .setPopupLoading */ .BI)(false));
                            dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .handleHidePopup */ .Zi)());
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }),
            onCancel: function() {
                return dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .handleHidePopup */ .Zi)());
            }
        }));
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .handleShowPopup */ .YF)());
    };
};
// The journalist changed their mind: the Raw goes back before its 24 hours are up.
var useUnbankRaw = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    return function(bankId, param) {
        var onUnbanked = param.onUnbanked, onError = param.onError;
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .setPopupConfig */ .iH)({
            title: "Unbank this Raw?",
            body: UNBANK_COPY,
            confirmTitle: "Unbank it",
            cancelTitle: "Keep it",
            onConfirm: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .setPopupLoading */ .BI)(true));
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                (0,api_raw_banks__WEBPACK_IMPORTED_MODULE_1__/* .unbankRaw */ .gz)(bankId)
                            ];
                        case 2:
                            _state.sent();
                            onUnbanked();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            err = _state.sent();
                            onError((0,api_newsroom__WEBPACK_IMPORTED_MODULE_2__/* .newsroomError */ .tt)(err, "Could not unbank this Raw."));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .setPopupLoading */ .BI)(false));
                            dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .handleHidePopup */ .Zi)());
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            }),
            onCancel: function() {
                return dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .handleHidePopup */ .Zi)());
            }
        }));
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_3__/* .handleShowPopup */ .YF)());
    };
};


/***/ }),

/***/ 43893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useFitCount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16988);
/* harmony import */ var styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69561);
/* harmony import */ var styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var TAG_LIMIT = 5;
var RawTags = function(param) {
    var tags = param.tags;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var listRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // Overflow chips are taken out of the row but keep their size, so every
    // candidate can be measured whatever is showing.
    var visible = (0,hooks_useFitCount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        rowRef: wrapperRef,
        buttonRef: buttonRef,
        measure: function() {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(listRef.current.children).map(function(param) {
                var link = param.firstElementChild;
                return link.scrollWidth + link.offsetWidth - link.clientWidth;
            });
        },
        total: tags.length,
        max: TAG_LIMIT,
        key: tags.map(function(tag) {
            return tag.id;
        }).join(),
        gap: 6,
        enabled: !expanded
    });
    var hidden = tags.length - visible;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (expanded) (ref = listRef.current.querySelectorAll("a")[visible]) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        expanded
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: wrapperRef,
        className: [
            (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_5___default().tags),
            expanded ? (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_5___default().tagsExpanded) : ""
        ].join(" ").trim(),
        "data-nosnippet": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                ref: listRef,
                children: tags.map(function(tag, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: !expanded && index >= visible ? (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_5___default().tagOverflow) : undefined,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/raws?tag=".concat(tag.id),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: tag.name
                            })
                        })
                    }, tag.id);
                })
            }),
            hidden > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: buttonRef,
                type: "button",
                "aria-expanded": expanded,
                onClick: function() {
                    return setExpanded(!expanded);
                },
                children: expanded ? "Show less" : "+".concat(hidden, " more")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RawTags);


/***/ }),

/***/ 9999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SmartText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-animate-height/lib/AnimateHeight.js
var AnimateHeight = __webpack_require__(68133);
// EXTERNAL MODULE: ./styles/modules/SmartText.module.scss
var SmartText_module = __webpack_require__(89073);
var SmartText_module_default = /*#__PURE__*/__webpack_require__.n(SmartText_module);
;// CONCATENATED MODULE: ./utils/hydrateLinks.js
var hydrateLinks = function(text) {
    var matches = text.match(/(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi);
    matches === null || matches === void 0 ? void 0 : matches.forEach(function(m) {
        text = text.replace(m, '<a href="'.concat(m, '">').concat(m, "</a>"));
    });
    return text;
};

// EXTERNAL MODULE: ./utils/safe-html.js
var safe_html = __webpack_require__(95460);
;// CONCATENATED MODULE: ./components/SmartText.js







var SmartText = function(param) {
    var quotes = param.quotes, height = param.height, bg = param.bg, className = param.className, change = param.change, data = param.data;
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var ref1 = (0,react.useState)("auto"), realHeight = ref1[0], setRealHeight = ref1[1];
    var wrapper = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        wrapper.current.offsetHeight < height ? setRealHeight("auto") : setRealHeight(height);
        setOpened(false);
    }, [
        router,
        change
    ]);
    if (data) {
        data = (0,safe_html/* default */.ZP)(hydrateLinks(data));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimateHeight/* default */.Z, {
                duration: 400,
                height: opened ? "auto" : realHeight,
                className: (SmartText_module_default()).descriptionText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: wrapper,
                        className: [
                            quotes ? (SmartText_module_default()).doubleQuoted : undefined,
                            (SmartText_module_default()).data, 
                        ].join(" "),
                        dangerouslySetInnerHTML: {
                            __html: data
                        }
                    }),
                    realHeight !== "auto" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            (SmartText_module_default()).shadow,
                            className,
                            opened ? (SmartText_module_default()).shadowOpened : undefined, 
                        ].join(" "),
                        style: {
                            background: bg && "linear-gradient(to top, ".concat(bg, " 0%, rgba(255, 255, 255, 0) 100%)")
                        }
                    })
                ]
            }),
            realHeight !== "auto" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (SmartText_module_default()).link,
                onClick: function() {
                    return setOpened(!opened);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: opened ? (SmartText_module_default()).opened : undefined,
                    "data-nosnippet": true,
                    children: opened ? "Read less" : "Read more"
                })
            })
        ]
    });
};
/* harmony default export */ var components_SmartText = (SmartText);


/***/ }),

/***/ 99652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsAlertLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function NewsAlertLogo(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        width: "146",
        height: "32",
        viewBox: "0 0 146 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7 7.5H5.5V9V22.4815V26V28.73L7.80434 27.2661L12.9746 23.9815H25H26.5V22.4815V9V7.5H25H7Z",
                stroke: "var(--color-blue)",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M51.3 9V17.5L44.34 9H41.66V23H44.86V14.5L51.84 23H54.5V9H51.3ZM68.1323 17.66C68.1323 14.2 65.6923 12.08 62.5323 12.08C59.2523 12.08 56.7923 14.4 56.7923 17.62C56.7923 20.82 59.2123 23.16 62.9323 23.16C64.8723 23.16 66.3723 22.56 67.3723 21.42L65.7123 19.62C64.9723 20.32 64.1523 20.66 63.0123 20.66C61.3723 20.66 60.2323 19.84 59.9323 18.5H68.0723C68.0923 18.24 68.1323 17.9 68.1323 17.66ZM62.5523 14.44C63.9523 14.44 64.9723 15.32 65.1923 16.68H59.8923C60.1123 15.3 61.1323 14.44 62.5523 14.44ZM84.5342 12.24L81.9142 19.52L79.3542 12.24H76.7142L74.0742 19.52L71.5342 12.24H68.5942L72.4742 23H75.4742L77.9742 16.32L80.3942 23H83.3942L87.2942 12.24H84.5342ZM92.2084 23.16C95.4284 23.16 97.2884 21.74 97.2884 19.74C97.2884 15.5 90.7884 17.28 90.7884 15.44C90.7884 14.88 91.3884 14.44 92.7884 14.44C93.7684 14.44 94.8284 14.64 95.8884 15.24L96.9284 13.02C95.9084 12.42 94.2684 12.08 92.7884 12.08C89.6484 12.08 87.8084 13.52 87.8084 15.56C87.8084 19.86 94.3084 18.06 94.3084 19.82C94.3084 20.42 93.7684 20.8 92.3284 20.8C91.0084 20.8 89.5484 20.38 88.5884 19.76L87.5484 22C88.5484 22.66 90.3884 23.16 92.2084 23.16ZM110.513 23H112.073L105.673 9H104.213L97.8134 23H99.3534L101.033 19.26H108.833L110.513 23ZM101.573 18.06L104.933 10.54L108.293 18.06H101.573ZM114.089 23H115.509V8.16H114.089V23ZM128.64 17.74C128.64 14.58 126.5 12.4 123.54 12.4C120.58 12.4 118.4 14.62 118.4 17.74C118.4 20.86 120.64 23.1 123.92 23.1C125.58 23.1 127.04 22.5 127.98 21.38L127.18 20.46C126.38 21.38 125.24 21.84 123.96 21.84C121.66 21.84 119.98 20.38 119.82 18.18H128.62C128.62 18.02 128.64 17.86 128.64 17.74ZM123.54 13.62C125.6 13.62 127.1 15.06 127.28 17.12H119.82C120 15.06 121.5 13.62 123.54 13.62ZM132.891 14.54V12.48H131.531V23H132.951V17.64C132.951 15.16 134.291 13.76 136.491 13.76C136.591 13.76 136.711 13.78 136.831 13.78V12.4C134.891 12.4 133.551 13.14 132.891 14.54ZM144.891 21.34C144.491 21.7 143.911 21.88 143.331 21.88C142.151 21.88 141.511 21.2 141.511 19.96V13.68H144.711V12.48H141.511V10.18H140.091V12.48H138.211V13.68H140.091V20.04C140.091 21.98 141.191 23.1 143.171 23.1C143.991 23.1 144.831 22.86 145.391 22.36L144.891 21.34Z",
                fill: "#232735"
            })
        ]
    }));
}


/***/ }),

/***/ 36027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ formatResponseReset; }
/* harmony export */ });
var formatDate = function(date) {
    var formattedDate = new Date(date);
    var hours = formattedDate.getHours();
    var minutes = formattedDate.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var timePart = hours + ":" + minutes + " " + ampm;
    return "".concat(formattedDate.getDate(), "/").concat(formattedDate.getMonth() + 1, "/").concat(formattedDate.getFullYear(), ", ").concat(timePart);
};
// The response allowance resets on a rolling 30-day boundary, not on the 1st of
// the month, so copy names the actual reset date rather than a calendar month.
var formatResponseReset = function(responsePeriodEnd) {
    if (!responsePeriodEnd) return null;
    var reset = new Date(responsePeriodEnd);
    if (Number.isNaN(reset.getTime())) return null;
    return reset.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (formatDate);


/***/ }),

/***/ 58096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ getDateDifference; }
/* harmony export */ });
var neededFormat = {
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1
};
var getDateDifference = function(laterDate) {
    var result = {};
    var difference = Math.abs(new Date(laterDate) - new Date()) / 1000;
    Object.keys(neededFormat).forEach(function(key) {
        result[key] = Math.floor(difference / neededFormat[key]);
        difference -= result[key] * neededFormat[key];
    });
    return result;
};


/***/ }),

/***/ 50030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./next-seo.config.js
var next_seo_config = __webpack_require__(5056);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(97762);
// EXTERNAL MODULE: ./api/index.js + 49 modules
var api = __webpack_require__(46979);
// EXTERNAL MODULE: ./data/globalConstants.js
var globalConstants = __webpack_require__(23208);
// EXTERNAL MODULE: ./store/auth.js
var auth = __webpack_require__(32505);
// EXTERNAL MODULE: ./store/company/index.js
var store_company = __webpack_require__(3383);
// EXTERNAL MODULE: ./store/company/expert.js
var expert = __webpack_require__(17390);
// EXTERNAL MODULE: ./store/alert.js
var store_alert = __webpack_require__(74703);
// EXTERNAL MODULE: ./store/ux.js
var ux = __webpack_require__(30807);
// EXTERNAL MODULE: ./utils/pluralize.js
var pluralize = __webpack_require__(68545);
// EXTERNAL MODULE: ./utils/text-truncate.js
var text_truncate = __webpack_require__(59965);
// EXTERNAL MODULE: ./utils/tag-remove.js
var tag_remove = __webpack_require__(92131);
// EXTERNAL MODULE: ./utils/seo-title.js
var seo_title = __webpack_require__(61055);
;// CONCATENATED MODULE: ./utils/story-sponsor.js
// The one labelled ad on a living story (Asana 1219383957503739).

var time = function(value) {
    return value ? new Date(value).getTime() : NaN;
};
var liveSponsor = function(story) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var ref = story || {}, sponsorName = ref.sponsorName, sponsorImageUrl = ref.sponsorImageUrl, sponsorUrl = ref.sponsorUrl;
    if (!sponsorName || !sponsorImageUrl || !sponsorUrl) {
        return null;
    }
    if (time(story.sponsorStartsAt) > now || time(story.sponsorEndsAt) <= now) {
        return null;
    }
    return {
        name: sponsorName,
        imageUrl: sponsorImageUrl,
        url: sponsorUrl
    };
};
// The page is ISR: rebuild it when the slot goes up or comes down, not a day later.
var sponsorRevalidate = function(story, revalidate) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var _Math;
    var next = [
        time(story === null || story === void 0 ? void 0 : story.sponsorStartsAt),
        time(story === null || story === void 0 ? void 0 : story.sponsorEndsAt)
    ].filter(function(at) {
        return at > now;
    }).map(function(at) {
        return Math.ceil((at - now) / 1000);
    });
    return Math.max(60, (_Math = Math).min.apply(_Math, [
        revalidate
    ].concat(_to_consumable_array(next))));
};

// EXTERNAL MODULE: ./utils/safe-html.js
var safe_html = __webpack_require__(95460);
// EXTERNAL MODULE: ./utils/alert-url.js
var alert_url = __webpack_require__(72247);
// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
// EXTERNAL MODULE: ./api/alert-slug.js
var alert_slug = __webpack_require__(7253);
// EXTERNAL MODULE: ./api/research-sponsorship.js
var research_sponsorship = __webpack_require__(25340);
// EXTERNAL MODULE: ./utils/research-sponsor.js
var research_sponsor = __webpack_require__(25374);
// EXTERNAL MODULE: ./components/Typo.js
var Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./layouts/SidebarLayout.js + 2 modules
var SidebarLayout = __webpack_require__(22028);
// EXTERNAL MODULE: ./components/Sidescreen.js + 32 modules
var Sidescreen = __webpack_require__(6266);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./styles/modules/PostAlert.module.scss
var PostAlert_module = __webpack_require__(20886);
var PostAlert_module_default = /*#__PURE__*/__webpack_require__.n(PostAlert_module);
// EXTERNAL MODULE: ./components/Input.js + 1 modules
var Input = __webpack_require__(21105);
// EXTERNAL MODULE: ./styles/modules/Post.module.scss
var Post_module = __webpack_require__(87382);
var Post_module_default = /*#__PURE__*/__webpack_require__.n(Post_module);
;// CONCATENATED MODULE: ./components/Post.js



var Post = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: (Post_module_default()).post,
        children: children
    });
};
/* harmony default export */ var components_Post = (Post);

;// CONCATENATED MODULE: ./components/PostHead.js



var PostHead = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            "mb-xl",
            (Post_module_default()).postHead
        ].join(" "),
        children: children
    });
};
/* harmony default export */ var components_PostHead = (PostHead);

;// CONCATENATED MODULE: ./components/PostBody.js



var PostBody = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Post_module_default()).postBody,
        children: children
    });
};
/* harmony default export */ var components_PostBody = (PostBody);

// EXTERNAL MODULE: ./components/SocialShare.js
var SocialShare = __webpack_require__(84443);
// EXTERNAL MODULE: ./components/Alert/SlugField.js
var SlugField = __webpack_require__(60717);
// EXTERNAL MODULE: ./components/Alert/TemplateFields.js
var TemplateFields = __webpack_require__(14530);
// EXTERNAL MODULE: ./utils/source-page.js
var source_page = __webpack_require__(93373);
// EXTERNAL MODULE: ./components/Alert/SourcePageFields.js
var SourcePageFields = __webpack_require__(8342);
// EXTERNAL MODULE: ./components/Alert/ResearchSponsorFields.js
var ResearchSponsorFields = __webpack_require__(63302);
// EXTERNAL MODULE: ./styles/modules/newsAlert/SourcePage.module.scss
var SourcePage_module = __webpack_require__(283);
var SourcePage_module_default = /*#__PURE__*/__webpack_require__.n(SourcePage_module);
// EXTERNAL MODULE: ./styles/modules/newsAlert/Newsroom.module.scss
var Newsroom_module = __webpack_require__(51495);
var Newsroom_module_default = /*#__PURE__*/__webpack_require__.n(Newsroom_module);
;// CONCATENATED MODULE: ./components/PostAlert.js

























var Editor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9612).then(__webpack_require__.bind(__webpack_require__, 29612));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29612)
            ];
        }
    },
    ssr: false
});
var PostAlert = function(param) {
    var title = param.title, body = param.body, edit = param.edit, // Remounts the editors when the form is refilled; they read their value only on mount.
    editorKey = param.editorKey, setData = param.setData, deadline = param.deadline, author = param.author, _titleVariant = param.// h2 when a published story above the alert holds the page's h1.
    titleVariant, titleVariant = _titleVariant === void 0 ? "h1" : _titleVariant, _isAdmin = param.// Admins only: the alert's address, editable alongside the title.
    isAdmin, isAdmin = _isAdmin === void 0 ? false : _isAdmin, slug = param.slug, currentSlug = param.currentSlug, alertId = param.alertId, source = param.source, setSource = param.setSource, // { intro, questions } on alerts written with the template; null on older ones.
    template = param.template, storedIntro = param.storedIntro, // A sold research sponsorship's credit, which the box promises at the top of the alert.
    sponsorCredit = param.sponsorCredit, // The sponsorship price, which the spec wants directly under the headline.
    sponsorStrip = param.sponsorStrip, // Admins only: the story sponsorship draft, null until its saved offer has loaded.
    research = param.research, researchRow = param.researchRow, setResearch = param.setResearch, onResearchRowChange = param.onResearchRowChange, researchError = param.researchError;
    // Read after mount: the server has no location, so rendering it earlier breaks hydration.
    var ref = (0,react.useState)(""), shareUrl = ref[0], setShareUrl = ref[1];
    (0,react.useEffect)(function() {
        return setShareUrl(location.href);
    }, [
        currentSlug
    ]);
    var titleElem;
    var postBody;
    var isFTEditorByRole = function(author) {
        if (!(author === null || author === void 0 ? void 0 : author.roles) || !Array.isArray(author.roles)) return false;
        return author.roles.some(function(role) {
            return role.name === "FT_EDITOR";
        });
    };
    // FT Adviser branding names the publication an anonymised journalist writes for.
    var isCreatedByFTEditor = !(author === null || author === void 0 ? void 0 : author.isAnonymised) && ((author === null || author === void 0 ? void 0 : author.isFTEditor) || isFTEditorByRole(author));
    var ref1 = (0,es/* useSelector */.v9)(auth/* authSelector */.aF), isAuthenticated = ref1.isAuthenticated, company = ref1.company;
    var authorView = author !== false && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            "mb-l",
            (PostAlert_module_default()).title
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: ".",
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typo/* default */.Z, {
                variant: "p",
                className: [
                    "mb-s",
                    (PostAlert_module_default()).author
                ].join(" "),
                children: [
                    !author.isAnonymised && "Journalist: ",
                    author.name,
                    author.publication ? ", " + author.publication : null,
                    author.isAnonymised && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (PostAlert_module_default()).anonymisedInfo,
                        tabIndex: 0,
                        "aria-label": "Why is the journalist hidden?",
                        "data-nosnippet": true,
                        children: [
                            "i",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (PostAlert_module_default()).anonymisedPopover,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "The journalist's name and outlet are shown to Plus and Pro members.",
                                        " ",
                                        isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(company, "/subscription"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "Upgrade"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/login",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "Log in"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
    // A journalist's source page is on their outlet's own site.
    var sourceHref = !edit && !(author === null || author === void 0 ? void 0 : author.isAnonymised) && (0,source_page/* sourcePageHref */.w7)(source === null || source === void 0 ? void 0 : source.sourceUrl, currentSlug);
    // Rendered as JSX: safeHtml would rewrite the rel of a link inside the body.
    var sourceLine = sourceHref && source.sourceBy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (SourcePage_module_default()).source,
        children: [
            "Based on analysis by ",
            source.sourceBy,
            ":",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: sourceHref,
                target: "_blank",
                rel: (0,source_page/* sourcePageRel */.WK)(source.isSponsored),
                children: (0,source_page/* sourcePageText */.Mg)(source.sourceLabel, source.sourceUrl)
            })
        ]
    });
    if (edit) {
        titleElem = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    value: title,
                    onChange: function(e) {
                        return setData.setTitle(e.target.value);
                    },
                    classes: (PostAlert_module_default()).input
                }),
                isAdmin && setData.setSlug && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlugField/* default */.Z, {
                    value: slug,
                    onChange: setData.setSlug,
                    onStatus: setData.setSlugStatus,
                    alertId: alertId,
                    currentSlug: currentSlug
                })
            ]
        });
        postBody = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                template ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateFields/* default */.Z, {
                    intro: template.intro,
                    questions: template.questions,
                    onChange: setData.setTemplate,
                    storedIntro: storedIntro
                }, editorKey) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                    data: body,
                    setData: setData.setBody,
                    height: "400px",
                    config: TemplateFields/* ALERT_EDITOR_CONFIG */.K
                }, editorKey),
                setSource && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-l",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourcePageFields/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, source), {
                        canSponsor: isAdmin,
                        onChange: function(field, value) {
                            return setSource((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, source), (0,_define_property/* default */.Z)({}, field, value)));
                        }
                    }))
                }),
                isAdmin && researchError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (Newsroom_module_default()).error,
                    role: "alert",
                    children: researchError
                }),
                isAdmin && research && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchSponsorFields/* default */.Z, {
                    alertId: alertId,
                    draft: research,
                    row: researchRow,
                    onChange: function(field, value) {
                        return setResearch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, research), (0,_define_property/* default */.Z)({}, field, value)));
                    },
                    onRowChange: onResearchRowChange
                })
            ]
        });
    } else {
        titleElem = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                    variant: titleVariant,
                    className: [
                        author === false ? "mb-s" : "",
                        (PostAlert_module_default()).title, 
                    ].join(" "),
                    children: title
                }),
                authorView
            ]
        });
        postBody = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: (0,safe_html/* default */.ZP)(body)
            }
        });
    }
    var social = !edit && shareUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PostAlert_module_default()).socialIcons,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Share"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                platform: "facebook",
                url: shareUrl,
                fill: "var(--color-blue)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                platform: "twitter",
                url: shareUrl,
                fill: "var(--color-blue)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                platform: "linkedin",
                url: shareUrl,
                fill: "var(--color-blue)"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Post, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PostHead, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    children: [
                        isCreatedByFTEditor && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PostAlert_module_default()).ftBannerContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/img/news-story/FT-banner.webp",
                                alt: "FT Editor Banner",
                                width: 800,
                                height: 300,
                                className: (PostAlert_module_default()).ftBanner
                            })
                        }),
                        titleElem,
                        !edit && sponsorStrip,
                        sourceLine,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (PostAlert_module_default()).metaWrapper,
                            children: [
                                deadline,
                                social
                            ]
                        }),
                        !edit && sponsorCredit
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PostBody, {
                children: postBody
            })
        ]
    });
};
/* harmony default export */ var components_PostAlert = (PostAlert);

// EXTERNAL MODULE: ./styles/modules/newsAlert/Detail.module.scss
var Detail_module = __webpack_require__(2642);
var Detail_module_default = /*#__PURE__*/__webpack_require__.n(Detail_module);
// EXTERNAL MODULE: ./components/DateProgress.js + 1 modules
var DateProgress = __webpack_require__(16302);
// EXTERNAL MODULE: ./helpers/getDateDifference.js
var getDateDifference = __webpack_require__(58096);
;// CONCATENATED MODULE: ./components/Alert/Countdown.js






var CountDown = function(param) {
    var close = param.close, status = param.status, deadline = param.deadline, createdAt = param.createdAt, isFTEditor = param.isFTEditor;
    var ref = (0,react.useState)((0,getDateDifference/* getDateDifference */.h)(deadline)), timeLeft = ref[0], setTimeLeft = ref[1];
    // close alert automatically
    (0,react.useEffect)(function() {
        if (timeLeft.day === 0 && timeLeft.hour === 0 && timeLeft.minute === 0 && timeLeft.second === 0) {
            close();
        }
    }, [
        timeLeft
    ]);
    var interval;
    (0,react.useEffect)(function() {
        clearInterval(interval);
        if (!deadline || status !== "active") {
            return;
        }
        interval = setInterval(function() {
            setTimeLeft((0,getDateDifference/* getDateDifference */.h)(deadline));
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        deadline,
        status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            (Detail_module_default()).timer,
            status === "active" ? (Detail_module_default()).timerActive : "", 
        ].join(" "),
        children: status === "active" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateProgress/* default */.Z, {
                    deadline: deadline,
                    createdAt: createdAt,
                    height: 7,
                    isFTEditor: isFTEditor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Detail_module_default()).dateWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                children: [
                                    (timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.day) !== 0 ? (timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.day) + "D" : "",
                                    " ",
                                    (timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.hour) !== 0 ? (timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.hour) + "H" : "",
                                    " ",
                                    (timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.minute) !== 0 ? (timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.minute) + "M" : "",
                                    " ",
                                    (timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.day) === 0 ? (timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.second) + "S" : "",
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "until end"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "ended",
                    " ",
                    moment_default()(new Date(deadline)).format("DD. MMMM YYYY")
                ]
            })
        })
    });
};
/* harmony default export */ var Countdown = (CountDown);

// EXTERNAL MODULE: ./components/Alert/TimePicker.js + 1 modules
var TimePicker = __webpack_require__(29386);
// EXTERNAL MODULE: ./components/Alert/DatePicker.js + 1 modules
var DatePicker = __webpack_require__(81252);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./components/Alert/Deadline.js





var ACTIVE_SET = 0;
var setTags = [
    {
        label: "24h",
        days: 1
    },
    {
        label: "48h",
        days: 2
    },
    {
        label: "week",
        days: 7
    },
    {
        label: "two weeks",
        days: 14
    },
    {
        label: "month",
        days: 30
    }, 
];
var START_DATE = new Date();
START_DATE.setDate(START_DATE.getDate() + setTags[ACTIVE_SET].days);
var Deadline = function(param) {
    var initialDate = param.initialDate, setDeadline = param.setDeadline, setTimeValid = param.setTimeValid, setDateValid = param.setDateValid;
    var ref = (0,react.useState)(new Date(initialDate) || new Date()), time = ref[0], setTime = ref[1];
    var ref1 = (0,react.useState)(new Date(initialDate) || START_DATE), date = ref1[0], setDate = ref1[1];
    (0,react.useEffect)(function() {
        if (!moment_timezone_default()(date).isValid() || !moment_timezone_default()(time).isValid()) {
            return;
        }
        setDeadline("".concat(moment_timezone_default()(date).format("MM/DD/YYYY"), " ").concat(moment_timezone_default()(time).format("HH:mm:ss")));
    }, [
        time,
        date
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimePicker/* default */.Z, {
                time: time,
                setTime: setTime,
                setTimeValid: setTimeValid
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* default */.Z, {
                date: date,
                setDate: setDate,
                setDateValid: setDateValid
            })
        ]
    });
};
/* harmony default export */ var Alert_Deadline = (Deadline);

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(98885);
// EXTERNAL MODULE: ./styles/modules/newsAlert/Response.module.scss
var Response_module = __webpack_require__(1932);
var Response_module_default = /*#__PURE__*/__webpack_require__.n(Response_module);
// EXTERNAL MODULE: ./components/SmartText.js + 1 modules
var SmartText = __webpack_require__(9999);
// EXTERNAL MODULE: ./components/Sidescreen/LimitedTextArea.js
var LimitedTextArea = __webpack_require__(97919);
// EXTERNAL MODULE: ./components/Button.js + 2 modules
var Button = __webpack_require__(44217);
// EXTERNAL MODULE: ./components/ProfileTag.js
var ProfileTag = __webpack_require__(34576);
// EXTERNAL MODULE: ./components/OptionSelect.js
var OptionSelect = __webpack_require__(35270);
;// CONCATENATED MODULE: ./components/Svg/Pin.js

function Pin(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "27",
        height: "28",
        viewBox: "0 0 27 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M23 10L27 19H16V25L11 28V19H0L4 10V1.66893e-06L23 0V10Z",
            fill: fill
        })
    });
}

// EXTERNAL MODULE: ./components/Svg/Tick.js
var Tick = __webpack_require__(98948);
// EXTERNAL MODULE: ./components/LoginInfo.js
var LoginInfo = __webpack_require__(45702);
// EXTERNAL MODULE: ./helpers/date.js
var date = __webpack_require__(36027);
// EXTERNAL MODULE: ./helpers/strings.js
var strings = __webpack_require__(66998);
;// CONCATENATED MODULE: ./utils/response-upgrade-copy.js

// Plus is capped at PREMIUM_TIER_RESPONSE_LIMIT and free at
// FREE_TIER_RESPONSE_LIMIT in newspage-backend plans.constants.ts; the "10 a
// month" and "1 FREE" claims below track those two constants.
var PLUS_OR_PRO = "Upgrade to Newspage Plus for 10 responses a month or Newspage Pro for unlimited responses";
var PRO_ONLY = "Upgrade to Newspage Pro for unlimited responses";
var getResponseUpgradeCopy = function(param) {
    var planType = param.planType, totalResponses = param.totalResponses, hasUnlimitedResponses = param.hasUnlimitedResponses;
    if (hasUnlimitedResponses) return null;
    if (planType !== "free" && planType !== "premium") return null;
    if (totalResponses <= 0) {
        return {
            variant: planType === "free" ? "free-wall" : "limit-other"
        };
    }
    if (planType === "premium") {
        return {
            variant: "premium",
            lead: "You currently have ".concat(totalResponses, " ").concat((0,pluralize/* default */.Z)(totalResponses, "response"), " left this month."),
            cta: PRO_ONLY
        };
    }
    // Only the untouched free allowance is "your 1 FREE response" — a free
    // member holding purchased credits has more than the plan grants.
    if (totalResponses === 1) {
        return {
            variant: "free-last",
            lead: "This will be your 1 FREE News Alert response this month.",
            cta: PLUS_OR_PRO
        };
    }
    return {
        variant: "free-credits",
        lead: "You currently have ".concat(totalResponses, " News Alert ").concat((0,pluralize/* default */.Z)(totalResponses, "response"), " left."),
        cta: PLUS_OR_PRO
    };
};
/* harmony default export */ var response_upgrade_copy = (getResponseUpgradeCopy);

;// CONCATENATED MODULE: ./utils/free-coverage.js
// newspage-backend answers a free member's News Alert response with this code once the
// profile has a counted piece of coverage (profiles/free-coverage.ts).
var FREE_COVERAGE_REACHED = "FREE_COVERAGE_REACHED";
var freeCoverageMessage = function(param) {
    var count = param.count, latestCoverage = param.latestCoverage;
    var lead = count === 1 && (latestCoverage === null || latestCoverage === void 0 ? void 0 : latestCoverage.publisher) ? "You've been quoted in ".concat(latestCoverage.publisher, " through Newspage.") : "You've had ".concat(count, " pieces of coverage through Newspage.");
    return "".concat(lead, " Free accounts can respond until their first piece, so to send this response you'll need Plus or Pro.");
};
// The block comes either ahead of time on the company's plan or from the rejected submit.
var getFreeCoverage = function(plan, error) {
    var ref;
    var _details;
    if ((error === null || error === void 0 ? void 0 : error.code) === FREE_COVERAGE_REACHED) return (_details = error.details) !== null && _details !== void 0 ? _details : null;
    if ((plan === null || plan === void 0 ? void 0 : plan.type) === "free" && ((ref = plan.freeCoverage) === null || ref === void 0 ? void 0 : ref.count) > 0) {
        return plan.freeCoverage;
    }
    return null;
};

;// CONCATENATED MODULE: ./components/Alert/AddResponse.js



















var RESPONSE_MAX_CHARACTERS = 1000;
var VIDEO_MAX_SIZE_MB = 100;
var VIDEO_MAX_DURATION_SEC = 30;
var ALLOWED_VIDEO_TYPES = [
    "video/mp4",
    "video/quicktime",
    "video/webm", 
];
var formatFileSize = function(bytes) {
    if (bytes === 0) return "0 Bytes";
    var k = 1024;
    var sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB"
    ];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
var formatDuration = function(seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = Math.floor(seconds % 60);
    return "".concat(minutes, ":").concat(remainingSeconds.toString().padStart(2, "0"));
};
var isFTEditorByRole = function(author) {
    if (!(author === null || author === void 0 ? void 0 : author.roles) || !Array.isArray(author.roles)) return false;
    return author.roles.some(function(role) {
        return role.name === "FT_EDITOR";
    });
};
var AddResponse = function(param) {
    var alertId = param.alertId, alertData = param.alertData;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,es/* useSelector */.v9)(store_alert/* alertSelector */.wV), error = ref7.error, loading = ref7.loading, alert = ref7.alert;
    var ref8 = (0,es/* useSelector */.v9)(function(param) {
        var company = param.company;
        return company;
    }), companyState = ref8.data;
    var ref9 = (0,es/* useSelector */.v9)(auth/* authSelector */.aF), responseCredit = ref9.responseCredit, isContributingEditor = ref9.isContributingEditor, ownSlug = ref9.company;
    var videoInputRef = (0,react.useRef)(null);
    var ref10 = (0,react.useState)(false), isDragging = ref10[0], setIsDragging = ref10[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref11 = (0,react.useState)(""), responseBody = ref11[0], setResponseBody = ref11[1];
    var ref12 = (0,react.useState)({}), company = ref12[0], setCompany = ref12[1];
    var ref13 = (0,react.useState)(null), videoFile = ref13[0], setVideoFile = ref13[1];
    var ref14 = (0,react.useState)(""), videoPreviewUrl = ref14[0], setVideoPreviewUrl = ref14[1];
    var ref15 = (0,react.useState)(""), videoError = ref15[0], setVideoError = ref15[1];
    var router = (0,next_router.useRouter)();
    var upgradeToPremiumLink = "/".concat(company.slug, "/subscription");
    (0,react.useEffect)(function() {
        setCompany(companyState);
    }, [
        companyState
    ]);
    // Determine if this is an FT Editor alert. An anonymised one hides FT from the author, so the
    // API says it with responseLimitExempt.
    var isFTEditorAlert = (alertData === null || alertData === void 0 ? void 0 : alertData.responseLimitExempt) || (alert === null || alert === void 0 ? void 0 : alert.responseLimitExempt) || (alertData === null || alertData === void 0 ? void 0 : (ref = alertData.author) === null || ref === void 0 ? void 0 : ref.isFTEditor) || (alert === null || alert === void 0 ? void 0 : (ref1 = alert.author) === null || ref1 === void 0 ? void 0 : ref1.isFTEditor) || isFTEditorByRole(alertData === null || alertData === void 0 ? void 0 : alertData.author) || isFTEditorByRole(alert === null || alert === void 0 ? void 0 : alert.author);
    // Calculate response limits once
    var totalResponses = (((ref2 = company.plan) === null || ref2 === void 0 ? void 0 : ref2.responsesLeft) || 0) + (responseCredit || 0);
    var ref16;
    // The alert's own profile answers as its story's source, outside the monthly allowance.
    var isOwnAlert = company.slug === ownSlug && Boolean(company.id) && ((ref16 = alertData === null || alertData === void 0 ? void 0 : alertData.profileId) !== null && ref16 !== void 0 ? ref16 : alert === null || alert === void 0 ? void 0 : alert.profileId) === company.id;
    // Free has no monthly allowance any more: unlimited until the first coverage, then blocked.
    var hasUnlimitedResponses = ((ref3 = company.plan) === null || ref3 === void 0 ? void 0 : ref3.type) === "free" || ((ref4 = company.plan) === null || ref4 === void 0 ? void 0 : ref4.type) === "platinum" || isContributingEditor || isFTEditorAlert || isOwnAlert;
    var isResponseLimitReached = !hasUnlimitedResponses && totalResponses <= 0;
    var shouldShowUpgradeMessages = !hasUnlimitedResponses;
    var upgradeCopy = response_upgrade_copy({
        planType: (ref5 = company.plan) === null || ref5 === void 0 ? void 0 : ref5.type,
        totalResponses: totalResponses,
        hasUnlimitedResponses: hasUnlimitedResponses
    });
    // Only shown once the allowance is spent — while responses remain they may be
    // purchased credits, which do not reset with the plan period.
    var responseResetDate = (0,date/* formatResponseReset */.s)((ref6 = company.plan) === null || ref6 === void 0 ? void 0 : ref6.responsePeriodEnd);
    var handleDragEnter = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!loading) setIsDragging(true);
    };
    var handleDragLeave = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };
    var handleDragOver = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!loading) setIsDragging(true);
    };
    var validateVideoDuration = function(file) {
        return new Promise(function(resolve) {
            var video = document.createElement("video");
            video.preload = "metadata";
            video.onloadedmetadata = function() {
                window.URL.revokeObjectURL(video.src);
                if (video.duration > VIDEO_MAX_DURATION_SEC) {
                    var duration = formatDuration(video.duration);
                    var maxDuration = formatDuration(VIDEO_MAX_DURATION_SEC);
                    setVideoError("Video duration (".concat(duration, ") exceeds the maximum allowed duration of ").concat(maxDuration, ". Please select a shorter video."));
                    resolve(false);
                }
                resolve(true);
            };
            video.onerror = function() {
                setVideoError("Error validating video duration. Please try another video.");
                resolve(false);
            };
            video.src = URL.createObjectURL(file);
        });
    };
    var validateVideoSize = function(file) {
        var maxSize = VIDEO_MAX_SIZE_MB * 1024 * 1024;
        if (file.size > maxSize) {
            var fileSize = formatFileSize(file.size);
            var maxSizeFormatted = formatFileSize(maxSize);
            setVideoError("Video size (".concat(fileSize, ") exceeds the maximum allowed size of ").concat(maxSizeFormatted, ". Please select a smaller video."));
            return false;
        }
        return true;
    };
    var handleDrop = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        e.stopPropagation();
                        setIsDragging(false);
                        if (loading) return [
                            2
                        ];
                        file = e.dataTransfer.files[0];
                        if (!file) return [
                            3,
                            2
                        ];
                        if (!validateVideoSize(file)) return [
                            2
                        ];
                        return [
                            4,
                            validateVideoDuration(file)
                        ];
                    case 1:
                        if (!_state.sent()) return [
                            2
                        ];
                        validateAndSetVideo(file);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDrop(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var validateAndSetVideo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setVideoError("");
                        if (!ALLOWED_VIDEO_TYPES.includes(file.type)) {
                            setVideoError("Please upload MP4, MOV, or WebM files only");
                            return [
                                2
                            ];
                        }
                        if (!validateVideoSize(file)) return [
                            2
                        ];
                        return [
                            4,
                            validateVideoDuration(file)
                        ];
                    case 1:
                        if (!_state.sent()) return [
                            2
                        ];
                        setVideoFile(file);
                        setVideoPreviewUrl(URL.createObjectURL(file));
                        return [
                            2
                        ];
                }
            });
        });
        return function validateAndSetVideo(file) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleVideoChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var file;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        file = event.target.files[0];
                        if (!file) return [
                            3,
                            2
                        ];
                        if (!validateVideoSize(file)) return [
                            2
                        ];
                        return [
                            4,
                            validateVideoDuration(file)
                        ];
                    case 1:
                        if (!_state.sent()) return [
                            2
                        ];
                        validateAndSetVideo(file);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleVideoChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var removeVideo = function() {
        setVideoFile(null);
        setVideoPreviewUrl("");
        if (videoInputRef.current) {
            videoInputRef.current.value = "";
        }
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var formData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!hasUnlimitedResponses && totalResponses === 0) {
                    dispatch((0,ux/* handleShowPopup */.YF)());
                    dispatch((0,ux/* setPopupConfig */.iH)({
                        onConfirm: function() {
                            router.push(upgradeToPremiumLink);
                            dispatch((0,ux/* handleHidePopup */.Zi)());
                        },
                        onCancel: function() {
                            return dispatch((0,ux/* handleHidePopup */.Zi)());
                        },
                        title: responseResetDate ? "Look at you, you media machine! You've maxed out your News Alert responses — your next one arrives on ".concat(responseResetDate, ". Or go Plus or Platinum now and keep going.") : "Look at you, you media machine! Get you, you've maxed out your one News Alert response per 30 days. Now it's time to go Plus or Platinum. Let's do this.",
                        confirmTitle: "Upgrade now",
                        cancelTitle: "Cancel"
                    }));
                    return [
                        2
                    ];
                }
                formData = new FormData();
                formData.append("body", responseBody);
                if (videoFile) {
                    formData.append("video", videoFile, videoFile.name);
                }
                dispatch((0,store_alert/* addAlertResponse */.YK)({
                    id: alertId,
                    data: formData
                }));
                return [
                    2
                ];
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var freeCoverage = isFTEditorAlert ? null : getFreeCoverage(company.plan, error);
    // The company slice holds the last profile loaded (another expert's page, or the previous
    // member's after a logout) until this page's fetch of the member's own one resolves.
    var blockedAhead = !!freeCoverage && (error === null || error === void 0 ? void 0 : error.code) !== FREE_COVERAGE_REACHED && !!company.id && company.slug === ownSlug;
    // A refused response is what sends the upgrade email, and this screen stops the member before
    // they submit one, so it asks for the email itself; the API sends at most one a week.
    (0,react.useEffect)(function() {
        if (blockedAhead) {
            (0,api/* postReq */.qu)("profiles/".concat(company.id, "/free-coverage/notice")).catch(function() {});
        }
    }, [
        blockedAhead,
        company.id
    ]);
    if (freeCoverage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (Detail_module_default()).responseInfo,
                    children: freeCoverageMessage(freeCoverage)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: [
                        (Detail_module_default()).cta,
                        (Detail_module_default()).upgradeCta
                    ].join(" "),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: "Upgrade",
                        onClick: function() {
                            return router.push(upgradeToPremiumLink);
                        },
                        classes: [
                            (Detail_module_default()).button
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isResponseLimitReached && !isFTEditorAlert && shouldShowUpgradeMessages ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Detail_module_default()).responseInfo,
                children: (upgradeCopy === null || upgradeCopy === void 0 ? void 0 : upgradeCopy.variant) === "free-wall" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "You've used your 1 FREE News Alert response this month. If you'd like to respond, please",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: upgradeToPremiumLink,
                            children: "upgrade to Newspage Plus or Newspage Pro"
                        }),
                        ". The more alerts you respond to, the more visible you are in AI search, the more chances you have of media coverage, and the sooner your Newspage becomes a Page 1 trust asset for your name and company. All subs can be cancelled at any time."
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        responseResetDate ? "You have no responses left until ".concat(responseResetDate, ".") : "You currently have 0 responses left.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: upgradeToPremiumLink,
                            children: "Upgrade to Platinum"
                        }),
                        " ",
                        "for unlimited responses with professional editing."
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitedTextArea/* default */.Z, {
                        classes: [
                            (Detail_module_default()).responseBox
                        ],
                        placeholder: "Write your masterpiece here. And remember, no waffle.",
                        callback: function(value) {
                            return setResponseBody(value);
                        },
                        limit: RESPONSE_MAX_CHARACTERS,
                        disabled: loading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Detail_module_default()).videoUpload,
                        children: [
                            !videoPreviewUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((Detail_module_default()).uploadArea, " ").concat(isDragging ? (Detail_module_default()).dragging : "", " ").concat(loading ? (Detail_module_default()).disabled : ""),
                                onDragEnter: handleDragEnter,
                                onDragOver: handleDragOver,
                                onDragLeave: handleDragLeave,
                                onDrop: handleDrop,
                                onClick: function() {
                                    var ref;
                                    return !loading && ((ref = videoInputRef.current) === null || ref === void 0 ? void 0 : ref.click());
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "file",
                                        accept: "video/mp4,video/quicktime,video/webm",
                                        onChange: handleVideoChange,
                                        ref: videoInputRef,
                                        className: (Detail_module_default()).videoInput,
                                        disabled: loading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Detail_module_default()).uploadIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 16L12 8",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9 11L12 8L15 11",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M8 16H16",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Detail_module_default()).uploadText,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Drag and drop your video here or",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "browse"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                children: [
                                                    "MP4, MOV or WebM (max.",
                                                    " ",
                                                    VIDEO_MAX_SIZE_MB,
                                                    "MB,",
                                                    " ",
                                                    VIDEO_MAX_DURATION_SEC,
                                                    " seconds)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            videoError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Detail_module_default()).errorContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Detail_module_default()).error,
                                        children: videoError
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (Detail_module_default()).tryAgain,
                                        onClick: function() {
                                            var ref;
                                            setVideoError("");
                                            (ref = videoInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
                                        },
                                        children: "Try again"
                                    })
                                ]
                            }),
                            videoPreviewUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Detail_module_default()).videoPreview,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                        src: videoPreviewUrl,
                                        controls: true,
                                        className: (Detail_module_default()).previewVideo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: removeVideo,
                                        className: (Detail_module_default()).removeVideo,
                                        disabled: loading,
                                        children: "Remove video"
                                    })
                                ]
                            }),
                            loading && videoFile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Detail_module_default()).uploadingState,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Detail_module_default()).uploadStatus,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Detail_module_default()).uploadingSpinner
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Uploading video... "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Detail_module_default()).uploadWarning,
                                        children: "Please do not exit or refresh the page while uploading"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (upgradeCopy === null || upgradeCopy === void 0 ? void 0 : upgradeCopy.lead) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Detail_module_default()).responseInfo,
                children: [
                    upgradeCopy.lead,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: upgradeToPremiumLink,
                        children: upgradeCopy.cta
                    }),
                    "."
                ]
            }),
            (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Detail_module_default()).error,
                children: error.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Detail_module_default()).cta,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: loading ? "Uploading..." : en/* news_alerts.responses.post_response */.RA.p7.jU,
                    onClick: onSubmit,
                    classes: [
                        (Detail_module_default()).button
                    ],
                    disabled: (0,strings/* br2nl */.dl)(responseBody).length > RESPONSE_MAX_CHARACTERS || isResponseLimitReached || !!videoError || loading
                })
            })
        ]
    });
};
/* harmony default export */ var Alert_AddResponse = (AddResponse);

// EXTERNAL MODULE: ./components/Svg/Quote2.js
var Quote2 = __webpack_require__(26967);
// EXTERNAL MODULE: ./utils/utm.js
var utm = __webpack_require__(91825);
;// CONCATENATED MODULE: ./components/Alert/ResponseQuote.js



var ResponseQuote = function(param) {
    var _company = param.company, companyName = _company.name, expertName = _company.expertName, expertPosition = _company.expertPosition, companyWebsite = _company.website, city = _company.city, slug = _company.slug, deactivated = _company.deactivated, body = param.response.body, alertSlug = param.alertSlug, planType = param.planType;
    // Even a detached div loads <img> and fires its onerror, so the raw body
    // never reaches innerHTML.
    var tmp = document.createElement("div");
    tmp.innerHTML = (0,safe_html/* default */.ZP)(body);
    body = tmp.innerText.trim();
    tmp.remove();
    // Pro is stored as contributing_editor: plan.type holds Stripe price
    // nicknames, which the Plus/Pro display rename deliberately left alone.
    var tag = function(url) {
        return planType === "contributing_editor" ? (0,utm/* withUtm */.K)(url, alertSlug) : url;
    };
    if (companyWebsite) {
        companyWebsite = tag(companyWebsite.includes("http") ? companyWebsite : "https://".concat(companyWebsite));
    } else {
        companyWebsite = null;
    }
    var profileUrl = slug && !deactivated ? tag("".concat("https://app.newspage.media", "/").concat(slug)) : null;
    var r = /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                children: [
                    !profileUrl ? expertName : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: profileUrl,
                        children: expertName
                    }),
                    ", ",
                    expertPosition
                ]
            }),
            " ",
            "at",
            " ",
            !companyWebsite ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                children: [
                    city ? "".concat(city, "-based ") : "",
                    companyName
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: companyWebsite,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        city ? "".concat(city, "-based ") : "",
                        companyName
                    ]
                })
            }),
            " ",
            "commented:",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            '"'.concat(body, '"'),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
    return r;
};
/* harmony default export */ var Alert_ResponseQuote = (ResponseQuote);

;// CONCATENATED MODULE: ./utils/copyFormattedHTML.js
function copyFormatted(html) {
    var // Copy to clipboard
    // [4]
    ref, ref1;
    // Create container for the HTML
    // [1]
    var container = document.createElement("div");
    container.innerHTML = html;
    // Hide element
    // [2]
    container.style.position = "fixed";
    container.style.pointerEvents = "none";
    container.style.opacity = "0";
    // Detect all style sheets of the page
    var activeSheets = Array.prototype.slice.call(document.styleSheets).filter(function(sheet) {
        return !sheet.disabled;
    });
    // Mount the container to the DOM to make `contentWindow` available
    // [3]
    document.body.appendChild(container);
    (ref = window.getSelection()) === null || ref === void 0 ? void 0 : ref.removeAllRanges();
    var range = document.createRange();
    range.selectNode(container);
    (ref1 = window.getSelection()) === null || ref1 === void 0 ? void 0 : ref1.addRange(range);
    // [5.3]
    document.execCommand("copy");
    // Remove the container
    // [6]
    document.body.removeChild(container);
}

;// CONCATENATED MODULE: ./components/Svg/PlatinumBadge.js




var SvgPlatinumBadge = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 35,
        height: 45,
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#ababab",
                d: "M0 29.647V0h35v29.647L17.246 45 0 29.647Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#b)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M23.463 11.753a1.189 1.189 0 0 0-.806-.32H12.332c-.302 0-.587.118-.806.32l-4.163 3.961a1.17 1.17 0 0 0-.033 1.662l9.317 9.821c.218.235.537.37.856.37.319 0 .638-.135.856-.37l9.317-9.82c.454-.47.42-1.21-.033-1.663l-4.18-3.961Zm1.343 5.22-6.447 6.8c-.319.335-.873.1-.873-.353v-9.15c0-.285.218-.503.504-.503h3.979c.134 0 .252.05.352.134l2.468 2.35c.201.202.201.521.017.723Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "b",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M7 9h21v21H7z"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var PlatinumBadge = (SvgPlatinumBadge);

;// CONCATENATED MODULE: ./components/Svg/EmbedCode.js

var EmbedCode = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#fff" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11 7L5 15L11 23M19 7L25 15L19 23",
            stroke: fill,
            strokeWidth: "6",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Svg_EmbedCode = (EmbedCode);

;// CONCATENATED MODULE: ./components/Alert/Response.js






























// A deactivated responder's page answers 404: the card keeps the name, minus the link.
var NoLink = function(param) {
    var children = param.children;
    return children;
};
var transitionStyles = {
    entering: {
        opacity: 0,
        position: "absolute",
        transform: "translateX(30px)"
    },
    entered: {
        opacity: 1,
        transform: "translateX(0)"
    },
    exiting: {
        opacity: 0,
        transform: "translateX(0px)"
    },
    exited: {
        opacity: 0,
        transform: "translateX(30px)"
    }
};
var Response = function(param) {
    var alertId = param.alertId, alertSlug = param.alertSlug, _profile = param.profile, companyId = _profile.id, name = _profile.name, email = _profile.email, phone = _profile.phone, logo = _profile.logo, slug = _profile.slug, website = _profile.website, position = _profile.position, profileCompany = _profile.employer, addresses = _profile.addresses, deactivated = _profile.deactivated, id = param.id, body = param.body, video = param.video, responseIndex = param.index, expert = param.expert, status = param.status, isStorySource = param.isStorySource, _author = param.author, plan = _author.plan, isVerified = _author.isVerified;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), contacts = ref[0], setContacts = ref[1];
    var ref1 = (0,react.useState)([]), experts = ref1[0], setExperts = ref1[1];
    var ref2 = (0,react.useState)(null), profileAddresses = ref2[0], setProfileAddresses = ref2[1];
    var ref3 = (0,es/* useSelector */.v9)(auth/* authSelector */.aF), isAdmin = ref3.isAdmin, isJournalist = ref3.isJournalist, isFTEditor = ref3.isFTEditor, isAuthenticated = ref3.isAuthenticated, company = ref3.company;
    var ref4 = (0,react.useState)(body), html = ref4[0], setHtml = ref4[1];
    var ref5 = (0,react.useState)(body), sentHtml = ref5[0], setSentHtml = ref5[1];
    var ref6 = (0,react.useState)(false), edit = ref6[0], setEdit = ref6[1]; // TODO: false
    var ref7 = (0,react.useState)(false), copied = ref7[0], setCopied = ref7[1];
    var ref8 = (0,react.useState)(false), iframeCopied = ref8[0], setIframeCopied = ref8[1];
    var ref9 = (0,react.useState)(false), shareClicked = ref9[0], setShareClicked = ref9[1];
    var ref10 = (0,react.useState)((0,_object_spread/* default */.Z)({
        value: expert ? expert.name : en/* news_alerts.responses.sendWithoutExperts */.RA.p7.ur
    }, expert && (0,_object_spread/* default */.Z)({
        id: expert.id
    }, expert.image && {
        image: expert.image
    }, expert))), expertSelected = ref10[0], setExpertSelected = ref10[1];
    (0,react.useEffect)(function() {
        function fetchExperts() {
            return _fetchExperts.apply(this, arguments);
        }
        function _fetchExperts() {
            _fetchExperts = (0,_async_to_generator/* default */.Z)(function() {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,api/* getReq */.ZL)("/profiles/".concat(companyId, "/experts"))
                            ];
                        case 1:
                            res = _state.sent();
                            if (res.status === 200) {
                                setExperts(res.data);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchExperts.apply(this, arguments);
        }
        function fetchProfileData() {
            return _fetchProfileData.apply(this, arguments);
        }
        function _fetchProfileData() {
            _fetchProfileData = (0,_async_to_generator/* default */.Z)(function() {
                var res, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,api/* getReq */.ZL)("/profiles/".concat(companyId))
                            ];
                        case 1:
                            res = _state.sent();
                            if (res.status === 200) {
                                setProfileAddresses(res.data.data.addresses);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.error("Error fetching profile data:", error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchProfileData.apply(this, arguments);
        }
        if (isAdmin) {
            fetchExperts();
        }
        // Fetch profile data to get addresses
        if (companyId) {
            fetchProfileData();
        }
    }, [
        companyId
    ]);
    // The expert who raised the alert is its Story Source: labelled like a pin and listed
    // first by the API whether or not an editor pinned them, never also a Star Quote.
    var pinned = responseIndex !== null || isStorySource;
    var pinLabel = isStorySource ? "Story Source" : "Star Quote";
    var handleClick = function() {
        setContacts(!contacts);
    };
    (0,react.useEffect)(function() {
        setHtml(body);
        setSentHtml(body);
        setExpertSelected((0,_object_spread/* default */.Z)({
            value: expert ? expert.name : en/* news_alerts.responses.sendWithoutExperts */.RA.p7.ur
        }, expert && (0,_object_spread/* default */.Z)({
            id: expert.id
        }, expert.image && {
            image: expert.image
        }, expert)));
    }, [
        body,
        id
    ]);
    var updateResponse = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSentHtml(html);
                        return [
                            4,
                            dispatch((0,store_alert/* updateAlertResponse */.NY)({
                                alertId: alertId,
                                responseId: id,
                                body: html,
                                expert: expertSelected.id ? expertSelected.id : null
                            }))
                        ];
                    case 1:
                        _state.sent();
                        setEdit(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function updateResponse() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeResponse = function(id) {
        dispatch((0,ux/* handleShowPopup */.YF)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch((0,ux/* setPopupLoading */.BI)(true));
                            return [
                                4,
                                dispatch((0,store_alert/* removeAlertResponse */.uh)({
                                    alertId: alertId,
                                    responseId: id
                                }))
                            ];
                        case 1:
                            _state.sent();
                            dispatch((0,ux/* setPopupLoading */.BI)(false));
                            return [
                                2,
                                dispatch((0,ux/* handleHidePopup */.Zi)())
                            ];
                    }
                });
            }),
            onCancel: function() {
                return dispatch((0,ux/* handleHidePopup */.Zi)());
            },
            title: "Remove response?",
            confirmTitle: "Confirm",
            cancelTitle: "Cancel"
        }));
    };
    var pinToTop = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                dispatch((0,ux/* handleShowPopup */.YF)());
                dispatch((0,ux/* setPopupConfig */.iH)({
                    onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dispatch((0,ux/* setPopupLoading */.BI)(true));
                                    if (edit) {
                                        updateResponse();
                                    }
                                    return [
                                        4,
                                        dispatch((0,store_alert/* orderAlertResponse */.yx)({
                                            alertId: alertId,
                                            responseId: id,
                                            index: 0
                                        }))
                                    ];
                                case 1:
                                    _state.sent();
                                    setEdit(false);
                                    dispatch((0,ux/* setPopupLoading */.BI)(false));
                                    return [
                                        2,
                                        dispatch((0,ux/* handleHidePopup */.Zi)())
                                    ];
                            }
                        });
                    }),
                    onCancel: function() {
                        return dispatch((0,ux/* handleHidePopup */.Zi)());
                    },
                    title: "Pin to Top?",
                    confirmTitle: "Confirm",
                    cancelTitle: "Cancel"
                }));
                return [
                    2
                ];
            });
        });
        return function pinToTop() {
            return _ref.apply(this, arguments);
        };
    }();
    var unpin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                dispatch((0,ux/* handleShowPopup */.YF)());
                dispatch((0,ux/* setPopupConfig */.iH)({
                    onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dispatch((0,ux/* setPopupLoading */.BI)(true));
                                    return [
                                        4,
                                        dispatch((0,store_alert/* orderAlertResponse */.yx)({
                                            alertId: alertId,
                                            responseId: id,
                                            index: -1
                                        }))
                                    ];
                                case 1:
                                    _state.sent();
                                    setEdit(false);
                                    dispatch((0,ux/* setPopupLoading */.BI)(false));
                                    return [
                                        2,
                                        dispatch((0,ux/* handleHidePopup */.Zi)())
                                    ];
                            }
                        });
                    }),
                    onCancel: function() {
                        return dispatch((0,ux/* handleHidePopup */.Zi)());
                    },
                    title: "Unpin response?",
                    confirmTitle: "Confirm",
                    cancelTitle: "Cancel"
                }));
                return [
                    2
                ];
            });
        });
        return function unpin() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleEmbed = function() {
        var baseUrl = window.location.origin;
        var iframeCode = '<iframe \n    id="np-embed-'.concat(id, '"\n    src="').concat(baseUrl, "/embed/alerts/").concat(alertId, "/responses/").concat(id, '" \n    width="500px"\n    style="border: none; width: 100%; max-width: 500px; border-radius: 12px; overflow: hidden;"\n    scrolling="no"></iframe>\n<script>\n    window.addEventListener(\'message\', function(e) {\n        if (e.data.type === \'resize\') {\n            document.getElementById(\'np-embed-').concat(id, "').style.height = e.data.height + 'px';\n        }\n    });\n</script>");
        navigator.clipboard.writeText(iframeCode);
        setIframeCopied(true);
        setTimeout(function() {
            return setIframeCopied(false);
        }, 2000);
    };
    var handleShare = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var shareUrl, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        shareUrl = "".concat(window.location.origin, "/embed/alerts/").concat(alertId, "/responses/").concat(id);
                        return [
                            4,
                            navigator.clipboard.writeText(shareUrl)
                        ];
                    case 1:
                        _state.sent();
                        setShareClicked(true);
                        setTimeout(function() {
                            return setShareClicked(false);
                        }, 2000);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error("Copy to clipboard failed:", err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleShare() {
            return _ref.apply(this, arguments);
        };
    }();
    var image = expertSelected.id && expertSelected.image && expertSelected.image.path || logo && logo.path;
    var showFooter = edit && (experts === null || experts === void 0 ? void 0 : experts.length) > 0 || isAuthenticated && company === slug && status === "active" || isAdmin === true || isJournalist === true || isFTEditor === true;
    var showFooterButtons = isAdmin === true || isJournalist === true || isFTEditor === true || isAuthenticated && company === slug && status === "active";
    // The API lets only an admin or the responding profile edit a response.
    var canEdit = isAdmin === true || isAuthenticated && company === slug && status === "active";
    var ProfileLink = deactivated ? NoLink : (link_default());
    var handleQuote = function() {
        var result = '\n        <meta charset="utf-8">\n        '.concat(server_browser.renderToString(/*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_ResponseQuote, {
            company: {
                name: profileCompany || name,
                expertName: (expert === null || expert === void 0 ? void 0 : expert.name) || name,
                expertPosition: (expert === null || expert === void 0 ? void 0 : expert.position) || position,
                website: website,
                slug: slug,
                deactivated: deactivated,
                city: profileAddresses && profileAddresses.length > 0 ? profileAddresses[0].city : null
            },
            response: {
                body: body
            },
            alertSlug: alertSlug,
            planType: plan === null || plan === void 0 ? void 0 : plan.type
        })), "\n        ");
        copyFormatted(result);
        setCopied(true);
        setTimeout(function() {
            setCopied(false);
        }, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: [
            "border-accent",
            (Response_module_default()).wrapper,
            plan.type === "contributing_editor" ? (Response_module_default()).contributingEditorWrapper : "",
            //TODO later after we will have design
            //isFTEditor ? styles.ftEditorWrapper : '',
            plan.type === "legend" ? (Response_module_default()).legendWrapper : "",
            plan.type === "platinum" ? (Response_module_default()).platinumWrapper : "",
            pinned && plan.type === "contributing_editor" ? (Response_module_default()).pinnedContributingEditor : "",
            pinned && isFTEditor ? (Response_module_default()).pinnedFTEditor : "",
            pinned && plan.type === "legend" ? (Response_module_default()).pinnedLegend : "", 
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Response_module_default()).controls,
                children: [
                    pinned && (plan.type === "free" || plan.type === "premium") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Response_module_default()).pinFree,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: pinLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin, {
                                fill: "#fff"
                            })
                        ]
                    }),
                    pinned && plan.type === "contributing_editor" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Response_module_default()).pinContributingEditor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: pinLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin, {
                                fill: "#fff"
                            })
                        ]
                    }),
                    pinned && isFTEditor && //TODO later after we will have design
                    //<div className={styles.pinFTEditor}>
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Response_module_default()).pinContributingEditor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: pinLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin, {
                                fill: "#fff"
                            })
                        ]
                    }),
                    pinned && plan.type === "legend" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Response_module_default()).pinLegend2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: pinLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin, {
                                fill: "#fff"
                            })
                        ]
                    }),
                    pinned && plan.type === "platinum" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Response_module_default()).pinPlatinum,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: pinLabel
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin, {
                                fill: "#fff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: isAuthenticated ? handleQuote : null,
                        className: [
                            (Response_module_default()).copy,
                            (Response_module_default()).pin,
                            !isAuthenticated && "loginLocked", 
                        ].filter(Boolean).join(" "),
                        "data-hint": isAuthenticated ? undefined : en/* common.loginToCopy */.y0.loginToCopy,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: !copied ? "Copy" : "Copied to clipboard"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote2/* default */.Z, {
                                fill: "#fff"
                            })
                        ]
                    }),
                    video && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: handleEmbed,
                                className: [
                                    (Response_module_default()).copy,
                                    (Response_module_default()).pin
                                ].join(" "),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: !iframeCopied ? "Embed" : "Embed code copied!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_EmbedCode, {
                                        fill: "#fff"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: handleShare,
                                className: [
                                    (Response_module_default()).copy,
                                    (Response_module_default()).pin
                                ].join(" "),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: !shareClicked ? "Copy link" : "Link copied!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z",
                                                stroke: "#fff",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z",
                                                stroke: "#fff",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z",
                                                stroke: "#fff",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8.59 13.51L15.42 17.49",
                                                stroke: "#fff",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M15.41 6.51L8.59 10.49",
                                                stroke: "#fff",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    plan.type === "legend" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Response_module_default()).pinLegend,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "35",
                            height: "45",
                            fill: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "var(--color-blue)",
                                    d: "M0 29.647V0h35v29.647L17.246 45 0 29.647Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "m23.462 21.938-.288 1.251a.563.563 0 0 1-.549.436h-11.25a.563.563 0 0 1-.548-.436l-.289-1.252h12.924Z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    d: "m24.86 15.877-1.138 4.935H10.278l-1.14-4.935a.563.563 0 0 1 .828-.615l3.482 1.99 3.083-4.626a.564.564 0 0 1 .913-.034l3.616 4.65 2.94-1.96a.564.564 0 0 1 .86.595Z"
                                })
                            ]
                        })
                    }) : null,
                    plan.type === "platinum" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Response_module_default()).platinumBadge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatinumBadge, {})
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    "border-gray-bottom",
                    (Response_module_default()).headerWrapper
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileLink, {
                            href: "/".concat(slug),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: [
                                    "mb-s",
                                    (Response_module_default()).header
                                ].join(" "),
                                children: [
                                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileTag/* default */.Z, {
                                        plan: plan,
                                        image: image
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Response_module_default()).personal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                className: (Response_module_default()).name,
                                                children: [
                                                    expertSelected.id ? expertSelected.name : name,
                                                    Boolean(isVerified) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: (Response_module_default()).verifiedBadge,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tick/* default */.Z, {
                                                                fill: "#fff"
                                                            }),
                                                            "Verified"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                className: (Response_module_default()).expert,
                                                children: [
                                                    expertSelected.id ? expertSelected.position || position ? "".concat(expertSelected.position || position, " at ") : "" : position ? "".concat(position, " at ") : "",
                                                    (expertSelected.id ? expertSelected.position || position : position) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            profileAddresses && profileAddresses.length > 0 && profileAddresses[0].city ? "".concat(profileAddresses[0].city, "-based ") : "",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: profileCompany || name
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    !isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Response_module_default()).contactsLocked,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "aria-hidden": "true",
                                className: "loginBlur",
                                "data-nosnippet": true,
                                children: "name@company.co.uk"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginInfo/* default */.Z, {
                                label: "Why are the contact details hidden?",
                                children: "Contact details are shown to logged-in members."
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Response_module_default()).contacts,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
                                in: !contacts,
                                timeout: 400,
                                unmountOnExit: true,
                                children: function(state) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: handleClick,
                                        className: (Response_module_default()).button,
                                        style: (0,_object_spread/* default */.Z)({}, transitionStyles[state]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: en/* news_alerts.responses.show_contacts */.RA.p7.i2
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
                                in: contacts,
                                timeout: 400,
                                unmountOnExit: true,
                                children: function(state) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Response_module_default()).contacts,
                                        style: (0,_object_spread/* default */.Z)({}, transitionStyles[state]),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:".concat(email),
                                                children: email
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "tel:".concat(phone),
                                                children: phone
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Response_module_default()).videoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    controls: true,
                    className: (Response_module_default()).video,
                    src: video.startsWith("http") ? video : "https://".concat(video),
                    children: "Your browser does not support the video tag."
                })
            }),
            edit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitedTextArea/* default */.Z, {
                classes: [
                    (Response_module_default()).responseBox
                ],
                placeholder: "Write your masterpiece here. And remember, no waffle.",
                callback: function(value) {
                    return setHtml(value);
                },
                value: body,
                limit: RESPONSE_MAX_CHARACTERS
            }) : sentHtml && /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartText/* default */.Z, {
                quotes: true,
                bg: "#fafafa",
                height: 180,
                change: sentHtml,
                data: sentHtml
            }),
            showFooter && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    (Response_module_default()).footer,
                    edit ? (Response_module_default()).footerActive : "", 
                ].join(" "),
                children: [
                    edit && (experts === null || experts === void 0 ? void 0 : experts.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Response_module_default()).experts,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionSelect/* default */.Z, {
                            options: experts,
                            value: expertSelected,
                            setValue: setExpertSelected,
                            defaultValue: en/* news_alerts.responses.sendWithoutExperts */.RA.p7.ur
                        })
                    }),
                    showFooterButtons && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Response_module_default()).footerButtons,
                        children: [
                            isAdmin === true || isFTEditor === true || isJournalist === true && responseIndex !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                // theme={'secondary'}
                                title: "Pin to Top",
                                onClick: function() {
                                    return pinToTop(id);
                                },
                                classes: [
                                    (Response_module_default()).buttonPin
                                ]
                            }) : null,
                            responseIndex !== null && responseIndex !== undefined && (isJournalist === true || isFTEditor === true || isAdmin === true) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                theme: "alert",
                                title: "UNPIN",
                                onClick: function() {
                                    return unpin(id);
                                },
                                classes: [
                                    (Response_module_default()).buttonPin
                                ]
                            }) : null,
                            isAuthenticated && company === slug && status === "active" || isAdmin === true || isJournalist === true || isFTEditor === true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    canEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        theme: "secondary",
                                        title: edit ? "Cancel" : "Edit",
                                        onClick: function() {
                                            setHtml(body);
                                            setEdit(!edit);
                                        }
                                    }),
                                    !edit && isAdmin === true || isJournalist === true || isFTEditor === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        theme: "danger",
                                        title: "Remove",
                                        onClick: function() {
                                            return removeResponse(id);
                                        }
                                    }) : null,
                                    edit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        title: en/* common.save */.y0.save,
                                        disabled: (0,strings/* br2nl */.dl)(html).length > RESPONSE_MAX_CHARACTERS,
                                        onClick: updateResponse
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Alert_Response = (Response);

;// CONCATENATED MODULE: ./components/Alert/Responses.js







var Responses = function(param) {
    var list = param.list, status = param.status, id = param.id, alertSlug = param.alertSlug;
    var dataList = (0,src_to_consumable_array/* default */.Z)(list);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: (dataList === null || dataList === void 0 ? void 0 : dataList.length) ? dataList.map(function(item, index) {
            return /*#__PURE__*/ (0,react.createElement)(Alert_Response, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                status: status,
                alertId: id,
                alertSlug: alertSlug,
                key: "response-".concat(index)
            }));
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: status === "active" ? en/* news_alerts.responses.no_response */.RA.p7.iA : en/* news_alerts.responses.closed_alert */.RA.p7.Ny
        })
    });
};
/* harmony default export */ var Alert_Responses = (Responses);

// EXTERNAL MODULE: ./api/newsroom.js
var newsroom = __webpack_require__(37665);
// EXTERNAL MODULE: ./utils/subscriptionAccess.js
var subscriptionAccess = __webpack_require__(93073);
;// CONCATENATED MODULE: ./components/Alert/AdminButtons.js









var AdminButtons = function(param) {
    var status = param.status, handleEditArticle = param.handleEditArticle, handleCloseArticle = param.handleCloseArticle, handleUpdateArticle = param.handleUpdateArticle, loading = param.loading, edit = param.edit, timeValid = param.timeValid, dateValid = param.dateValid, setActive = param.setActive, isAdmin = param.isAdmin, isContributingEditor = param.isContributingEditor, isFTEditor = param.isFTEditor, plan = param.plan, alertId = param.alertId, noindex = param.noindex, onNoindexChange = param.onNoindexChange;
    var ref = (0,react.useState)(false), noindexSaving = ref[0], setNoindexSaving = ref[1];
    var ref1 = (0,react.useState)(null), noindexError = ref1[0], setNoindexError = ref1[1];
    var isContributingEditorOnly = (isContributingEditor || (0,subscriptionAccess/* writesAlerts */.B3)(plan === null || plan === void 0 ? void 0 : plan.type)) && !isAdmin && !isFTEditor;
    var toggleNoindex = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var saved, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setNoindexSaving(true);
                        setNoindexError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,newsroom/* setAlertNoindex */.NI)(alertId, !noindex)
                        ];
                    case 2:
                        saved = _state.sent();
                        onNoindexChange(saved.noindex);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setNoindexError((0,newsroom/* newsroomError */.tt)(err, "Could not change it."));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setNoindexSaving(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleNoindex() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Detail_module_default()).adminButtons,
        children: [
            status === "active" && !isContributingEditorOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                loading: loading,
                title: en/* news_alerts.close_button */.RA.vT,
                onClick: handleCloseArticle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                theme: "secondary",
                title: edit ? "Close Edit" : "Edit NewsAlert",
                onClick: handleEditArticle
            }),
            edit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: "Update NewsAlert",
                theme: "success",
                loading: edit && loading,
                onClick: handleUpdateArticle,
                disabled: status === "active" && (!timeValid || !dateValid)
            }),
            isAdmin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                theme: "danger",
                title: en/* news_alerts.remove_button */.RA.RW,
                onClick: function() {
                    return setActive(true);
                }
            }),
            isAdmin && alertId && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                theme: "secondary",
                title: noindex ? "Index in Google" : "Don't index",
                loading: noindexSaving,
                onClick: toggleNoindex
            }),
            isAdmin && noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Detail_module_default()).noindexNote,
                children: "Not indexed: this page is out of Google and the sitemaps."
            }),
            noindexError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Detail_module_default()).noindexNote,
                role: "alert",
                children: noindexError
            })
        ]
    });
};
/* harmony default export */ var Alert_AdminButtons = (AdminButtons);

// EXTERNAL MODULE: ./components/popUps/PopupConfirm.js
var PopupConfirm = __webpack_require__(67774);
// EXTERNAL MODULE: ./components/Svg/NewsAlertLogo.js
var NewsAlertLogo = __webpack_require__(99652);
;// CONCATENATED MODULE: ./components/Alert/Banner.js


var EXPERTISE_BANNER_MAPPER = [
    {
        expertise: [
            "mortgages"
        ],
        banner: {
            href: "https://www.finanzecapital.com/?utm_source=newspage",
            src: "finanze-banner.png",
            id: "banner_finanze"
        }
    },
    {
        expertise: [
            "pensions",
            "investments",
            "wealth manager",
            "wealth management",
            "financial planner",
            "financial advice",
            "IFA",
            "investing",
            "equity investments",
            "retirement planning",
            "stock markets",
            "money coach",
            "chartered financial planner",
            "independent financial adviser", 
        ],
        banner: {
            href: "https://investingreviews.co.uk/?utm_source=newspage",
            src: "investing-reviews.png",
            id: "banner_investingreviews"
        }
    },
    {
        expertise: [
            "law",
            "HR",
            "management",
            "technology",
            "insurance",
            "property",
            "accountancy/tax",
            "entrepreneurship", 
        ],
        banner: {
            href: "https://www.net-worthntwrk.com?utm_source=newspage&utm_medium=banner&utm_campaign=ntwrk-sponsorship",
            src: "net-worth-ntwrk.png",
            id: "net_worth_ntwrk"
        }
    }, 
];
var Banner = function(param) {
    var _campaign = param.campaign, campaign = _campaign === void 0 ? [] : _campaign;
    if (!campaign || !campaign.isActive) return null;
    var id = campaign.id, bannerLink = campaign.bannerLink, bannerSrc = campaign.bannerSrc, sponsorName = campaign.sponsorName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: [
            "mb-s",
            (Detail_module_default()).logo
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: bannerLink,
            target: "_blank",
            rel: "sponsored noopener",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                id: "banner-".concat(id),
                className: [
                    (Detail_module_default()).banner
                ].join(" "),
                src: "/img/banners/".concat(bannerSrc),
                alt: sponsorName ? "Advertisement: ".concat(sponsorName) : "Advertisement"
            })
        })
    });
};
/* harmony default export */ var Alert_Banner = (Banner);

;// CONCATENATED MODULE: ./components/Alert/ResponseArticle.js



var ResponseArticle = function(param) {
    var body = param.body, title = param.title;
    // Even a detached div loads <img> and fires its onerror, so the raw body
    // never reaches innerHTML.
    var tmp = document.createElement("div");
    tmp.innerHTML = (0,safe_html/* default */.ZP)(body);
    // Replace specific HTML tags with newlines or remove unwanted characters
    tmp.querySelectorAll("p, h1, br, li, b, a").forEach(function(element) {
        if (element.tagName === "P" || element.tagName === "H1") {
            element.insertAdjacentHTML("beforebegin", "&nbsp;&nbsp;");
        } else if (element.tagName === "BR" || element.tagName === "B") {
            element.insertAdjacentHTML("beforebegin", "&nbsp;");
        }
    });
    var cleanedBody = tmp.innerHTML;
    tmp.remove();
    var htmlContentWithTitle = "<h1>".concat((0,safe_html/* escapeHtml */.Xv)(title), "</h1><br />").concat((0,safe_html/* default */.ZP)(cleanedBody));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: htmlContentWithTitle
            }
        })
    });
};
/* harmony default export */ var Alert_ResponseArticle = (ResponseArticle);

// EXTERNAL MODULE: ./utils/newsroom.js
var utils_newsroom = __webpack_require__(93889);
// EXTERNAL MODULE: ./utils/faq-sponsor.js
var faq_sponsor = __webpack_require__(5812);
;// CONCATENATED MODULE: ./utils/seo-checks.js

// Yoast-style checks for a Storify story. Pure functions, so they run the same
// in the editor and in tests. Statuses: good (green), ok (amber), bad (red),
// info (grey: worth knowing, nothing to fix).
// The page title is "<SEO title> | Newspage", and Google shows about 60 characters.
var SEO_TITLE_MAX = seo_title/* TITLE_MAX */.WL - seo_title/* SITE_SUFFIX.length */.pW.length - 1;
var META_MIN = 120;
var META_MAX = 156;
// Google News shows up to about 110 characters of a headline.
var HEADLINE_MAX = 110;
var MIN_WORDS = 300;
var LONG_SENTENCE_WORDS = 20;
var LONG_PARAGRAPH_WORDS = 150;
var HOST_NAME = "app.newspage.media";
var ENTITIES = {
    "&nbsp;": " ",
    "&amp;": "&",
    "&quot;": '"',
    "&#39;": "'",
    "&#039;": "'",
    "&apos;": "'",
    "&lsquo;": "‘",
    "&rsquo;": "’",
    "&ldquo;": "“",
    "&rdquo;": "”",
    "&ndash;": "–",
    "&mdash;": "—",
    "&pound;": "\xa3",
    "&lt;": "<",
    "&gt;": ">"
};
var _entity;
var stripHtml = function() {
    var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return String(html || "").replace(/<(br|\/p|\/h[1-6]|\/li|\/blockquote)[^>]*>/gi, " ").replace(/<[^>]+>/g, " ").replace(/&[a-z#0-9]+;/gi, function(entity) {
        return (_entity = ENTITIES[entity]) !== null && _entity !== void 0 ? _entity : " ";
    }).replace(/\s+/g, " ").trim();
};
// Lower case, curly quotes straightened, punctuation removed (but not inside
// words: "buy-to-let" and "lender's" stay whole).
var normalise = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return String(text || "").toLowerCase().replace(/[‘’`]/g, "'").replace(RegExp("[^\\p{L}\\p{N}'\xa3$%-]+", "gu"), " ").replace(/(^|\s)['-]+|['-]+(?=\s|$)/g, " ").replace(/\s+/g, " ").trim();
};
var words = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return normalise(text).split(" ").filter(Boolean);
};
var escapeRegExp = function(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
// Each word of the keyphrase also matches its plural or possessive
// ("fractional CFO" matches "fractional CFOs").
var wordPattern = function(word) {
    return "".concat(escapeRegExp(word), "(?:'s|s|es)?");
};
// Occurrences of the keyphrase as a whole phrase.
var countPhrase = function(text, phrase) {
    var parts = words(phrase);
    if (!parts.length) return 0;
    var re = new RegExp("(^|\\s)".concat(parts.map(wordPattern).join("\\s"), "(?=\\s|$)"), "g");
    return (normalise(text).match(re) || []).length;
};
// 'exact' when the phrase appears as written, 'words' when every word of it
// appears somewhere (Yoast counts that as a match too), otherwise 'none'.
var matchKeyphrase = function(text, phrase) {
    var parts = words(phrase);
    if (!parts.length) return "none";
    if (countPhrase(text, phrase) > 0) return "exact";
    var haystack = normalise(text);
    return parts.every(function(w) {
        return new RegExp("(^|\\s)".concat(wordPattern(w), "(?=\\s|$)")).test(haystack);
    }) ? "words" : "none";
};
var paragraphs = function() {
    var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var found = [];
    var re = /<p[^>]*>([\s\S]*?)<\/p>/gi;
    var match;
    while(match = re.exec(html || "")){
        var text = stripHtml(match[1]);
        if (text) found.push(text);
    }
    if (!found.length) {
        var text1 = stripHtml(html);
        if (text1) found.push(text1);
    }
    return found;
};
var ABBREVIATION = /\b(Mr|Mrs|Ms|Dr|Prof|St|vs|etc|No|e\.g|i\.e)\.$/i;
var sentences = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return String(text || "").split(RegExp("(?<=[.!?])\\s+(?=[“\"‘'(]?[A-Z0-9\xa3$])")).reduce(function(all, piece) {
        var last = all[all.length - 1];
        if (last && ABBREVIATION.test(last)) {
            all[all.length - 1] = "".concat(last, " ").concat(piece);
        } else {
            all.push(piece);
        }
        return all;
    }, []).map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return words(s).length > 0;
    });
};
var links = function() {
    var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var hrefs = [];
    var re = /<a\s[^>]*href=["']([^"']+)["']/gi;
    var match;
    while(match = re.exec(html || ""))hrefs.push(match[1]);
    return hrefs;
};
var isInternal = function(href) {
    return href.startsWith("/") || /^https?:\/\/([a-z0-9-]+\.)*newspage\.(media|news)(\/|$)/i.test(href);
};
var excerptFrom = function(html) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : META_MAX;
    var text = stripHtml(html);
    if (text.length <= max) return text;
    return "".concat(text.slice(0, max - 1).replace(/\s+\S*$/, ""), "…");
};
var check = function(id, group, label, status, text) {
    return {
        id: id,
        group: group,
        label: label,
        status: status,
        text: text
    };
};
function storySeoChecks() {
    var story = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _slug = ref.slug, slug = _slug === void 0 ? "" : _slug;
    var headline = (story.headline || "").trim();
    var seoTitle = (story.seoTitle || "").trim() || headline;
    var meta = (story.metaDescription || "").trim();
    var keyphrase = (story.focusKeyphrase || "").trim();
    var body = story.body || "";
    var text = stripHtml(body);
    var wordCount = words(text).length;
    var paras = paragraphs(body);
    var hasKeyphrase = words(keyphrase).length > 0;
    var checks = [];
    // SEO
    var kpWords = words(keyphrase).length;
    checks.push(!hasKeyphrase ? check("keyphrase", "seo", "Focus keyphrase", "bad", "Set the search you want this story to rank for.") : kpWords > 4 ? check("keyphrase", "seo", "Focus keyphrase", "ok", "".concat(kpWords, " words is long. Most searches are 1 to 4 words.")) : check("keyphrase", "seo", "Focus keyphrase", "good", "Set."));
    if (hasKeyphrase) {
        var inTitle = matchKeyphrase(seoTitle, keyphrase);
        var atStart = normalise(seoTitle).startsWith(normalise(keyphrase));
        checks.push(inTitle === "none" ? check("kp-title", "seo", "Keyphrase in SEO title", "bad", "Put the keyphrase in the SEO title, ideally at the start.") : atStart ? check("kp-title", "seo", "Keyphrase in SEO title", "good", "At the start of the title.") : check("kp-title", "seo", "Keyphrase in SEO title", "ok", "In the title. Moving it to the start helps."));
        checks.push(matchKeyphrase(headline, keyphrase) === "none" ? check("kp-headline", "seo", "Keyphrase in headline", "ok", "The headline (H1) does not contain the keyphrase.") : check("kp-headline", "seo", "Keyphrase in headline", "good", "The headline contains it."));
        checks.push(!meta ? check("kp-meta", "seo", "Keyphrase in meta description", "bad", "Write a meta description that uses the keyphrase.") : matchKeyphrase(meta, keyphrase) === "none" ? check("kp-meta", "seo", "Keyphrase in meta description", "bad", "The meta description does not use the keyphrase.") : check("kp-meta", "seo", "Keyphrase in meta description", "good", "Used."));
        var intro = paras[0] || "";
        checks.push(matchKeyphrase(intro, keyphrase) === "none" ? check("kp-intro", "seo", "Keyphrase in introduction", "bad", "Use the keyphrase in the first paragraph.") : check("kp-intro", "seo", "Keyphrase in introduction", "good", "The first paragraph uses it."));
        var occurrences = countPhrase(text, keyphrase);
        var density = wordCount ? occurrences * kpWords * 100 / wordCount : 0;
        var used = "Used ".concat(occurrences, " time").concat(occurrences === 1 ? "" : "s", " (").concat(density.toFixed(1), "%)");
        checks.push(wordCount < 100 ? check("kp-density", "seo", "Keyphrase density", "info", "Counts once the story passes 100 words.") : density > 3 ? check("kp-density", "seo", "Keyphrase density", "bad", "".concat(used, ". That reads as stuffing: use it less.")) : density < 0.5 ? check("kp-density", "seo", "Keyphrase density", "ok", "".concat(used, ". Aim for 0.5–3%.")) : check("kp-density", "seo", "Keyphrase density", "good", "".concat(used, ".")));
        var slugText = String(slug || "").replace(/-/g, " ");
        checks.push(matchKeyphrase(slugText, keyphrase) === "none" ? check("kp-slug", "seo", "Keyphrase in URL", "info", "Not in the URL. The URL stays as it is: it is already indexed, and changing it would lose that.") : check("kp-slug", "seo", "Keyphrase in URL", "good", "The URL contains it."));
    }
    checks.push(!seoTitle ? check("title-length", "seo", "SEO title width", "bad", "Write a headline or an SEO title.") : seoTitle.length > SEO_TITLE_MAX ? check("title-length", "seo", "SEO title width", "ok", "".concat(seoTitle.length, " characters. Over ").concat(SEO_TITLE_MAX, ', Google cuts it off (the page adds "').concat(seo_title/* SITE_SUFFIX */.pW, '").')) : seoTitle.length < 30 ? check("title-length", "seo", "SEO title width", "ok", "".concat(seoTitle.length, " characters. There is room for more.")) : check("title-length", "seo", "SEO title width", "good", "".concat(seoTitle.length, " of ").concat(SEO_TITLE_MAX, " characters.")));
    checks.push(!meta ? check("meta-length", "seo", "Meta description length", "bad", "Empty, so Google will pick its own text.") : meta.length < META_MIN ? check("meta-length", "seo", "Meta description length", "ok", "".concat(meta.length, " characters. Aim for ").concat(META_MIN, "–").concat(META_MAX, ".")) : meta.length > META_MAX ? check("meta-length", "seo", "Meta description length", "ok", "".concat(meta.length, " characters. Google cuts it off after about ").concat(META_MAX, ".")) : check("meta-length", "seo", "Meta description length", "good", "".concat(meta.length, " characters.")));
    checks.push(!headline ? check("headline", "seo", "Headline", "bad", "The story needs a headline.") : headline.length > HEADLINE_MAX ? check("headline", "seo", "Headline", "ok", "".concat(headline.length, " characters. Google News shows about ").concat(HEADLINE_MAX, ".")) : check("headline", "seo", "Headline", "good", "".concat(headline.length, " characters.")));
    checks.push(wordCount >= MIN_WORDS ? check("length", "seo", "Text length", "good", "".concat(wordCount, " words.")) : check("length", "seo", "Text length", wordCount >= 200 ? "ok" : "bad", "".concat(wordCount, " words. Aim for at least ").concat(MIN_WORDS, ".")));
    var hrefs = links(body);
    var outbound = hrefs.filter(function(h) {
        return /^https?:/i.test(h) && !isInternal(h);
    });
    var internal = hrefs.filter(isInternal);
    checks.push(outbound.length ? check("outbound", "seo", "Outbound links", "good", "".concat(outbound.length, " link").concat(outbound.length === 1 ? "" : "s", " to sources.")) : check("outbound", "seo", "Outbound links", "ok", "Link to the research or data the story relies on."));
    checks.push(internal.length ? check("internal", "seo", "Internal links", "good", "".concat(internal.length, " link").concat(internal.length === 1 ? "" : "s", " to Newspage.")) : check("internal", "seo", "Internal links", "ok", "Link to the experts' Newspages or related stories."));
    var images = (body || "").match(/<img\b[^>]*>/gi) || [];
    var noAlt = images.filter(function(img) {
        return !/\balt=["'][^"']+["']/i.test(img);
    });
    if (images.length) {
        checks.push(noAlt.length ? check("alt", "seo", "Image alt text", "ok", "".concat(noAlt.length, " image").concat(noAlt.length === 1 ? " has" : "s have", " no alt text.")) : check("alt", "seo", "Image alt text", "good", "Every image has alt text."));
    }
    // Readability
    var allSentences = paras.flatMap(sentences);
    var long = allSentences.filter(function(s) {
        return words(s).length > LONG_SENTENCE_WORDS;
    });
    var longShare = allSentences.length ? long.length * 100 / allSentences.length : 0;
    if (allSentences.length) {
        checks.push(longShare > 25 ? check("sentences", "readability", "Sentence length", "ok", "".concat(Math.round(longShare), "% of sentences are over ").concat(LONG_SENTENCE_WORDS, " words. Keep it under 25%.")) : check("sentences", "readability", "Sentence length", "good", "".concat(Math.round(longShare), "% of sentences are over ").concat(LONG_SENTENCE_WORDS, " words.")));
    }
    var longParas = paras.filter(function(p) {
        return words(p).length > LONG_PARAGRAPH_WORDS;
    });
    if (paras.length) {
        checks.push(longParas.length ? check("paragraphs", "readability", "Paragraph length", "ok", "".concat(longParas.length, " paragraph").concat(longParas.length === 1 ? " is" : "s are", " over ").concat(LONG_PARAGRAPH_WORDS, " words.")) : check("paragraphs", "readability", "Paragraph length", "good", "No paragraph is too long."));
    }
    if (wordCount > MIN_WORDS) {
        checks.push(/<h[2-4][\s>]/i.test(body) ? check("subheadings", "readability", "Subheadings", "good", "The story is broken up with subheadings.") : check("subheadings", "readability", "Subheadings", "ok", "Add subheadings (Heading 2) to break up a longer story."));
    }
    return checks;
}
// One traffic light for the whole story, as Yoast shows.
var overallStatus = function(checks) {
    var scored = checks.filter(function(c) {
        return c.status !== "info";
    });
    if (!scored.length) return "bad";
    if (scored.some(function(c) {
        return c.status === "bad";
    })) return "bad";
    var ok = scored.filter(function(c) {
        return c.status === "ok";
    }).length;
    return ok > 2 ? "ok" : "good";
};
// What the Google result will look like.
var searchSnippet = function() {
    var story = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slug = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return {
        title: (0,seo_title/* default */.ZP)((story.seoTitle || "").trim() || story.headline || ""),
        url: "".concat(HOST_NAME, " › news-alerts › ").concat(slug),
        description: (story.metaDescription || "").trim() || excerptFrom(story.body)
    };
};

;// CONCATENATED MODULE: ./components/Alert/Newsroom/SeoPanel.js




var STATUS_LABEL = {
    good: "Good",
    ok: "OK",
    bad: "Needs work",
    info: "Note"
};
var LengthBar = function(param) {
    var length = param.length, min = param.min, max = param.max;
    var status = !length || length > max ? "bad" : length < min ? "ok" : "good";
    var width = Math.min(100, Math.round(length / max * 100));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Newsroom_module_default()).lengthBar,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (Newsroom_module_default())["bar-".concat(status)],
            style: {
                width: "".concat(width, "%")
            }
        })
    });
};
var CheckList = function(param) {
    var title = param.title, checks = param.checks;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Newsroom_module_default()).checkGroup,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (Newsroom_module_default()).checks,
                children: checks.map(function(check) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: [
                                    (Newsroom_module_default()).dot,
                                    (Newsroom_module_default())["dot-".concat(check.status)], 
                                ].join(" "),
                                title: STATUS_LABEL[check.status]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        children: [
                                            check.label,
                                            ":"
                                        ]
                                    }),
                                    " ",
                                    check.text
                                ]
                            })
                        ]
                    }, check.id);
                })
            })
        ]
    });
};
// The Yoast-style side panel: focus keyphrase, Google preview, SEO title and
// meta description with length bars, then the SEO and readability checks.
var SeoPanel = function(param) {
    var draft = param.draft, slug = param.slug, onChange = param.onChange;
    var checks = (0,react.useMemo)(function() {
        return storySeoChecks(draft, {
            slug: slug
        });
    }, [
        draft,
        slug
    ]);
    var snippet = searchSnippet(draft, slug);
    var overall = overallStatus(checks);
    var seoTitleLength = (draft.seoTitle || draft.headline || "").trim().length;
    var metaLength = (draft.metaDescription || "").trim().length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Newsroom_module_default()).seo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).seoHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: [
                            (Newsroom_module_default()).dot,
                            (Newsroom_module_default())["dot-".concat(overall)]
                        ].join(" ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            "SEO: ",
                            STATUS_LABEL[overall]
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (Newsroom_module_default()).label,
                htmlFor: "story-keyphrase",
                children: "Focus keyphrase"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "story-keyphrase",
                className: (Newsroom_module_default()).input,
                value: draft.focusKeyphrase,
                maxLength: 255,
                placeholder: "The search you want to rank for",
                onChange: function(e) {
                    return onChange("focusKeyphrase", e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).snippet,
                "aria-label": "Google preview",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Newsroom_module_default()).snippetUrl,
                        children: snippet.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Newsroom_module_default()).snippetTitle,
                        children: snippet.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Newsroom_module_default()).snippetText,
                        children: snippet.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (Newsroom_module_default()).label,
                htmlFor: "story-seo-title",
                children: [
                    "SEO title",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (Newsroom_module_default()).count,
                        children: [
                            seoTitleLength,
                            "/",
                            SEO_TITLE_MAX
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "story-seo-title",
                className: (Newsroom_module_default()).input,
                value: draft.seoTitle,
                maxLength: 255,
                placeholder: draft.headline || "Defaults to the headline",
                onChange: function(e) {
                    return onChange("seoTitle", e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LengthBar, {
                length: seoTitleLength,
                min: 30,
                max: SEO_TITLE_MAX
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (Newsroom_module_default()).label,
                htmlFor: "story-meta",
                children: [
                    "Meta description",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (Newsroom_module_default()).count,
                        children: [
                            metaLength,
                            "/",
                            META_MAX
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                id: "story-meta",
                className: (Newsroom_module_default()).textarea,
                rows: 3,
                value: draft.metaDescription,
                maxLength: 500,
                placeholder: "What Google shows under the title",
                onChange: function(e) {
                    return onChange("metaDescription", e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LengthBar, {
                length: metaLength,
                min: META_MIN,
                max: META_MAX
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckList, {
                title: "SEO analysis",
                checks: checks.filter(function(c) {
                    return c.group === "seo";
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckList, {
                title: "Readability",
                checks: checks.filter(function(c) {
                    return c.group === "readability";
                })
            })
        ]
    });
};
/* harmony default export */ var Newsroom_SeoPanel = (SeoPanel);

;// CONCATENATED MODULE: ./components/Alert/Newsroom/SuggestedLink.js






var escapeHtml = function(value) {
    return String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
};
// The alert's source page, offered to the writer; the link only goes into the story if they paste it.
var SuggestedLink = function(param) {
    var alert = param.alert;
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    var href = (0,source_page/* sourcePageHref */.w7)(alert.sourceUrl, alert.slug);
    if (!href) return null;
    var text = (0,source_page/* sourcePageText */.Mg)(alert.sourceLabel, alert.sourceUrl);
    // Matches the editor's "Sponsored link" decorator, so the rel survives the paste.
    var rel = alert.isSponsored ? ' rel="nofollow sponsored"' : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (Newsroom_module_default()).seo,
            (Newsroom_module_default()).suggestedLink
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Newsroom_module_default()).kicker,
                children: "Suggested link"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (Newsroom_module_default()).hint,
                children: [
                    "The alert’s source page",
                    alert.isSponsored ? " (sponsored)" : "",
                    ". Copy it into the story where it fits, or leave it out."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noopener noreferrer",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                theme: "secondary",
                title: copied ? "Copied" : "Copy link",
                onClick: function() {
                    copyFormatted('<a href="'.concat(escapeHtml(href), '"').concat(rel, ">").concat(escapeHtml(text), "</a>"));
                    setCopied(true);
                }
            })
        ]
    });
};
/* harmony default export */ var Newsroom_SuggestedLink = (SuggestedLink);

// EXTERNAL MODULE: ./api/faq-sponsor.js
var api_faq_sponsor = __webpack_require__(57573);
;// CONCATENATED MODULE: ./components/Alert/Newsroom/FaqReview.js











var REVIEWABLE = [
    "in_review",
    "live"
];
// Admin: the sponsor's answers for this story. Approve puts the block live;
// Decline emails the sponsor the reason (the payment is refunded in Stripe).
var FaqReview = function(param) {
    var alertId = param.alertId, story = param.story, onStoryChange = param.onStoryChange, onNotice = param.onNotice;
    var status = story.faqSponsorStatus;
    var _faqAnswers;
    var ref = (0,react.useState)((_faqAnswers = story.faqAnswers) !== null && _faqAnswers !== void 0 ? _faqAnswers : []), answers = ref[0], setAnswers = ref[1];
    var _faqSponsorWebsite;
    var ref1 = (0,react.useState)((_faqSponsorWebsite = story.faqSponsorWebsite) !== null && _faqSponsorWebsite !== void 0 ? _faqSponsorWebsite : ""), website = ref1[0], setWebsite = ref1[1];
    var ref2 = (0,react.useState)(""), reason = ref2[0], setReason = ref2[1];
    var ref3 = (0,react.useState)(null), busy = ref3[0], setBusy = ref3[1];
    var run = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(key, action, done, fallback) {
            var saved, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setBusy(key);
                        onNotice(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            action()
                        ];
                    case 2:
                        saved = _state.sent();
                        onStoryChange(saved);
                        onNotice({
                            type: "ok",
                            text: done
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        onNotice({
                            type: "error",
                            text: (0,newsroom/* newsroomError */.tt)(err, fallback)
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setBusy(null);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function run(key, action, done, fallback) {
            return _ref.apply(this, arguments);
        };
    }();
    var _faqAnswers1, _faqSponsorWebsite1;
    var unsaved = JSON.stringify(answers) !== JSON.stringify((_faqAnswers1 = story.faqAnswers) !== null && _faqAnswers1 !== void 0 ? _faqAnswers1 : []) || website !== ((_faqSponsorWebsite1 = story.faqSponsorWebsite) !== null && _faqSponsorWebsite1 !== void 0 ? _faqSponsorWebsite1 : "");
    var canDecline = [
        "awaiting_answers",
        "in_review",
        "live"
    ].includes(status);
    if (!REVIEWABLE.includes(status) && !canDecline) return null;
    var _faqQuestions, _i;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Newsroom_module_default()).faqReview,
        children: [
            REVIEWABLE.includes(status) && ((_faqQuestions = story.faqQuestions) !== null && _faqQuestions !== void 0 ? _faqQuestions : []).map(function(question, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: (Newsroom_module_default()).label,
                            htmlFor: "faq-answer-".concat(i),
                            children: question
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            id: "faq-answer-".concat(i),
                            className: (Newsroom_module_default()).textarea,
                            rows: 5,
                            value: (_i = answers[i]) !== null && _i !== void 0 ? _i : "",
                            onChange: function(e) {
                                return setAnswers(function(current) {
                                    return Object.assign((0,src_to_consumable_array/* default */.Z)(current), (0,_define_property/* default */.Z)({}, i, e.target.value));
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,faq_sponsor/* countWords */.Ht)(answers[i]) > faq_sponsor/* MAX_ANSWER_WORDS */.jb ? (Newsroom_module_default()).overLimit : (Newsroom_module_default()).hint,
                            children: "".concat((0,faq_sponsor/* countWords */.Ht)(answers[i]), " / ").concat(faq_sponsor/* MAX_ANSWER_WORDS */.jb, " words")
                        })
                    ]
                }, i);
            }),
            REVIEWABLE.includes(status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (Newsroom_module_default()).label,
                        htmlFor: "faq-website",
                        children: "Sponsor’s website (sponsored link)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "faq-website",
                        className: (Newsroom_module_default()).input,
                        value: website,
                        onChange: function(e) {
                            return setWebsite(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Newsroom_module_default()).editorActions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: "Save edits",
                                theme: "secondary",
                                loading: busy === "edit",
                                onClick: function() {
                                    return run("edit", function() {
                                        return (0,api_faq_sponsor/* editSponsorAnswers */.DE)(alertId, {
                                            answers: answers,
                                            website: website
                                        });
                                    }, status === "live" ? "Saved. The live answers are updated." : "Saved.", "Could not save the answers.");
                                }
                            }),
                            status === "in_review" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                title: "Approve and publish",
                                theme: "success",
                                loading: busy === "approve",
                                disabled: unsaved,
                                onClick: function() {
                                    return run("approve", function() {
                                        return (0,api_faq_sponsor/* approveSponsorAnswers */.so)(alertId);
                                    }, "Approved. The expert answers are live under the story.", "Could not approve the answers.");
                                }
                            })
                        ]
                    }),
                    unsaved && status === "in_review" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Newsroom_module_default()).hint,
                        children: "Save your edits before approving."
                    })
                ]
            }),
            canDecline && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (Newsroom_module_default()).label,
                        htmlFor: "faq-decline",
                        children: status === "live" ? "Reason for taking the answers down (emailed to the sponsor)" : "Reason for declining (emailed to the sponsor)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        id: "faq-decline",
                        className: (Newsroom_module_default()).textarea,
                        rows: 3,
                        value: reason,
                        onChange: function(e) {
                            return setReason(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Newsroom_module_default()).editorActions,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            title: status === "live" ? "Take down" : "Decline",
                            theme: "danger",
                            loading: busy === "decline",
                            disabled: !reason.trim(),
                            onClick: function() {
                                return run("decline", function() {
                                    return (0,api_faq_sponsor/* declineSponsorAnswers */.Vp)(alertId, reason);
                                }, "Declined and the sponsor emailed. Refund the payment in Stripe.", "Could not decline.");
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Newsroom_FaqReview = (FaqReview);

;// CONCATENATED MODULE: ./components/Alert/Newsroom/FaqOfferFields.js






// Evergreen Sponsor: the "Expert answers" slot under the story, offered to the
// alert's responders by email once the story is live.
var FaqOfferFields = function(param) {
    var alert = param.alert, researchOn = param.researchOn, story = param.story, draft = param.draft, onChange = param.onChange, onStoryChange = param.onStoryChange;
    var sponsored = Boolean(alert.isSponsored);
    // The story research sponsorship sells this slot too, so the API refuses the offer.
    var blocked = sponsored || researchOn;
    var sentAt = story === null || story === void 0 ? void 0 : story.faqOfferSentAt;
    var status = (0,faq_sponsor/* faqSponsorStatusLabel */.oo)(story);
    // Answers are written to these questions, matched by position.
    var locked = Boolean(story === null || story === void 0 ? void 0 : story.faqSponsorStatus);
    // Kept here: approving or declining changes what the review panel shows.
    var ref = (0,react.useState)(null), reviewNotice = ref[0], setReviewNotice = ref[1];
    var setQuestion = function(index, value) {
        return onChange("faqQuestions", draft.faqQuestions.map(function(q, i) {
            return i === index ? value : q;
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        className: (Newsroom_module_default()).faqOffer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                className: (Newsroom_module_default()).kicker,
                children: "Evergreen Sponsor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (Newsroom_module_default()).checkboxLabel,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        checked: draft.faqOffer,
                        disabled: blocked,
                        onChange: function(e) {
                            return onChange("faqOffer", e.target.checked);
                        }
                    }),
                    "Offer FAQ sponsorship to responders"
                ]
            }),
            sponsored ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: "Alert is sponsored; the sponsor’s answers run here."
            }) : researchOn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: "Not available: this alert offers a story research sponsorship, which includes the expert answers. Turn it off in Edit first."
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: sentAt ? "Offer emailed to the responders on ".concat((0,utils_newsroom/* formatDate */.p6)(sentAt), ". It is sent only once.") : "Emailed once to every expert who responded, when the story is live. First come, first served. Untick to publish without the offer."
            }),
            status && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).faqStatus,
                children: status
            }),
            (story === null || story === void 0 ? void 0 : story.faqSponsorStatus) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_FaqReview, {
                alertId: alert.id,
                story: story,
                onStoryChange: onStoryChange,
                onNotice: setReviewNotice
            }),
            reviewNotice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: reviewNotice.type === "error" ? (Newsroom_module_default()).error : (Newsroom_module_default()).ok,
                role: reviewNotice.type === "error" ? "alert" : "status",
                children: reviewNotice.text
            }),
            locked && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: "The heading and questions are fixed now that the slot is sold."
            }),
            !sponsored && draft.faqOffer && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (Newsroom_module_default()).label,
                        htmlFor: "faq-heading",
                        children: "FAQ heading"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "faq-heading",
                        className: (Newsroom_module_default()).input,
                        value: draft.faqHeading,
                        maxLength: 255,
                        disabled: locked,
                        placeholder: "Financial advice for women going through divorce: your questions answered",
                        onChange: function(e) {
                            return onChange("faqHeading", e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Newsroom_module_default()).label,
                        children: "Questions (at least one)"
                    }),
                    draft.faqQuestions.map(function(question, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            "aria-label": "Question ".concat(i + 1),
                            className: [
                                (Newsroom_module_default()).input,
                                (Newsroom_module_default()).faqQuestion
                            ].join(" "),
                            value: question,
                            maxLength: 255,
                            disabled: locked,
                            placeholder: "Question ".concat(i + 1),
                            onChange: function(e) {
                                return setQuestion(i, e.target.value);
                            }
                        }, i);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Newsroom_FaqOfferFields = (FaqOfferFields);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./components/Alert/Newsroom/StorySponsorFields.js



var FIELDS = [
    [
        "sponsorName",
        "Sponsor name",
        "text",
        "Check Financial"
    ],
    [
        "sponsorImageUrl",
        "Banner image URL (728\xd790)",
        "url",
        "https://…"
    ],
    [
        "sponsorUrl",
        "Sponsor link",
        "url",
        "https://…"
    ],
    [
        "sponsorStartsAt",
        "Runs from",
        "datetime-local"
    ],
    [
        "sponsorEndsAt",
        "Runs until",
        "datetime-local"
    ], 
];
// The living story's one ad slot. Saving it does not count as an update to the story.
// Off while the alert offers a story research sponsorship: one sponsor per page, and the API refuses it.
var StorySponsorFields = function(param) {
    var draft = param.draft, onChange = param.onChange, researchOn = param.researchOn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        className: (Newsroom_module_default()).faqOffer,
        disabled: researchOn,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                className: (Newsroom_module_default()).kicker,
                children: "Sponsor slot"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: researchOn ? "Not available: this alert offers a story research sponsorship, and the page carries one sponsor. Turn it off in Edit first." : "One labelled ad above the headline. Links in the story to the sponsor’s site are marked sponsored automatically. Leave the dates empty to run it from now with no end."
            }),
            FIELDS.map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 4), name = _param[0], label = _param[1], type = _param[2], placeholder = _param[3];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: (Newsroom_module_default()).label,
                            htmlFor: "story-".concat(name),
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "story-".concat(name),
                            className: (Newsroom_module_default()).input,
                            type: type,
                            value: draft[name],
                            maxLength: type === "datetime-local" ? undefined : 1000,
                            placeholder: placeholder,
                            onChange: function(e) {
                                return onChange(name, e.target.value);
                            }
                        })
                    ]
                }, name);
            })
        ]
    });
};
/* harmony default export */ var Newsroom_StorySponsorFields = (StorySponsorFields);

;// CONCATENATED MODULE: ./components/Alert/Newsroom/LeadImageFields.js





var TEXT_FIELDS = [
    [
        "leadImageAlt",
        "Alt text (required)",
        255,
        "What the picture shows"
    ],
    [
        "leadImageCaption",
        "Caption",
        500,
        ""
    ],
    [
        "leadImageCredit",
        "Credit",
        255,
        "Photo: Reuters"
    ], 
];
// The picture above the story, and the one Google and social cards show. The
// file uploads straight away; alt, caption, credit and Remove save with the story.
var LeadImageFields = function(param) {
    var story = param.story, draft = param.draft, uploading = param.uploading, onChange = param.onChange, onUpload = param.onUpload;
    var fileInput = (0,react.useRef)(null);
    var current = (story === null || story === void 0 ? void 0 : story.leadImageUrl) && !draft.clearLeadImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        className: (Newsroom_module_default()).faqOffer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                className: (Newsroom_module_default()).kicker,
                children: "Lead image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: "Shown under the byline and on Google and social media. PNG, JPEG or WebP, at least 1200px wide and 675px tall, up to 10 MB. Write the alt text before choosing the file."
            }),
            current && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (Newsroom_module_default()).leadImagePreview,
                src: story.leadImageUrl,
                alt: story.leadImageAlt || ""
            }),
            (story === null || story === void 0 ? void 0 : story.leadImageUrl) && draft.clearLeadImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: "The lead image is removed when you save."
            }),
            TEXT_FIELDS.map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 4), name = _param[0], label = _param[1], maxLength = _param[2], placeholder = _param[3];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            className: (Newsroom_module_default()).label,
                            htmlFor: "story-".concat(name),
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "story-".concat(name),
                            className: (Newsroom_module_default()).input,
                            value: draft[name],
                            maxLength: maxLength,
                            placeholder: placeholder,
                            onChange: function(e) {
                                return onChange(name, e.target.value);
                            }
                        })
                    ]
                }, name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: fileInput,
                type: "file",
                accept: "image/png,image/jpeg,image/webp",
                hidden: true,
                onChange: function(e) {
                    var _files = (0,_sliced_to_array/* default */.Z)(e.target.files, 1), file = _files[0];
                    // So picking the same file again after an error uploads it again.
                    e.target.value = "";
                    if (file) onUpload(file);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).leadImageActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        theme: "primary",
                        title: current ? "Replace image" : "Upload image",
                        loading: uploading,
                        disabled: !draft.leadImageAlt.trim(),
                        onClick: function() {
                            var ref;
                            return (ref = fileInput.current) === null || ref === void 0 ? void 0 : ref.click();
                        }
                    }),
                    (story === null || story === void 0 ? void 0 : story.leadImageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        theme: "secondary",
                        title: draft.clearLeadImage ? "Keep image" : "Remove",
                        onClick: function() {
                            return onChange("clearLeadImage", !draft.clearLeadImage);
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Newsroom_LeadImageFields = (LeadImageFields);

// EXTERNAL MODULE: ./api/directory.js
var directory = __webpack_require__(11305);
;// CONCATENATED MODULE: ./components/Alert/Newsroom/DirectoryTopicsPicker.js










var sameSet = function(a, b) {
    return a.length === b.length && a.every(function(value) {
        return b.includes(value);
    });
};
var toggled = function(list, value) {
    return list.includes(value) ? list.filter(function(other) {
        return other !== value;
    }) : (0,src_to_consumable_array/* default */.Z)(list).concat([
        value
    ]);
};
// Admins only. Saved on its own button, apart from the story or alert form: it changes the
// directory pages, not this one.
var DirectoryTopicsPicker = function(param) {
    var alertId = param.alertId, published = param.published;
    var ref = (0,react.useState)(null), options = ref[0], setOptions = ref[1];
    var ref1 = (0,react.useState)({
        expertiseIds: [],
        townSlugs: []
    }), saved = ref1[0], setSaved = ref1[1];
    var ref2 = (0,react.useState)([]), topicIds = ref2[0], setTopicIds = ref2[1];
    var ref3 = (0,react.useState)([]), townSlugs = ref3[0], setTownSlugs = ref3[1];
    var ref4 = (0,react.useState)(false), showAll = ref4[0], setShowAll = ref4[1];
    var ref5 = (0,react.useState)(false), saving = ref5[0], setSaving = ref5[1];
    var ref6 = (0,react.useState)(null), notice = ref6[0], setNotice = ref6[1];
    var apply = function(current) {
        setSaved(current);
        setTopicIds(current.expertiseIds);
        setTownSlugs(current.townSlugs || []);
    };
    (0,react.useEffect)(function() {
        var active = true;
        setOptions(null);
        setNotice(null);
        Promise.all([
            (0,directory/* fetchDirectoryTopics */.vF)(),
            (0,directory/* fetchAlertDirectoryTopics */.Bf)(alertId), 
        ]).then(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), list = _param[0], current = _param[1];
            if (!active) return;
            setOptions({
                topics: list.topics,
                towns: list.towns || []
            });
            apply(current);
        }).catch(function(err) {
            if (active) setNotice({
                ok: false,
                text: (0,newsroom/* newsroomError */.tt)(err, "Could not load the directory topics.")
            });
        });
        return function() {
            active = false;
        };
    }, [
        alertId
    ]);
    var save = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSaving(true);
                        setNotice(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,directory/* saveAlertDirectoryTopics */.re)(alertId, topicIds, townSlugs)
                        ];
                    case 2:
                        apply.apply(void 0, [
                            _state.sent()
                        ]);
                        setNotice({
                            ok: true,
                            text: published ? "Saved. The directory pages update within a minute." : "Saved. The story goes on these pages when it is published."
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setNotice({
                            ok: false,
                            text: (0,newsroom/* newsroomError */.tt)(err, "Could not save the topics.")
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setSaving(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function save() {
            return _ref.apply(this, arguments);
        };
    }();
    var topics = (options === null || options === void 0 ? void 0 : options.topics) || [];
    var withoutPage = topics.filter(function(topic) {
        return !topic.hasPage && !topicIds.includes(topic.id);
    });
    var shownTopics = topics.filter(function(topic) {
        return showAll || topic.hasPage || topicIds.includes(topic.id);
    });
    // A town ticked earlier stays listed after its page has gone, so it can be unticked.
    var towns = (0,src_to_consumable_array/* default */.Z)((options === null || options === void 0 ? void 0 : options.towns) || []).concat((0,src_to_consumable_array/* default */.Z)((saved.townSlugs || []).filter(function(slug) {
        var ref;
        return !(options === null || options === void 0 ? void 0 : (ref = options.towns) === null || ref === void 0 ? void 0 : ref.some(function(town) {
            return town.slug === slug;
        }));
    }).map(function(slug) {
        return {
            slug: slug,
            name: slug,
            gone: true
        };
    })));
    var unchanged = sameSet(topicIds, saved.expertiseIds) && sameSet(townSlugs, saved.townSlugs || []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Newsroom_module_default()).topics,
        "aria-label": "Directory topics",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Directory topics"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: "Tick every mortgage-brokers page this story belongs on. The experts quoted in it, and coverage logged from this alert, show on those pages too."
            }),
            !options && !notice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).hint,
                children: "Loading…"
            }),
            options && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Newsroom_module_default()).topicGroup,
                        children: "Topics"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (Newsroom_module_default()).topicList,
                        children: shownTopics.map(function(topic) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            checked: topicIds.includes(topic.id),
                                            disabled: saving,
                                            onChange: function() {
                                                return setTopicIds(function(current) {
                                                    return toggled(current, topic.id);
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: topic.name
                                        }),
                                        !topic.hasPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Newsroom_module_default()).topicNoPage,
                                            children: "no page yet"
                                        })
                                    ]
                                })
                            }, topic.id);
                        })
                    }),
                    withoutPage.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (Newsroom_module_default()).linkButton,
                        onClick: function() {
                            return setShowAll(function(value) {
                                return !value;
                            });
                        },
                        children: showAll ? "Hide topics without a page" : "Show ".concat(withoutPage.length, " topics without a page")
                    }),
                    towns.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Newsroom_module_default()).topicGroup,
                                children: "Towns"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (Newsroom_module_default()).topicList,
                                children: towns.map(function(town) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: townSlugs.includes(town.slug),
                                                    disabled: saving,
                                                    onChange: function() {
                                                        return setTownSlugs(function(current) {
                                                            return toggled(current, town.slug);
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: town.name
                                                }),
                                                town.gone && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (Newsroom_module_default()).topicNoPage,
                                                    children: "no page now"
                                                })
                                            ]
                                        })
                                    }, town.slug);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Newsroom_module_default()).topicActions,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            title: "Save topics",
                            theme: "secondary",
                            loading: saving,
                            disabled: unchanged,
                            onClick: save
                        })
                    })
                ]
            }),
            notice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: notice.ok ? (Newsroom_module_default()).ok : (Newsroom_module_default()).error,
                role: notice.ok ? "status" : "alert",
                children: notice.text
            })
        ]
    });
};
/* harmony default export */ var Newsroom_DirectoryTopicsPicker = (DirectoryTopicsPicker);

// EXTERNAL MODULE: ./utils/story-links.js
var story_links = __webpack_require__(90788);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
;// CONCATENATED MODULE: ./components/Alert/Newsroom/storyLinkRel.js





var FOLLOW_LABEL = "Follow link";
var PAID_LABEL = "Paid link: always nofollow sponsored";
// CKEditor plugin for the story's link balloon: the "Follow link" switch starts
// on for official sources and off for everything else, and a paid link is
// locked to sponsored. The hidden "nofollow" decorator stores the switch's off
// state, so an explicit nofollow differs from a link nobody chose for.
var storyLinkRelPlugin = function(sponsorHosts) {
    var StoryLinkRel = /*#__PURE__*/ function() {
        "use strict";
        function StoryLinkRel(editor) {
            (0,_class_call_check/* default */.Z)(this, StoryLinkRel);
            this.editor = editor;
        }
        (0,_create_class/* default */.Z)(StoryLinkRel, [
            {
                key: "afterInit",
                value: function afterInit() {
                    var ref;
                    var editor = this.editor;
                    var command = editor.commands.get("link");
                    // CKEditor prefixes decorator ids: "follow" becomes "linkFollow".
                    var decorator = function(id) {
                        return command === null || command === void 0 ? void 0 : command.manualDecorators.get(id);
                    };
                    var sponsored = decorator("linkSponsored");
                    var follow = decorator("linkFollow");
                    var nofollow = decorator("linkNofollow");
                    if (!sponsored || !follow || !nofollow) return;
                    // LinkFormView has no public accessor for its switches in v35; if a
                    // CKEditor upgrade moves them, the balloon keeps its plain switches.
                    var form = editor.plugins.has("LinkUI") ? editor.plugins.get("LinkUI").formView : null;
                    var switches = form === null || form === void 0 ? void 0 : form._manualDecoratorSwitches;
                    var switchFor = function(id) {
                        return typeof (switches === null || switches === void 0 ? void 0 : switches.find) === "function" ? switches.find(function(view) {
                            return view.name === id;
                        }) : null;
                    };
                    var followSwitch = switchFor("linkFollow");
                    var sponsoredSwitch = switchFor("linkSponsored");
                    var nofollowSwitch = switchFor("linkNofollow");
                    var wired = Boolean(followSwitch && sponsoredSwitch && nofollowSwitch && ((ref = form.urlInputView) === null || ref === void 0 ? void 0 : ref.fieldView) && editor.plugins.has("ContextualBalloon"));
                    if (wired) {
                        var balloon = editor.plugins.get("ContextualBalloon");
                        var field = form.urlInputView.fieldView;
                        nofollowSwitch.isVisible = false;
                        var url = "";
                        var chosen = false;
                        var autoSponsored = false;
                        var showToggle = function(visible) {
                            var ref;
                            var toggle = (ref = followSwitch.element) === null || ref === void 0 ? void 0 : ref.querySelector(".ck-button__toggle");
                            if (toggle) toggle.style.display = visible ? "" : "none";
                        };
                        var sync = function() {
                            var paidHost = (0,story_links/* isSponsorHref */.P0)(url, sponsorHosts());
                            if (paidHost && !sponsored.value) {
                                autoSponsored = true;
                                sponsored.value = true;
                            } else if (!paidHost && autoSponsored) {
                                autoSponsored = false;
                                sponsored.value = false;
                            }
                            sponsoredSwitch.isEnabled = !paidHost;
                            var paid = paidHost || Boolean(sponsored.value);
                            followSwitch.isEnabled = !paid;
                            followSwitch.label = paid ? PAID_LABEL : FOLLOW_LABEL;
                            showToggle(!paid);
                            if (paid) follow.value = false;
                            else if (!chosen) follow.value = (0,story_links/* isOfficialHref */.oV)(url);
                        };
                        balloon.on("change:visibleView", function(evt, name, view) {
                            if (view !== form) return;
                            url = command.value || "";
                            chosen = Boolean(follow.value || nofollow.value);
                            autoSponsored = false;
                            sync();
                        });
                        field.on("input", function() {
                            url = field.element.value;
                            sync();
                        });
                        followSwitch.on("execute", function() {
                            chosen = true;
                        });
                        sponsored.on("change:value", function() {
                            if (balloon.visibleView === form) sync();
                        });
                    }
                    command.on("execute", function(evt, args) {
                        var ids = args[1];
                        if (!ids || !("linkFollow" in ids)) return;
                        if (ids.linkSponsored || (0,story_links/* isSponsorHref */.P0)(args[0], sponsorHosts())) {
                            args[1] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ids), {
                                linkSponsored: true,
                                linkFollow: false,
                                linkNofollow: false
                            });
                        } else if (wired) {
                            args[1] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ids), {
                                linkNofollow: !ids.linkFollow
                            });
                        } else if (ids.linkFollow && ids.linkNofollow) {
                            args[1] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ids), {
                                linkFollow: false
                            });
                        }
                    }, {
                        priority: "high"
                    });
                }
            }
        ]);
        return StoryLinkRel;
    }();
    return StoryLinkRel;
};

;// CONCATENATED MODULE: ./components/Alert/Newsroom/StoryEditor.js














var StoryEditor_Editor = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9612).then(__webpack_require__.bind(__webpack_require__, 29612));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29612)
            ];
        }
    },
    ssr: false
});
var StoryBodyEditor = function(param) {
    var alert = param.alert, draft = param.draft, onChange = param.onChange;
    var sponsorHosts = (0,react.useRef)([]);
    sponsorHosts.current = (0,story_links/* storySponsorHosts */.Qs)(draft, alert);
    // CKEditor reads its config once, so the plugin reads the hosts through the ref.
    var ref = (0,react.useState)(function() {
        return {
            extraPlugins: [
                storyLinkRelPlugin(function() {
                    return sponsorHosts.current;
                })
            ]
        };
    }), config = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryEditor_Editor, {
        data: draft.body,
        setData: function(value) {
            return onChange("body", value);
        },
        height: "420px",
        link: utils_newsroom/* STORY_LINK_CONFIG */.jA,
        config: config
    });
};
// The Storify template: the news article that sits on top of the raw alert.
var StoryEditor = function(param) {
    var alert = param.alert, researchOn = param.researchOn, story = param.story, draft = param.draft, authors = param.authors, slug = param.slug, published = param.published, dirty = param.dirty, saving = param.saving, uploadingLeadImage = param.uploadingLeadImage, error = param.error, onChange = param.onChange, onSponsorChange = param.onSponsorChange, onSave = param.onSave, onLeadImage = param.onLeadImage, onClose = param.onClose;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("section", {
        className: (Newsroom_module_default()).editor,
        "aria-label": "Story editor",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).editorIntro,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Newsroom_module_default()).kicker,
                        children: "Storify"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The story sits above the raw alert, at this URL. Nothing changes on the public page until you press Publish."
                    }),
                    (story === null || story === void 0 ? void 0 : story.lastEditedByName) && (story === null || story === void 0 ? void 0 : story.lastEditedAt) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Last edited by ",
                            story.lastEditedByName,
                            ",",
                            " ",
                            (0,utils_newsroom/* formatDateTime */.o0)(story.lastEditedAt)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).editorGrid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Newsroom_module_default()).editorMain,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (Newsroom_module_default()).label,
                                htmlFor: "story-headline",
                                children: "Headline (H1)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "story-headline",
                                className: [
                                    (Newsroom_module_default()).input,
                                    (Newsroom_module_default()).headlineInput
                                ].join(" "),
                                value: draft.headline,
                                maxLength: 255,
                                onChange: function(e) {
                                    return onChange("headline", e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (Newsroom_module_default()).label,
                                htmlFor: "story-byline",
                                children: "Byline"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                id: "story-byline",
                                className: (Newsroom_module_default()).input,
                                value: draft.bylineAuthorId,
                                onChange: function(e) {
                                    var id = e.target.value;
                                    var author = authors.find(function(a) {
                                        return String(a.id) === id;
                                    });
                                    onChange("bylineAuthorId", id);
                                    var ref;
                                    onChange("byline", (ref = author === null || author === void 0 ? void 0 : author.name) !== null && ref !== void 0 ? ref : "");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "",
                                        children: "None: shows as Newspage"
                                    }),
                                    authors.map(function(author) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: String(author.id),
                                            children: author.name
                                        }, author.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Newsroom_module_default()).hint,
                                children: "Photo, role, bio and LinkedIn are edited on the author in the CMS."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_LeadImageFields, {
                                story: story,
                                draft: draft,
                                uploading: uploadingLeadImage,
                                onChange: onChange,
                                onUpload: onLeadImage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Newsroom_module_default()).label,
                                children: "Story"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Newsroom_module_default()).hint,
                                children: "Use Heading 2 for subheadings and Heading 3 for FAQ questions, and link to sources and to the experts’ Newspages. Links to official sources (gov.uk, ONS, Bank of England, FCA) are followed, others are nofollow; the “Follow link” switch on each link overrides that. Quotes from the responses below can be fixed for typos, never for meaning."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryBodyEditor, {
                                alert: alert,
                                draft: draft,
                                onChange: onChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_FaqOfferFields, {
                                alert: alert,
                                researchOn: researchOn,
                                story: story,
                                draft: draft,
                                onChange: onChange,
                                onStoryChange: onSponsorChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                        className: (Newsroom_module_default()).editorSide,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_SuggestedLink, {
                                alert: alert
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_SeoPanel, {
                                draft: draft,
                                slug: slug,
                                onChange: onChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_StorySponsorFields, {
                                draft: draft,
                                onChange: onChange,
                                researchOn: researchOn
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_DirectoryTopicsPicker, {
                                alertId: alert.id,
                                published: published
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).editorActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: published ? "Update live story" : "Save draft",
                        theme: "success",
                        loading: saving,
                        disabled: !dirty,
                        onClick: onSave
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        theme: "secondary",
                        title: "Close",
                        onClick: onClose
                    }),
                    dirty && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Newsroom_module_default()).unsaved,
                        children: "Unsaved changes"
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).error,
                role: "alert",
                children: error
            })
        ]
    });
};
/* harmony default export */ var Newsroom_StoryEditor = (StoryEditor);

;// CONCATENATED MODULE: ./components/Alert/Newsroom/RawPanel.js






var rawStatus = function(alert) {
    if (alert.rawAt && !(0,utils_newsroom/* isReleasedRaw */.gI)(alert)) {
        return "A Raw, held out of the archive until ".concat((0,utils_newsroom/* formatDateTime */.o0)(alert.rawExclusiveUntil), ".");
    }
    if (alert.rawAt) {
        var reraw = (0,utils_newsroom/* rerawMarker */.Qr)(alert);
        return "In the Raws archive since ".concat((0,utils_newsroom/* formatDateTime */.o0)(alert.rawAt), ".").concat(reraw ? " ".concat(reraw, ".") : "");
    }
    if (alert.rawReviewedAt) {
        return "Marked Not a Raw on ".concat((0,utils_newsroom/* formatDateTime */.o0)(alert.rawReviewedAt), ".");
    }
    return "Not reviewed yet.";
};
// Raw: brands the alert as a Newspage Raw and adds it to the archive that
// journalists search. A person decides: thin alerts get a second look.
var RawPanel = function(param) {
    var alert = param.alert, responsesCount = param.responsesCount, busy = param.busy, onRaw = param.onRaw, onReraw = param.onReraw, onNotRaw = param.onNotRaw, onClose = param.onClose;
    var ref = (0,react.useState)((0,utils_newsroom/* toLocalInput */.UE)(alert.rawExclusiveUntil)), exclusive = ref[0], setExclusive = ref[1];
    var thin = (0,utils_newsroom/* isThin */.gR)(responsesCount);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Newsroom_module_default()).rawPanel,
        "aria-label": "Raw",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).rawStatus,
                children: rawStatus(alert)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "".concat(responsesCount, " ").concat((0,pluralize/* default */.Z)(responsesCount, "response"), "."),
                    " ",
                    "A Raw should be something you could see a journalist running."
                ]
            }),
            thin && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (Newsroom_module_default()).thinWarning,
                children: [
                    responsesCount === 0 ? "No responses yet." : "Only one response.",
                    " ",
                    "Thin Raws weaken the archive journalists search. Would a journalist run this?"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (Newsroom_module_default()).label,
                htmlFor: "raw-exclusive",
                children: "Keep out of the archive until (optional, for an exclusive)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "raw-exclusive",
                type: "datetime-local",
                className: (Newsroom_module_default()).input,
                value: exclusive,
                onChange: function(e) {
                    return setExclusive(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).rawActions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: alert.rawAt ? "Update Raw" : thin ? "Raw it anyway" : "Make it a Raw",
                        loading: busy === "raw",
                        onClick: function() {
                            return onRaw((0,utils_newsroom/* fromLocalInput */.hr)(exclusive));
                        }
                    }),
                    (0,utils_newsroom/* isReleasedRaw */.gI)(alert) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        theme: "secondary",
                        title: "ReRaw",
                        loading: busy === "reraw",
                        onClick: onReraw
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        theme: "secondary",
                        title: alert.rawAt ? "Remove from Raws" : "Not a Raw",
                        loading: busy === "notRaw",
                        onClick: onNotRaw
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        theme: "secondary",
                        title: "Cancel",
                        onClick: onClose
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Newsroom_RawPanel = (RawPanel);

;// CONCATENATED MODULE: ./components/Alert/Newsroom/index.js
















var Newsroom_FIELDS = [
    "headline",
    "bylineAuthorId",
    "body",
    "seoTitle",
    "metaDescription",
    "focusKeyphrase",
    "sponsorName",
    "sponsorImageUrl",
    "sponsorUrl",
    "sponsorStartsAt",
    "sponsorEndsAt",
    "leadImageAlt",
    "leadImageCaption",
    "leadImageCredit", 
];
var LEAD_IMAGE_MAX_BYTES = 10 * 1024 * 1024;
var ref, ref1, ref2;
var leadImageDraft = function(story) {
    return {
        leadImageAlt: (ref = story === null || story === void 0 ? void 0 : story.leadImageAlt) !== null && ref !== void 0 ? ref : "",
        leadImageCaption: (ref1 = story === null || story === void 0 ? void 0 : story.leadImageCaption) !== null && ref1 !== void 0 ? ref1 : "",
        leadImageCredit: (ref2 = story === null || story === void 0 ? void 0 : story.leadImageCredit) !== null && ref2 !== void 0 ? ref2 : "",
        clearLeadImage: false
    };
};
var editorError = function(message) {
    return Object.assign(new Error(message), {
        editorMessage: message
    });
};
var SPONSOR_DATES = [
    "sponsorStartsAt",
    "sponsorEndsAt"
];
var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
var toDraft = function(story, alert, researchOn) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        headline: (ref4 = (ref3 = story === null || story === void 0 ? void 0 : story.headline) !== null && ref3 !== void 0 ? ref3 : alert.title) !== null && ref4 !== void 0 ? ref4 : "",
        // The byline goes too, so a backend without authors yet keeps the name.
        byline: (ref5 = story === null || story === void 0 ? void 0 : story.byline) !== null && ref5 !== void 0 ? ref5 : "",
        bylineAuthorId: (story === null || story === void 0 ? void 0 : story.bylineAuthorId) ? String(story.bylineAuthorId) : "",
        body: (ref6 = story === null || story === void 0 ? void 0 : story.body) !== null && ref6 !== void 0 ? ref6 : "",
        seoTitle: (ref7 = story === null || story === void 0 ? void 0 : story.seoTitle) !== null && ref7 !== void 0 ? ref7 : "",
        metaDescription: (ref8 = story === null || story === void 0 ? void 0 : story.metaDescription) !== null && ref8 !== void 0 ? ref8 : "",
        focusKeyphrase: (ref9 = story === null || story === void 0 ? void 0 : story.focusKeyphrase) !== null && ref9 !== void 0 ? ref9 : "",
        sponsorName: (ref10 = story === null || story === void 0 ? void 0 : story.sponsorName) !== null && ref10 !== void 0 ? ref10 : "",
        sponsorImageUrl: (ref11 = story === null || story === void 0 ? void 0 : story.sponsorImageUrl) !== null && ref11 !== void 0 ? ref11 : "",
        sponsorUrl: (ref12 = story === null || story === void 0 ? void 0 : story.sponsorUrl) !== null && ref12 !== void 0 ? ref12 : "",
        sponsorStartsAt: (0,utils_newsroom/* toLocalInput */.UE)(story === null || story === void 0 ? void 0 : story.sponsorStartsAt),
        sponsorEndsAt: (0,utils_newsroom/* toLocalInput */.UE)(story === null || story === void 0 ? void 0 : story.sponsorEndsAt)
    }, leadImageDraft(story)), {
        // On by default for a new story; stories from before Evergreen Sponsor keep it off,
        // and so does an alert whose research sponsorship holds its paid slots.
        faqOffer: !alert.isSponsored && (story ? Boolean(story.faqOffer) : !researchOn),
        faqHeading: (ref13 = story === null || story === void 0 ? void 0 : story.faqHeading) !== null && ref13 !== void 0 ? ref13 : "",
        faqQuestions: (0,faq_sponsor/* faqQuestionInputs */.ao)(story === null || story === void 0 ? void 0 : story.faqQuestions)
    });
};
var faqKey = function(draft) {
    return JSON.stringify([
        draft.faqOffer,
        draft.faqHeading.trim(),
        draft.faqQuestions.map(function(q) {
            return q.trim();
        }), 
    ]);
};
// The editor keeps its own HTML; outbound rel is added to what is saved, since
// feeding it back into CKEditor would reset the content on every keystroke.
var toSaved = function(draft) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft), {
        body: (0,utils_newsroom/* withOutboundRel */.mI)(draft.body)
    });
};
// The date inputs hold local time; the API takes ISO.
var toPayload = function(draft) {
    var saved = toSaved(draft);
    SPONSOR_DATES.forEach(function(key) {
        saved[key] = (0,utils_newsroom/* fromLocalInput */.hr)(saved[key]);
    });
    saved.bylineAuthorId = saved.bylineAuthorId ? Number(saved.bylineAuthorId) : null;
    return saved;
};
var RAW_FIELDS = [
    "rawAt",
    "rawExclusiveUntil",
    "rawReviewedAt",
    "rerawAt"
];
var rawPatch = function(alert) {
    return RAW_FIELDS.reduce(function(patch, key) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, patch), (0,_define_property/* default */.Z)({}, key, alert[key]));
    }, {});
};
// Admin only: the Storify, Raw and Publish buttons, and the panels they open.
var Newsroom = function(param) {
    var alert = param.alert, researchOn = param.researchOn, responsesCount = param.responsesCount, onAlertChange = param.onAlertChange, onStoryChange = param.onStoryChange, onEditingChange = param.onEditingChange;
    var dispatch = (0,es/* useDispatch */.I0)();
    // undefined while loading, null when the alert has no story yet.
    var ref = (0,react.useState)(undefined), story = ref[0], setStory = ref[1];
    var ref1 = (0,react.useState)(null), draft = ref1[0], setDraft = ref1[1];
    var ref2 = (0,react.useState)(null), panel = ref2[0], setPanel = ref2[1]; // 'story' | 'raw' | null
    var ref3 = (0,react.useState)(null), busy = ref3[0], setBusy = ref3[1];
    var ref4 = (0,react.useState)(null), notice = ref4[0], setNotice = ref4[1];
    // The body as CKEditor last had it saved or loaded. CKEditor rewrites embeds
    // and the server sanitizes them, so the server's HTML never matches it.
    var ref5 = (0,react.useState)(null), savedBody = ref5[0], setSavedBody = ref5[1];
    var ref6 = (0,react.useState)([]), authors = ref6[0], setAuthors = ref6[1];
    var editorLoaded = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        (0,newsroom/* fetchAuthors */.Ui)().then(setAuthors).catch(function(err) {
            return setNotice({
                type: "error",
                text: (0,newsroom/* newsroomError */.tt)(err, "Could not load the authors. Reload the page before changing the byline.")
            });
        });
    }, []);
    (0,react.useEffect)(function() {
        var live = true;
        setStory(undefined);
        setDraft(null);
        setPanel(null);
        setSavedBody(null);
        editorLoaded.current = false;
        (0,newsroom/* fetchStory */.su)(alert.id).then(function(data) {
            return live && setStory(data !== null && data !== void 0 ? data : null);
        })// "No story yet" comes back as an empty 200, so an error is a real failure.
        // Treating it as no story would let Storify overwrite the one that exists.
        .catch(function(err) {
            return live && setNotice({
                type: "error",
                text: (0,newsroom/* newsroomError */.tt)(err, "Could not load the story. Reload the page before editing it.")
            });
        });
        return function() {
            live = false;
        };
    }, [
        alert.id
    ]);
    (0,react.useEffect)(function() {
        onEditingChange === null || onEditingChange === void 0 ? void 0 : onEditingChange(panel === "story");
    }, [
        panel
    ]);
    var dirty = (0,react.useMemo)(function() {
        if (!draft) return false;
        var saved = toDraft(story, alert, researchOn);
        if (savedBody !== null) saved.body = savedBody;
        var current = toSaved(draft);
        return Newsroom_FIELDS.some(function(f) {
            return (current[f] || "").trim() !== (saved[f] || "").trim();
        }) || faqKey(current) !== faqKey(saved) || current.clearLeadImage;
    }, [
        draft,
        story,
        alert,
        savedBody
    ]);
    // Don't lose a story by closing the tab.
    (0,react.useEffect)(function() {
        if (!dirty) return undefined;
        var warn = function(e) {
            e.preventDefault();
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", warn);
        return function() {
            return window.removeEventListener("beforeunload", warn);
        };
    }, [
        dirty
    ]);
    // One action at a time: a Publish pressed while a Save is still on its way would save
    // again from the version that Save is replacing, and the API would refuse it.
    var inFlight = (0,react.useRef)(false);
    var run = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(key, action, fallback) {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (inFlight.current) return [
                            2,
                            null
                        ];
                        inFlight.current = true;
                        setBusy(key);
                        setNotice(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            action()
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        err = _state.sent();
                        setNotice({
                            type: "error",
                            text: (err === null || err === void 0 ? void 0 : err.editorMessage) || (0,newsroom/* newsroomError */.tt)(err, fallback)
                        });
                        return [
                            2,
                            null
                        ];
                    case 4:
                        inFlight.current = false;
                        setBusy(null);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function run(key, action, fallback) {
            return _ref.apply(this, arguments);
        };
    }();
    var togglePanel = function(name) {
        if (name === "story" && !draft) setDraft(toDraft(story, alert, researchOn));
        setPanel(panel === name ? null : name);
    };
    var change = function(field, value) {
        // The first body the editor reports is the loaded story, not an edit.
        if (field === "body" && !editorLoaded.current) {
            editorLoaded.current = true;
            setSavedBody((0,utils_newsroom/* withOutboundRel */.mI)(value));
        }
        setDraft(function(current) {
            return current[field] === value ? current : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current), (0,_define_property/* default */.Z)({}, field, value));
        });
    };
    var persist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var message, sent, saved, _faqHeading;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ((0,faq_sponsor/* faqIncomplete */.v7)(draft)) {
                            message = "Add an FAQ heading and at least one question, or untick the FAQ sponsorship offer.";
                            throw Object.assign(new Error(message), {
                                editorMessage: message
                            });
                        }
                        if ((story === null || story === void 0 ? void 0 : story.leadImageUrl) && !draft.clearLeadImage && !draft.leadImageAlt.trim()) {
                            throw editorError("Add alt text for the lead image, or remove the image.");
                        }
                        sent = toPayload(draft);
                        return [
                            4,
                            (0,newsroom/* saveStory */.mY)(alert.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sent), {
                                version: story ? story.version : null
                            }))
                        ];
                    case 1:
                        saved = _state.sent();
                        setStory(saved);
                        setSavedBody(sent.body);
                        // The API drops blank questions, so the draft takes its saved order back.
                        setDraft(function(current) {
                            return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current), {
                                faqHeading: (_faqHeading = saved.faqHeading) !== null && _faqHeading !== void 0 ? _faqHeading : "",
                                faqQuestions: (0,faq_sponsor/* faqQuestionInputs */.ao)(saved.faqQuestions)
                            }), leadImageDraft(saved));
                        });
                        if (saved.publishedAt) onStoryChange(saved);
                        return [
                            2,
                            saved
                        ];
                }
            });
        });
        return function persist() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSave = function() {
        return run("save", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var saved;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            persist()
                        ];
                    case 1:
                        saved = _state.sent();
                        setNotice({
                            type: "ok",
                            text: saved.publishedAt ? "Saved. The live story is updated." : "Draft saved. Press Publish when it is ready."
                        });
                        return [
                            2
                        ];
                }
            });
        }), "Could not save the story.");
    };
    var handleLeadImage = function(file) {
        return run("leadImage", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var saved;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!draft.leadImageAlt.trim()) {
                            throw editorError("Write the alt text before uploading.");
                        }
                        if (file.size > LEAD_IMAGE_MAX_BYTES) {
                            throw editorError("The lead image must be 10 MB or smaller.");
                        }
                        if (!!story) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            persist()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0,newsroom/* uploadLeadImage */.q6)(alert.id, file, draft)
                        ];
                    case 3:
                        saved = _state.sent();
                        setStory(saved);
                        setDraft(function(current) {
                            return (0,_object_spread/* default */.Z)({}, current, leadImageDraft(saved));
                        });
                        if (saved.publishedAt) onStoryChange(saved);
                        setNotice({
                            type: "ok",
                            text: saved.publishedAt ? "Lead image saved. The live story shows it." : "Lead image saved to the draft."
                        });
                        return [
                            2
                        ];
                }
            });
        }), "Could not upload the lead image.");
    };
    var publish = function() {
        return run("publish", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var published;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(draft && dirty)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            persist()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            (0,newsroom/* publishStory */.W3)(alert.id)
                        ];
                    case 3:
                        published = _state.sent();
                        setStory(published);
                        onStoryChange(published);
                        onAlertChange({
                            newsIndex: true
                        });
                        setPanel(null);
                        setNotice({
                            type: "ok",
                            text: "Published. The story is live above the raw alert and in the Google News sitemap."
                        });
                        return [
                            2
                        ];
                }
            });
        }), "Could not publish the story.");
    };
    var seededBy = alert.rawAt ? alert.seededBy : null;
    var handlePublish = function() {
        var body = draft ? draft.body : story === null || story === void 0 ? void 0 : story.body;
        if (!seededBy || (0,utils_newsroom/* namesExpert */.kD)(body, seededBy.name)) return publish();
        dispatch((0,ux/* handleShowPopup */.YF)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            title: "".concat(seededBy.name, " is not named in the story"),
            body: "This Raw was seeded by them, so they must be quoted. Publish anyway?",
            confirmTitle: "Publish anyway",
            cancelTitle: "Back to the story",
            onCancel: function() {
                return dispatch((0,ux/* handleHidePopup */.Zi)());
            },
            onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch((0,ux/* setPopupLoading */.BI)(true));
                            return [
                                4,
                                publish()
                            ];
                        case 1:
                            _state.sent();
                            dispatch((0,ux/* setPopupLoading */.BI)(false));
                            dispatch((0,ux/* handleHidePopup */.Zi)());
                            return [
                                2
                            ];
                    }
                });
            })
        }));
    };
    var handleUnpublish = function() {
        dispatch((0,ux/* handleShowPopup */.YF)());
        dispatch((0,ux/* setPopupConfig */.iH)({
            title: "Unpublish the story?",
            body: "The raw alert stays live, and the story is kept as a draft.",
            confirmTitle: "Unpublish",
            cancelTitle: "Cancel",
            onCancel: function() {
                return dispatch((0,ux/* handleHidePopup */.Zi)());
            },
            onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch((0,ux/* setPopupLoading */.BI)(true));
                            return [
                                4,
                                run("publish", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    var story;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    (0,newsroom/* unpublishStory */.NB)(alert.id)
                                                ];
                                            case 1:
                                                story = _state.sent();
                                                setStory(story);
                                                onStoryChange(null);
                                                onAlertChange({
                                                    newsIndex: false
                                                });
                                                setNotice({
                                                    type: "ok",
                                                    text: "Story unpublished. It is saved as a draft."
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }), "Could not unpublish the story.")
                            ];
                        case 1:
                            _state.sent();
                            dispatch((0,ux/* setPopupLoading */.BI)(false));
                            dispatch((0,ux/* handleHidePopup */.Zi)());
                            return [
                                2
                            ];
                    }
                });
            })
        }));
    };
    var handleRaw = function(exclusiveUntil) {
        return run("raw", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var updated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,newsroom/* markRaw */.Xl)(alert.id, exclusiveUntil)
                        ];
                    case 1:
                        updated = _state.sent();
                        onAlertChange(rawPatch(updated));
                        setPanel(null);
                        setNotice({
                            type: "ok",
                            text: exclusiveUntil ? "Branded a Newspage Raw. It joins the archive when the exclusive ends." : "Branded a Newspage Raw and added to the Raws archive."
                        });
                        return [
                            2
                        ];
                }
            });
        }), "Could not make this a Raw.");
    };
    var handleReraw = function() {
        return run("reraw", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var updated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,newsroom/* markReraw */.BV)(alert.id)
                        ];
                    case 1:
                        updated = _state.sent();
                        onAlertChange(rawPatch(updated));
                        setPanel(null);
                        setNotice({
                            type: "ok",
                            text: "ReRawed. It is back at the top of the Raws archive."
                        });
                        return [
                            2
                        ];
                }
            });
        }), "Could not ReRaw this alert.");
    };
    var handleNotRaw = function() {
        return run("notRaw", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var updated;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,newsroom/* markNotRaw */.To)(alert.id)
                        ];
                    case 1:
                        updated = _state.sent();
                        onAlertChange(rawPatch(updated));
                        setPanel(null);
                        setNotice({
                            type: "ok",
                            text: "Marked Not a Raw. It is out of the archive and the review queue."
                        });
                        return [
                            2
                        ];
                }
            });
        }), "Could not update this alert.");
    };
    var published = Boolean(story === null || story === void 0 ? void 0 : story.publishedAt);
    var loading = story === undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Newsroom_module_default()).newsroom,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).bar,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: panel === "story" ? "Close story" : story ? "Edit story" : "Storify",
                        theme: panel === "story" ? "secondary" : "primary",
                        disabled: loading,
                        onClick: function() {
                            return togglePanel("story");
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: alert.rawAt ? "Raw ✓" : "Raw",
                        theme: alert.rawAt ? "success" : "primary",
                        onClick: function() {
                            return togglePanel("raw");
                        }
                    }),
                    published ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: "Unpublish story",
                        theme: "danger",
                        loading: busy === "publish",
                        onClick: handleUnpublish
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: "Publish",
                        theme: "success",
                        loading: busy === "publish",
                        disabled: loading || !story && !dirty,
                        onClick: handlePublish
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Newsroom_module_default()).barStatus,
                        children: loading ? "Loading story…" : published ? "Story live" : story ? "Story draft saved" : "No story yet"
                    })
                ]
            }),
            notice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: notice.type === "error" ? (Newsroom_module_default()).error : (Newsroom_module_default()).ok,
                role: notice.type === "error" ? "alert" : "status",
                children: notice.text
            }),
            panel === "raw" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_RawPanel, {
                alert: alert,
                responsesCount: responsesCount,
                busy: busy,
                onRaw: handleRaw,
                onReraw: handleReraw,
                onNotRaw: handleNotRaw,
                onClose: function() {
                    return setPanel(null);
                }
            }),
            panel === "story" && draft && seededBy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).sourceReminder,
                role: "note",
                children: "This Raw was seeded by ".concat((0,utils_newsroom/* sourceCredit */.sX)(seededBy), ". They must be quoted in the story.")
            }),
            panel === "story" && draft && /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_StoryEditor, {
                alert: alert,
                researchOn: researchOn,
                story: story,
                draft: draft,
                authors: authors,
                slug: alert.slug,
                published: published,
                dirty: dirty,
                saving: busy === "save",
                uploadingLeadImage: busy === "leadImage",
                onLeadImage: handleLeadImage,
                error: (notice === null || notice === void 0 ? void 0 : notice.type) === "error" ? notice.text : null,
                onChange: change,
                onSponsorChange: function(saved) {
                    setStory(saved);
                    if (saved.publishedAt) onStoryChange(saved);
                },
                onSave: handleSave,
                onClose: function() {
                    return setPanel(null);
                }
            })
        ]
    });
};
/* harmony default export */ var Alert_Newsroom = (Newsroom);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./utils/news-article-schema.js
var news_article_schema = __webpack_require__(72638);
// EXTERNAL MODULE: ./utils/profile-seo.js
var profile_seo = __webpack_require__(88300);
;// CONCATENATED MODULE: ./utils/lead-image.js

var httpUrl = function(value) {
    var text = (0,profile_seo/* clean */.ru)(value);
    return /^https?:\/\/\S+$/i.test(text) ? text : "";
};
// Google's article structured data asks for 16:9, 4:3 and 1:1, widest first.
var RATIOS = [
    "16x9",
    "4x3",
    "1x1"
];
// The story's lead image as the page and its metadata use it, or null when it
// has none (or no alt text, which the API requires with every image).
function leadImage(story) {
    var url = httpUrl(story === null || story === void 0 ? void 0 : story.leadImageUrl);
    var alt = (0,profile_seo/* clean */.ru)(story === null || story === void 0 ? void 0 : story.leadImageAlt);
    if (!url || !alt) {
        return null;
    }
    var crops = story.leadImageCrops || {};
    return {
        wide: httpUrl(crops["16x9"]),
        url: url,
        alt: alt,
        width: Number(story.leadImageWidth) || undefined,
        height: Number(story.leadImageHeight) || undefined,
        caption: (0,profile_seo/* clean */.ru)(story.leadImageCaption),
        credit: (0,profile_seo/* clean */.ru)(story.leadImageCredit),
        crops: RATIOS.map(function(ratio) {
            return httpUrl(crops[ratio]);
        }).filter(Boolean)
    };
}
// NewsArticle image: the three crops, or the one copy when they are missing.
var leadImageSchema = function(image) {
    return image.crops.length ? image.crops : [
        image.url
    ];
};
// og:image is the 16:9 crop, 1200x675 by construction, so the share card shows
// a predictable picture whatever the photo's own shape.
var leadImageOg = function(image) {
    return image.wide ? {
        url: image.wide,
        width: 1200,
        height: 675,
        alt: image.alt
    } : {
        url: image.url,
        width: image.width,
        height: image.height,
        alt: image.alt
    };
};

;// CONCATENATED MODULE: ./components/Alert/Newsroom/ExpertAnswers.js



// Paid placement, so every link in it says so to search engines.
var SPONSORED_REL = "sponsored nofollow";
// The API only stores web addresses; this keeps any other scheme out of an href.
var webHref = function(url) {
    return /^https?:\/\//i.test(url || "") ? url : null;
};
// Evergreen Sponsor: the story's five questions, answered by the expert who
// paid for the slot. Rendered on the server with the story; no FAQPage
// markup, since Google keeps FAQ results for government and health sites and
// this is sponsored content.
var ExpertAnswers = function(param) {
    var answers = param.answers;
    var heading = answers.heading, items = answers.items, sponsor = answers.sponsor;
    var website = webHref(sponsor.website);
    var firm = (0,faq_sponsor/* websiteLabel */.XO)(sponsor.firm, website);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Newsroom_module_default()).expertAnswers,
        "aria-label": "Expert answers",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Newsroom_module_default()).sponsoredLabel,
                children: "Sponsored"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (Newsroom_module_default()).expertAnswersHeading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (Newsroom_module_default()).expertAnswersIntro,
                children: [
                    "Answers from",
                    " ",
                    sponsor.profileSlug ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/".concat(encodeURIComponent(sponsor.profileSlug)),
                        rel: SPONSORED_REL,
                        children: sponsor.name
                    }) : sponsor.name,
                    sponsor.role && ", ".concat(sponsor.role),
                    firm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            " at ",
                            website ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: website,
                                rel: SPONSORED_REL,
                                children: firm
                            }) : firm
                        ]
                    })
                ]
            }),
            items.map(function(param) {
                var question = param.question, answer = param.answer;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Newsroom_module_default()).expertAnswer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: question
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: answer
                        })
                    ]
                }, question);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Newsroom_module_default()).expertAnswersNote,
                children: "These answers are general information, not financial advice."
            })
        ]
    });
};
/* harmony default export */ var Newsroom_ExpertAnswers = (ExpertAnswers);

;// CONCATENATED MODULE: ./components/Alert/Newsroom/StorySponsor.js


// One ad per page, labelled, at a fixed size so nothing shifts as it loads.
var StorySponsor = function(param) {
    var sponsor = param.sponsor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: (Newsroom_module_default()).storySponsor,
        "aria-label": "Advertisement",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Newsroom_module_default()).storySponsorLabel,
                children: "Advertisement"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: sponsor.url,
                target: "_blank",
                rel: "sponsored noopener",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: sponsor.imageUrl,
                    alt: "Advertisement: ".concat(sponsor.name),
                    width: 728,
                    height: 90
                })
            })
        ]
    });
};
/* harmony default export */ var Newsroom_StorySponsor = (StorySponsor);

// EXTERNAL MODULE: ./components/Alert/Newsroom/AuthorBlock.js
var AuthorBlock = __webpack_require__(30694);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./styles/modules/newsAlert/ResearchSponsor.module.scss
var ResearchSponsor_module = __webpack_require__(94013);
var ResearchSponsor_module_default = /*#__PURE__*/__webpack_require__.n(ResearchSponsor_module);
;// CONCATENATED MODULE: ./components/Alert/ResearchSponsorBox.js













var copy = en/* news_alerts.research_sponsor */.RA.qh;
// The API only stores web addresses; this keeps any other scheme out of an href.
var ResearchSponsorBox_webHref = function(url) {
    return /^https?:\/\//i.test(url || "") ? url : null;
};
// Paid credit, so the link says so to search engines. Shown at the top of the alert and
// under the story byline, where the box promises the sponsor's name.
var ResearchCredit = function(param) {
    var name = param.name, website = param.website;
    var href = ResearchSponsorBox_webHref(website);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (ResearchSponsor_module_default()).credit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (ResearchSponsor_module_default()).creditLabel,
                children: copy.sold
            }),
            " ",
            href ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "sponsored nofollow noopener",
                children: name
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: name
            })
        ]
    });
};
// The price under an open alert's headline, so experts who never scroll to the box see
// it (Asana 1220157993244795). Asked for on mount: the cached page doesn't carry it.
// `loginHref`: where a logged-out visitor goes, since the box is for members only.
var ResearchStrip = function(param) {
    var alertId = param.alertId, loginHref = param.loginHref, deadline = param.deadline;
    var ref = (0,react.useState)(null), strip = ref[0], setStrip = ref[1];
    var ref1 = (0,react.useState)(false), ended = ref1[0], setEnded = ref1[1];
    (0,react.useEffect)(function() {
        (0,research_sponsorship/* fetchResearchStrip */.iE)(alertId).then(setStrip).catch(function() {});
    }, [
        alertId
    ]);
    // The countdown closes the alert only if it ticks on the exact second, which a
    // throttled background tab can miss. Over ~24 days setTimeout overflows and fires at once.
    (0,react.useEffect)(function() {
        var left = new Date(deadline) - Date.now();
        setEnded(left <= 0);
        if (!(left > 0 && left < Math.pow(2, 31) - 1)) return;
        var timer = setTimeout(function() {
            return setEnded(true);
        }, left);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        deadline
    ]);
    if (!(strip === null || strip === void 0 ? void 0 : strip.price) || ended) return null;
    var toBox = function(event) {
        var ref;
        var box = (ref = document.getElementById("research-sponsor")) === null || ref === void 0 ? void 0 : ref.closest("aside");
        if (!box) return;
        event.preventDefault();
        box.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    return(// The price must stay out of Google's snippets and AI answers.
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ResearchSponsor_module_default()).strip,
        "data-nosnippet": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    copy.strip,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            (0,research_sponsor/* priceLabel */.gX)(strip.price),
                            "+VAT"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: [
                    "button",
                    "button__primary",
                    (ResearchSponsor_module_default()).stripButton, 
                ].join(" "),
                href: loginHref || "#research-sponsor",
                onClick: loginHref ? undefined : toBox,
                children: loginHref ? copy.strip_more_login : copy.strip_more
            })
        ]
    }));
};
var EMPTY = {
    sponsorName: "",
    website: "",
    email: ""
};
var GONE = [
    "RESERVED",
    "SOLD",
    "NOT_OFFERED"
];
var RESUME_WAIT_MS = 10000;
// `resume`: the buyer's stored reservation with what they last sent, so going
// back to their checkout needs no second form.
var ReserveForm = function(param) {
    var alertId = param.alertId, resume = param.resume, onRefresh = param.onRefresh;
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var ref;
    var ref1 = (0,react.useState)((ref = resume === null || resume === void 0 ? void 0 : resume.fields) !== null && ref !== void 0 ? ref : EMPTY), fields = ref1[0], setFields = ref1[1];
    var ref2 = (0,react.useState)(!(resume === null || resume === void 0 ? void 0 : resume.fields)), showForm = ref2[0], setShowForm = ref2[1];
    var ref3 = (0,react.useState)(null), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var resumed = (0,react.useRef)(false);
    var reserve = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var ref, result, _tmp, _tmp1, err, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        _tmp = [
                            alertId
                        ];
                        _tmp1 = {
                            sponsorName: values.sponsorName,
                            website: values.website.trim() || null,
                            email: values.email
                        };
                        return [
                            4,
                            executeRecaptcha("research_sponsor")
                        ];
                    case 2:
                        return [
                            4,
                            research_sponsorship/* reserveResearchSponsorship.apply */.io.apply(void 0, _tmp.concat((_tmp1.recaptchaToken = _state.sent(), _tmp1.reservationToken = ((ref = (0,research_sponsor/* storedReservation */.FS)(alertId)) === null || ref === void 0 ? void 0 : ref.reservationToken) || undefined, _tmp1)))
                        ];
                    case 3:
                        result = _state.sent();
                        if (result === null || result === void 0 ? void 0 : result.url) {
                            (0,research_sponsor/* storeReservation */.XE)(alertId, result.reservationToken, values);
                            window.location.assign(result.url);
                            return [
                                2
                            ];
                        }
                        // This buyer's earlier checkout had already gone through.
                        (0,research_sponsor/* forgetReservation */.df)(alertId);
                        onRefresh();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        setError((0,research_sponsor/* reserveErrorMessage */.KA)(err === null || err === void 0 ? void 0 : err.response));
                        setShowForm(true);
                        if (GONE.includes(err === null || err === void 0 ? void 0 : (ref1 = err.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.code)) {
                            (0,research_sponsor/* forgetReservation */.df)(alertId);
                            onRefresh();
                        }
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function reserve(values) {
            return _ref.apply(this, arguments);
        };
    }();
    // The reCAPTCHA script loads after mount; resume as soon as it is ready.
    (0,react.useEffect)(function() {
        if (!(resume === null || resume === void 0 ? void 0 : resume.fields) || !executeRecaptcha || resumed.current) return;
        resumed.current = true;
        reserve(resume.fields);
    }, [
        executeRecaptcha
    ]);
    // A script that never loads (blocked, offline) must not leave the buyer waiting.
    (0,react.useEffect)(function() {
        if (!(resume === null || resume === void 0 ? void 0 : resume.fields)) return;
        var timer = setTimeout(function() {
            if (resumed.current) return;
            resumed.current = true;
            setError(copy.spam_check_slow);
            setShowForm(true);
        }, RESUME_WAIT_MS);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    var set = function(field) {
        return function(e) {
            return setFields((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields), (0,_define_property/* default */.Z)({}, field, e.target.value)));
        };
    };
    var submit = function(e) {
        e.preventDefault();
        if (!executeRecaptcha) {
            setError(copy.form_loading);
            return;
        }
        reserve(fields);
    };
    if (!showForm) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (ResearchSponsor_module_default()).small,
            role: "status",
            children: copy.resuming
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: (ResearchSponsor_module_default()).form,
        onSubmit: submit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (ResearchSponsor_module_default()).field,
                children: [
                    copy.name,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        required: true,
                        maxLength: 120,
                        autoComplete: "organization",
                        value: fields.sponsorName,
                        onChange: set("sponsorName")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (ResearchSponsor_module_default()).field,
                children: [
                    copy.website,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        maxLength: 500,
                        inputMode: "url",
                        autoComplete: "url",
                        placeholder: "https://",
                        value: fields.website,
                        onChange: set("website")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (ResearchSponsor_module_default()).field,
                children: [
                    copy.email,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        required: true,
                        type: "email",
                        maxLength: 255,
                        autoComplete: "email",
                        value: fields.email,
                        onChange: set("email")
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ResearchSponsor_module_default()).error,
                role: "alert",
                children: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: copy.submit,
                theme: "primary",
                loading: loading
            })
        ]
    });
};
// The offer is for logged-in experts only, so the cached alert page never carries
// it: the box asks for it on mount and whenever the tab comes back, and shows
// nothing until the API answers with one.
var ResearchSponsorBox = function(param) {
    var alertId = param.alertId;
    var ref = (0,react.useState)(null), live = ref[0], setLive = ref[1];
    var ref1 = (0,react.useState)(null), stored = ref1[0], setStored = ref1[1];
    // 'form' or 'resume' once the buyer has asked; reCAPTCHA loads only then.
    var ref2 = (0,react.useState)(null), open = ref2[0], setOpen = ref2[1];
    var refresh = (0,react.useCallback)(function() {
        setStored((0,research_sponsor/* storedReservation */.FS)(alertId));
        (0,research_sponsorship/* fetchResearchOffer */.Pg)(alertId).then(setLive).catch(function() {});
    }, [
        alertId
    ]);
    (0,react.useEffect)(function() {
        refresh();
        var onVisible = function() {
            if (document.visibilityState === "visible") refresh();
        };
        document.addEventListener("visibilitychange", onVisible);
        return function() {
            return document.removeEventListener("visibilitychange", onVisible);
        };
    }, [
        refresh
    ]);
    // A sale is credited at the top of the page from the public data.
    var view = (0,research_sponsor/* researchBoxView */.mf)(live, Boolean(stored));
    var shown = Boolean(view) && view !== "sold";
    // The email's button lands here after the login; the box only exists once the
    // offer has loaded, so the browser's own jump to #research-sponsor misses it.
    (0,react.useEffect)(function() {
        if (shown && window.location.hash === "#research-sponsor") {
            var ref, ref1;
            (ref1 = (ref = document.getElementById("research-sponsor")) === null || ref === void 0 ? void 0 : ref.closest("aside")) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView();
        }
    }, [
        shown
    ]);
    if (!shown) return null;
    return(// The sales pitch must not become the search snippet for the alert.
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: (ResearchSponsor_module_default()).box,
        "aria-labelledby": "research-sponsor",
        "data-nosnippet": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "research-sponsor",
                className: (ResearchSponsor_module_default()).heading,
                children: copy.heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ResearchSponsor_module_default()).text,
                children: live.researchDetail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ResearchSponsor_module_default()).includes,
                children: copy.includes
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (ResearchSponsor_module_default()).list,
                children: copy.benefits.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: item
                    }, item);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            copy.cost_label,
                            " ",
                            (0,research_sponsor/* priceLabel */.gX)(live.price)
                        ]
                    }),
                    " ",
                    copy.cost
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ResearchSponsor_module_default()).small,
                children: copy.decline
            }),
            view === "reserved" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ResearchSponsor_module_default()).reserved,
                role: "status",
                children: copy.reserved
            }),
            view === "available" && !open && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: (stored === null || stored === void 0 ? void 0 : stored.fields) ? copy.resume : copy.open,
                theme: "primary",
                onClick: function() {
                    return setOpen((stored === null || stored === void 0 ? void 0 : stored.fields) ? "resume" : "form");
                }
            }),
            view === "available" && open && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                reCaptchaKey: "6Lc2t9EiAAAAAH2646UgmZyx4Sg0jMmuSVpvkCul",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReserveForm, {
                    alertId: alertId,
                    resume: open === "resume" ? stored : null,
                    onRefresh: refresh
                })
            })
        ]
    }));
};
/* harmony default export */ var Alert_ResearchSponsorBox = (ResearchSponsorBox);

;// CONCATENATED MODULE: ./components/Alert/Newsroom/Story.js

























var PUBLISHER = {
    "@type": "Organization",
    name: "Newspage",
    url: "https://newspage.media",
    logo: {
        "@type": "ImageObject",
        url: "".concat("https://app.newspage.media", "/newspage.png")
    }
};
// Not safeHtml: that one rewrites every outbound rel to "nofollow noopener",
// which would drop the follow an editor chose and the rel="sponsored" paid links need.
var cleanStoryHtml = function(html) {
    var sponsorHosts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return sanitize_html_default()((0,utils_newsroom/* faqQuestionsBelowHeading */.il)(html || ""), {
        transformTags: {
            a: (0,story_links/* storyLinkTransform */.JK)(sponsorHosts),
            iframe: function(tagName, attribs) {
                return {
                    tagName: tagName,
                    attribs: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attribs), {
                        src: (0,utils_newsroom/* privateYoutubeSrc */.VG)(attribs.src),
                        loading: "lazy",
                        title: "Video"
                    })
                };
            },
            div: function(tagName, attribs) {
                return {
                    tagName: tagName,
                    attribs: (0,utils_newsroom/* isYoutubeShort */.Lh)(attribs["data-oembed-url"]) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attribs), {
                        class: "video-short"
                    }) : attribs
                };
            },
            // CKEditor's dropdown calls <h3> "Heading 2" (its "Heading 1" is
            // <h2>), so the subheadings editors pick sat a level below the H1.
            h3: "h2",
            h4: "h3"
        },
        allowedTags: sanitize_html_default().defaults.allowedTags.concat([
            "img",
            "iframe",
            "ins", 
        ]),
        allowedAttributes: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (sanitize_html_default()).defaults.allowedAttributes), {
            a: [
                "href",
                "name",
                "target",
                "rel"
            ],
            img: [
                "src",
                "srcset",
                "sizes",
                "alt",
                "width",
                "height"
            ],
            iframe: [
                "src",
                "width",
                "height",
                "allow",
                "allowfullscreen",
                "loading",
                "title", 
            ],
            figure: [
                "class"
            ],
            "*": [
                "style"
            ]
        }),
        allowedClasses: {
            div: [
                "video-short"
            ]
        },
        allowedStyles: {
            "*": {
                "text-align": [
                    /^(left|right|center|justify)$/
                ]
            }
        },
        allowedIframeHostnames: [
            "www.youtube.com",
            "www.youtube-nocookie.com",
            "player.vimeo.com", 
        ]
    });
};
// A story is published at its alert's address.
var storyUrl = function(slug) {
    return (0,alert_url/* alertUrl */.v)(slug);
};
// NewsArticle structured data, so Google reads the page as a news story whose
// source material (the alert and every response) sits below it. The byline is
// the author; the quoted experts are the people the story mentions.
var newsArticleJsonLd = function(story, alert, responses, videoDates) {
    var url = storyUrl(alert.slug);
    var lead = leadImage(story);
    var image = (0,utils_newsroom/* firstImage */.UK)(story.body);
    var mentions = (0,news_article_schema/* expertPersons */.Fv)(responses, "https://app.newspage.media");
    var description = story.metaDescription || excerptFrom(story.body);
    var videos = (0,news_article_schema/* storyVideos */.xO)(story.body, videoDates, {
        headline: story.headline,
        description: description,
        savedAt: story.updatedAt || story.publishedAt
    });
    return (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        headline: story.headline,
        description: description,
        url: url,
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        datePublished: story.publishedAt,
        dateModified: story.updatedAt || story.publishedAt,
        author: (0,news_article_schema/* bylineAuthor */.PE)(story, "https://app.newspage.media") || {
            "@type": "Organization",
            name: "Newspage",
            url: PUBLISHER.url
        },
        publisher: PUBLISHER,
        image: lead ? leadImageSchema(lead) : [
            image || "".concat("https://app.newspage.media", "/newspage.png")
        ],
        isAccessibleForFree: true
    }, mentions.length ? {
        mentions: mentions
    } : {}, videos.length ? {
        video: videos
    } : {});
};
// The published story, above the raw alert it was written from.
var Story = function(param) {
    var story = param.story, alert = param.alert, responses = param.responses, videoDates = param.videoDates;
    var ref, ref1;
    var _asReportedBy;
    // The API already keeps http(s) only; checked again because these become hrefs.
    var reportedBy = ((_asReportedBy = alert.asReportedBy) !== null && _asReportedBy !== void 0 ? _asReportedBy : []).filter(function(item) {
        return /^https?:\/\//i.test(item.url);
    });
    var ref2 = (0,react.useState)(false), copied = ref2[0], setCopied = ref2[1];
    var isAuthenticated = (0,es/* useSelector */.v9)(auth/* authSelector */.aF).isAuthenticated;
    var sponsor = liveSponsor(story);
    var lead = leadImage(story);
    var author = story.bylineAuthor;
    var authorPhoto = (0,news_article_schema/* webUrl */.wo)(author === null || author === void 0 ? void 0 : author.photoUrl);
    var role = author && (0,AuthorBlock/* authorRole */.T)(author);
    var research = ((ref = alert.researchSponsorship) === null || ref === void 0 ? void 0 : ref.status) === "sold" ? alert.researchSponsorship : null;
    var bodyHtml = cleanStoryHtml(story.body, (0,story_links/* storySponsorHosts */.Qs)(story, alert));
    var updated = story.updatedAt && (0,utils_newsroom/* formatDate */.p6)(story.updatedAt) !== (0,utils_newsroom/* formatDate */.p6)(story.publishedAt);
    var handleCopy = function() {
        copyFormatted((0,utils_newsroom/* storyCopyHtml */.cr)(story.headline, bodyHtml, alert.slug));
        setCopied(true);
        setTimeout(function() {
            return setCopied(false);
        }, 1000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: (0,safe_html/* jsonLd */.oL)(newsArticleJsonLd(story, alert, responses, videoDates))
                    }
                }, "news-article-jsonld")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (Newsroom_module_default()).story,
                children: [
                    sponsor && /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_StorySponsor, {
                        sponsor: sponsor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                        variant: "h1",
                        className: (Newsroom_module_default()).storyHeadline,
                        children: story.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Newsroom_module_default()).storyMetaRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Newsroom_module_default()).storyMeta,
                                children: [
                                    authorPhoto && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (Newsroom_module_default()).bylinePhoto,
                                        src: authorPhoto,
                                        alt: "",
                                        width: 32,
                                        height: 32
                                    }),
                                    "By",
                                    " ",
                                    author ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (0,news_article_schema/* authorPath */.tw)(author.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: author.name
                                        })
                                    }) : story.byline || "Newspage",
                                    role && ", ".concat(role),
                                    " \xb7",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                        dateTime: story.publishedAt,
                                        children: (0,utils_newsroom/* formatDate */.p6)(story.publishedAt)
                                    }),
                                    updated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ",
                                            "\xb7 Updated",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                dateTime: story.updatedAt,
                                                children: (0,utils_newsroom/* formatDate */.p6)(story.updatedAt)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: (Newsroom_module_default()).copyStory,
                                onClick: copied ? undefined : handleCopy,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote2/* default */.Z, {
                                        fill: "currentColor"
                                    }),
                                    copied ? "Copied" : "Copy story"
                                ]
                            })
                        ]
                    }),
                    (research === null || research === void 0 ? void 0 : research.sponsorName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchCredit, {
                        name: research.sponsorName,
                        website: research.sponsorWebsite
                    }),
                    lead && /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                        className: (Newsroom_module_default()).leadImage,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: lead.url,
                                alt: lead.alt,
                                width: lead.width,
                                height: lead.height
                            }),
                            (lead.caption || lead.credit) && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                children: [
                                    lead.caption,
                                    lead.credit
                                ].filter(Boolean).join(" \xb7 ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Newsroom_module_default()).storyBody,
                        dangerouslySetInnerHTML: {
                            __html: bodyHtml
                        }
                    }),
                    author && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorBlock/* default */.Z, {
                        author: author
                    })
                ]
            }),
            reportedBy.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (Newsroom_module_default()).reportedBy,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "As reported by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: reportedBy.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: item.url,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: item.outlet || (0,utils_newsroom/* hostname */.Kn)(item.url)
                                            }),
                                            item.title && ": ".concat(item.title)
                                        ]
                                    }),
                                    item.date && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " \xb7 ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                dateTime: item.date,
                                                children: (0,utils_newsroom/* formatDate */.p6)(item.date)
                                            })
                                        ]
                                    })
                                ]
                            }, item.url);
                        })
                    })
                ]
            }),
            story.expertAnswers && /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_ExpertAnswers, {
                answers: story.expertAnswers
            }),
            ((ref1 = alert.relatedStories) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (Newsroom_module_default()).related,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Related stories"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: alert.relatedStories.map(function(related) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (0,alert_url/* alertPath */.E)(related.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: related.headline
                                        })
                                    }),
                                    " \xb7 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                        dateTime: related.publishedAt,
                                        children: (0,utils_newsroom/* formatDate */.p6)(related.publishedAt)
                                    })
                                ]
                            }, related.slug);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Newsroom_module_default()).rawDivider,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        id: "raw-alert",
                        children: "The raw alert"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The question we put to Newspage’s experts, and their answers."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Newsroom_Story = (Story);

;// CONCATENATED MODULE: ./components/Alert/Newsroom/RawBadge.js




// Brands an alert as a Newspage Raw and links to the archive. A ReRawed alert
// says so, since its own date can be months old.
var RawBadge = function(param) {
    var alert = param.alert;
    var reraw = (0,utils_newsroom/* rerawMarker */.Qr)(alert);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/raws",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (Newsroom_module_default()).rawBadge,
                    title: "Browse the Newspage Raws archive",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Newspage Raw"
                    })
                })
            }),
            reraw && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Newsroom_module_default()).rerawMarker,
                children: reraw
            })
        ]
    });
};
/* harmony default export */ var Newsroom_RawBadge = (RawBadge);

// EXTERNAL MODULE: ./components/Alert/Newsroom/SourceCredit.js
var SourceCredit = __webpack_require__(844);
// EXTERNAL MODULE: ./components/RawTags.js
var RawTags = __webpack_require__(43893);
// EXTERNAL MODULE: ./api/coverage-submissions.js
var coverage_submissions = __webpack_require__(75148);
// EXTERNAL MODULE: ./styles/modules/newsAlert/RanThis.module.scss
var RanThis_module = __webpack_require__(54537);
var RanThis_module_default = /*#__PURE__*/__webpack_require__.n(RanThis_module);
;// CONCATENATED MODULE: ./components/Alert/RanThis.js









// Emails can link to #ran-this, or pass ?ran=<url> to pre-fill the field.
var RanThis = function(param) {
    var alertId = param.alertId;
    var router = (0,next_router.useRouter)();
    var inputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), url = ref[0], setUrl = ref[1];
    var ref1 = (0,react.useState)(false), sending = ref1[0], setSending = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(false), done = ref3[0], setDone = ref3[1];
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        var ran = router.query.ran;
        if (typeof ran === "string" && /^https?:\/\//i.test(ran)) {
            setUrl(ran);
        }
        if (ran !== undefined || router.asPath.includes("#ran-this")) {
            var ref, ref1;
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                block: "center"
            });
            (ref1 = inputRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus({
                preventScroll: true
            });
        }
    }, [
        router.isReady
    ]);
    var submit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        setSending(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,coverage_submissions/* submitCoverage */.eh)(alertId, url.trim())
                        ];
                    case 2:
                        _state.sent();
                        setDone(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setError((0,newsroom/* newsroomError */.tt)(err, "Could not log that link."));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setSending(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function submit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "ran-this",
        className: (RanThis_module_default()).ranThis,
        children: [
            done ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (RanThis_module_default()).thanks,
                role: "status",
                children: [
                    "Thanks, logged. We’ll attach it to the experts’ profiles shortly.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/raws",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: "Back to the Raws"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (RanThis_module_default()).form,
                onSubmit: submit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (RanThis_module_default()).label,
                        htmlFor: "ran-this-url",
                        children: "Ran this story? Paste the link."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: inputRef,
                        id: "ran-this-url",
                        type: "url",
                        required: true,
                        value: url,
                        onChange: function(e) {
                            return setUrl(e.target.value);
                        },
                        placeholder: "https://",
                        maxLength: 255
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        disabled: sending,
                        children: sending ? "Sending…" : "Submit"
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (RanThis_module_default()).error,
                children: error
            })
        ]
    });
};
/* harmony default export */ var Alert_RanThis = (RanThis);

// EXTERNAL MODULE: ./api/raw-banks.js
var raw_banks = __webpack_require__(2359);
// EXTERNAL MODULE: ./components/Raw/useBankRaw.js
var useBankRaw = __webpack_require__(31773);
// EXTERNAL MODULE: ./styles/modules/RawBank.module.scss
var RawBank_module = __webpack_require__(284);
var RawBank_module_default = /*#__PURE__*/__webpack_require__.n(RawBank_module);
;// CONCATENATED MODULE: ./components/Raw/RawBank.js





var BLOCKED = {
    limit: "You already hold two banked Raws. Bank another when one ends.",
    banked_before: "You have banked this Raw before, so it can’t be banked again.",
    exclusive: "This Raw isn’t open to bank yet."
};
// The journalist's view of Bank on an alert page that is a Raw.
var RawBank = function(param) {
    var alertId = param.alertId;
    var confirmBank = (0,useBankRaw/* useBankRaw */.qx)();
    var ref = (0,react.useState)(null), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var load = function() {
        return (0,raw_banks/* fetchBankStatus */.pJ)(alertId).then(setStatus).catch(function() {
            return setStatus(null);
        });
    };
    (0,react.useEffect)(function() {
        load();
    }, [
        alertId
    ]);
    if (!(status === null || status === void 0 ? void 0 : status.isRaw)) return null;
    var bank = function() {
        return confirmBank(alertId, {
            onBanked: function() {
                setError(null);
                load();
            },
            onError: setError
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (RawBank_module_default()).rawBank,
        children: [
            status.bankedByMe ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (RawBank_module_default()).banked,
                role: "status",
                children: [
                    "Banked by you, releases at",
                    " ",
                    (0,useBankRaw/* releaseTime */.cn)(status.bankedByMe.releasesAt),
                    ". It’s out of the Newspage archive until then; the alert page stays public."
                ]
            }) : status.bankedByOther ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (RawBank_module_default()).note,
                children: [
                    "Another journalist is writing this up. It’s back in the archive at",
                    " ",
                    (0,useBankRaw/* releaseTime */.cn)(status.bankedByOther.releasesAt),
                    "."
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (RawBank_module_default()).button,
                        onClick: bank,
                        disabled: !status.canBank,
                        "aria-describedby": status.blocked ? "raw-bank-blocked" : undefined,
                        children: "Bank this Raw for 24 hours"
                    }),
                    status.blocked && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        id: "raw-bank-blocked",
                        className: (RawBank_module_default()).note,
                        children: BLOCKED[status.blocked]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (RawBank_module_default()).error,
                children: error
            })
        ]
    });
};
/* harmony default export */ var Raw_RawBank = (RawBank);

// EXTERNAL MODULE: ./utils/alert-template.js
var alert_template = __webpack_require__(36543);
;// CONCATENATED MODULE: ./pages/news-alerts/[slug].js
































































var researchCopy = en/* news_alerts.research_sponsor */.RA.qh;
var NewsAlert = function(param) {
    var alert = param.alert, responses = param.responses, schema = param.schema, videoDates = param.videoDates;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var dispatch = (0,es/* useDispatch */.I0)();
    var responsesState = (0,es/* useSelector */.v9)(function(param) {
        var alerts = param.alerts;
        return alerts.alertResponses;
    });
    var ref9 = (0,es/* useSelector */.v9)(function(param) {
        var alerts = param.alerts;
        return alerts;
    }), alertState = ref9.alert;
    var ref10 = (0,es/* useSelector */.v9)(auth/* authSelector */.aF), isAuthenticated = ref10.isAuthenticated, isAdmin = ref10.isAdmin, company = ref10.company, isJournalist = ref10.isJournalist, isContributingEditor = ref10.isContributingEditor, isFTEditor = ref10.isFTEditor, userId = ref10.id;
    var ref11 = (0,es/* useSelector */.v9)(store_company/* companySelector */.yX), ownCompany = ref11.data;
    var plan = isAuthenticated ? (ownCompany === null || ownCompany === void 0 ? void 0 : ownCompany.plan) || null : null;
    var router = (0,next_router.useRouter)();
    var ref12 = (0,react.useState)(false), loading = ref12[0], setLoading = ref12[1];
    var ref13 = (0,react.useState)(alert), data = ref13[0], setData = ref13[1];
    var ref14 = (0,react.useState)(responses), responsesList = ref14[0], setResponsesList = ref14[1];
    var ref15 = (0,react.useState)(false), edit = ref15[0], setEdit = ref15[1];
    var ref16 = (0,react.useState)(true), dateValid = ref16[0], setDateValid = ref16[1];
    var ref17 = (0,react.useState)(true), timeValid = ref17[0], setTimeValid = ref17[1];
    var ref18 = (0,react.useState)(data === null || data === void 0 ? void 0 : data.deadline), deadline = ref18[0], setDeadline = ref18[1];
    var ref19 = (0,react.useState)(data === null || data === void 0 ? void 0 : data.title), title = ref19[0], setTitle = ref19[1];
    var ref20 = (0,react.useState)(data === null || data === void 0 ? void 0 : data.body), body = ref20[0], setBody = ref20[1];
    var ref21 = (0,react.useState)((0,alert_template/* alertTemplate */.hz)(data)), template = ref21[0], setTemplate = ref21[1];
    // Admins may move the alert to a new address while editing; the old one
    // keeps working as a redirect.
    var ref22 = (0,react.useState)(data === null || data === void 0 ? void 0 : data.slug), slug = ref22[0], setSlug = ref22[1];
    var ref23 = (0,react.useState)({
        ok: true,
        checking: false
    }), slugStatus = ref23[0], setSlugStatus = ref23[1];
    var ref24 = (0,react.useState)(null), updateError = ref24[0], setUpdateError = ref24[1];
    // Admin edit: who last saved the alert from this form, and when. The cached page has no names.
    var ref25 = (0,react.useState)(null), lastEdit = ref25[0], setLastEdit = ref25[1];
    var saving = (0,react.useRef)(false);
    // The cached page may carry an old version: the form reloads the alert when opened, but
    // only fills itself while the user has not started editing.
    var touched = (0,react.useRef)(false);
    var ref26 = (0,react.useState)(0), formKey = ref26[0], setFormKey = ref26[1];
    var ref27 = (0,react.useState)(false), conflict = ref27[0], setConflict = ref27[1];
    var ref28 = (0,react.useState)(null), removeError = ref28[0], setRemoveError = ref28[1];
    var ref29 = (0,react.useState)(data === null || data === void 0 ? void 0 : data.expertise), expertises = ref29[0], setExpertises = ref29[1];
    var ref30 = (0,react.useState)((0,source_page/* pickSource */.uO)(data)), source = ref30[0], setSource = ref30[1];
    var ref31 = (0,react.useState)(false), copied = ref31[0], setCopied = ref31[1];
    var ref32 = (0,react.useState)(false), articleCopied = ref32[0], setArticleCopied = ref32[1];
    var ref33 = (0,react.useState)({}), profilesWithAddresses = ref33[0], setProfilesWithAddresses = ref33[1];
    // While an admin edits the story, the published version is hidden.
    var ref34 = (0,react.useState)(false), editingStory = ref34[0], setEditingStory = ref34[1];
    // Admin edit: the saved story sponsorship offer and its draft; null until loaded.
    var ref35 = (0,react.useState)(null), researchRow = ref35[0], setResearchRow = ref35[1];
    var ref36 = (0,react.useState)(null), research = ref36[0], setResearch = ref36[1];
    var ref37 = (0,react.useState)(null), researchLoadError = ref37[0], setResearchLoadError = ref37[1];
    var researchRequest = (0,react.useRef)(0);
    // Remounts the public box after an admin change, so it fetches the new status.
    var ref38 = (0,react.useState)(0), researchVersion = ref38[0], setResearchVersion = ref38[1];
    // The page is cached HTML built without a user, so the signed-in user's own
    // company (which carries their plan) and their experts are fetched here
    // instead of in getStaticProps.
    (0,react.useEffect)(function() {
        if (!isAuthenticated || !company) {
            return;
        }
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,store_company/* fetchCompanyBySlug */._g)(company))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,expert/* fetchExperts */.cZ)())
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isAuthenticated,
        company
    ]);
    // The cached page is built logged out, so its responses carry no firm email or phone. A
    // signed-in member fetches them again; a plain request, as a failed fetchResponses would
    // clear the alert and blank the page.
    (0,react.useEffect)(function() {
        if (!isAuthenticated || !(alertState === null || alertState === void 0 ? void 0 : alertState.id)) {
            return;
        }
        (0,api/* getReq */.ZL)("/alerts/".concat(alertState.id, "/responses?size=").concat(globalConstants/* MAX_PAGE_SIZE */.N)).then(function(param) {
            var data = param.data;
            var ref;
            if (Array.isArray(data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.items)) {
                dispatch(store_alert/* fetchResponses.fulfilled */.j9.fulfilled(data.data.items));
            }
        }).catch(function() {});
    }, [
        isAuthenticated,
        alertState === null || alertState === void 0 ? void 0 : alertState.id
    ]);
    // ?author=0 hides the alert author and cannot reach a cached page.
    (0,react.useEffect)(function() {
        if (router.query.author === "0") {
            dispatch((0,store_alert/* fetchAlertBySlug */.bh)({
                slug: router.query.slug,
                author: "0"
            }));
        }
    }, [
        router.query.author,
        router.query.slug
    ]);
    // The cached page is built logged out, so a journalist's name is never in it. A signed-in
    // member asks the API again, which names the journalist only to paid plans and admins.
    // Only the author is taken over, and a failure leaves the page as it was.
    (0,react.useEffect)(function() {
        var ref;
        if (!isAuthenticated || !(alertState === null || alertState === void 0 ? void 0 : (ref = alertState.author) === null || ref === void 0 ? void 0 : ref.isAnonymised) || router.query.author === "0") {
            return;
        }
        (0,api/* getReq */.ZL)("/alerts/slug/".concat(router.query.slug)).then(function(param) {
            var data = param.data;
            var ref;
            if ((data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.author) && !data.data.author.isAnonymised) {
                dispatch((0,store_alert/* revealAlertAuthor */.x1)(data.data));
            }
        }).catch(function() {});
    }, [
        isAuthenticated,
        alertState === null || alertState === void 0 ? void 0 : alertState.id,
        alertState === null || alertState === void 0 ? void 0 : (ref = alertState.author) === null || ref === void 0 ? void 0 : ref.isAnonymised
    ]);
    // Storify greys out the other sponsor slots while research sponsorship holds them,
    // including a sold sponsor an admin hid, which the public view leaves out.
    var researchAlertId = isAdmin === true && alertState && (!alertState.type || alertState.type === "ALERT") ? alertState.id : null;
    (0,react.useEffect)(function() {
        if (!researchAlertId) {
            return;
        }
        var current = true;
        (0,research_sponsorship/* fetchResearchSponsorshipAdmin */.w9)(researchAlertId).then(function(row) {
            return current && setResearchRow(function(shown) {
                return shown !== null && shown !== void 0 ? shown : row;
            });
        }).catch(function() {});
        return function() {
            current = false;
        };
    }, [
        researchAlertId
    ]);
    (0,react.useEffect)(function() {
        setData(alertState);
        if (alertState) {
            setDeadline(alertState.deadline);
            setTitle(alertState.title);
            setBody(alertState.body);
            setTemplate((0,alert_template/* alertTemplate */.hz)(alertState));
            setExpertises(alertState.expertise);
            setSource((0,source_page/* pickSource */.uO)(alertState));
        }
    }, [
        alertState
    ]);
    var isFTEditorByRole = function(author) {
        if (!(author === null || author === void 0 ? void 0 : author.roles) || !Array.isArray(author.roles)) return false;
        return author.roles.some(function(role) {
            return role.name === "FT_EDITOR";
        });
    };
    // FT Adviser branding names the publication an anonymised journalist writes for.
    var isCreatedByFTEditor = !(data === null || data === void 0 ? void 0 : (ref1 = data.author) === null || ref1 === void 0 ? void 0 : ref1.isAnonymised) && ((data === null || data === void 0 ? void 0 : (ref2 = data.author) === null || ref2 === void 0 ? void 0 : ref2.isFTEditor) || isFTEditorByRole(data === null || data === void 0 ? void 0 : data.author));
    (0,react.useEffect)(function() {
        if (responsesState) {
            setResponsesList(responsesState);
            // Fetch addresses for all profiles
            var fetchAddressesForProfiles = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var addressesMap, uniqueProfileIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, profileId, res, error, err;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                addressesMap = {};
                                uniqueProfileIds = (0,src_to_consumable_array/* default */.Z)(new Set(responsesState.map(function(r) {
                                    return r.profile.id;
                                })));
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = uniqueProfileIds[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                profileId = _step.value;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    (0,api/* getReq */.ZL)("/profiles/".concat(profileId))
                                ];
                            case 4:
                                res = _state.sent();
                                if (res.status === 200) {
                                    addressesMap[profileId] = res.data.data.addresses;
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                console.error("Error fetching profile ".concat(profileId, ":"), error);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                setProfilesWithAddresses(addressesMap);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchAddressesForProfiles() {
                    return _ref.apply(this, arguments);
                };
            }();
            if (responsesState.length > 0) {
                fetchAddressesForProfiles();
            }
        }
    }, [
        responsesState
    ]);
    var ref39 = (0,react.useState)(null), active = ref39[0], setActive = ref39[1];
    var sourceRef = (0,react.useRef)(null);
    var hasStory = Boolean(data === null || data === void 0 ? void 0 : (ref3 = data.story) === null || ref3 === void 0 ? void 0 : ref3.publishedAt);
    // In-copy credits link to #raw-alert, which has to open the folded raw alert.
    (0,react.useEffect)(function() {
        if (!hasStory) {
            return;
        }
        var openOnHash = function() {
            if (window.location.hash === "#raw-alert" && sourceRef.current) {
                sourceRef.current.open = true;
            }
        };
        openOnHash();
        window.addEventListener("hashchange", openOnHash);
        return function() {
            return window.removeEventListener("hashchange", openOnHash);
        };
    }, [
        hasStory
    ]);
    if (!data) {
        return null;
    }
    var handleCloseArticle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            dispatch((0,store_alert/* closeAlert */.M6)(data.id))
                        ];
                    case 1:
                        _state.sent();
                        setDeadline(new Date());
                        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            deadline: new Date(),
                            status: "inactive"
                        }));
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCloseArticle() {
            return _ref.apply(this, arguments);
        };
    }();
    // The API refuses (409) while a research sponsorship is reserved or sold; say so
    // instead of leaving the page as if the alert were gone.
    var handleRemoveArticle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setActive(false);
                        setRemoveError(null);
                        return [
                            4,
                            dispatch((0,store_alert/* removeAlert */.JU)(data.id))
                        ];
                    case 1:
                        result = _state.sent();
                        if (store_alert/* removeAlert.rejected.match */.JU.rejected.match(result)) {
                            ;
                            setRemoveError(((ref = result.payload) === null || ref === void 0 ? void 0 : ref.message) || "The alert could not be deleted.");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            router.push("/news-alerts")
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveArticle() {
            return _ref.apply(this, arguments);
        };
    }();
    // Only news alerts can offer it; this page shows nothing else today.
    var canOfferResearch = isAdmin === true && (!data.type || data.type === "ALERT");
    var markTouched = function() {
        if (edit) touched.current = true;
    };
    var fillForm = function(alert) {
        setDeadline(alert.deadline);
        setTitle(alert.title);
        setBody(alert.body);
        setTemplate((0,alert_template/* alertTemplate */.hz)(alert));
        setSlug(alert.slug);
        setSource((0,source_page/* pickSource */.uO)(alert));
    };
    var loadLatest = function(isCurrent, canFill) {
        return (0,api/* getReq */.ZL)("/alerts/slug/".concat(data.slug)).then(function(param) {
            var res = param.data;
            var latest = res === null || res === void 0 ? void 0 : res.data;
            if (!latest || !isCurrent()) return false;
            if (isAdmin === true) setLastEdit(latest);
            if (!canFill()) return false;
            var patch = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,source_page/* pickSource */.uO)(latest)), {
                deadline: latest.deadline,
                title: latest.title,
                body: latest.body,
                intro: latest.intro,
                questions: latest.questions,
                slug: latest.slug,
                version: latest.version
            });
            // The effect on alertState refills the form; a stale store copy would bring the 409 back.
            dispatch(store_alert/* updateAlert.fulfilled */.Cr.fulfilled(patch));
            setData(function(current) {
                return (0,_object_spread/* default */.Z)({}, current, patch);
            });
            fillForm(latest);
            // Remounts the editors, which read their value only on mount.
            setFormKey(function(key) {
                return key + 1;
            });
            return true;
        });
    };
    var handleLoadLatest = function() {
        var request = researchRequest.current;
        var current = function() {
            return request === researchRequest.current;
        };
        var failed = function() {
            return current() && setUpdateError("The latest version could not be loaded.");
        };
        loadLatest(current, current).then(function(loaded) {
            if (!loaded) return failed();
            setConflict(false);
            setUpdateError(null);
        }).catch(failed);
    };
    var handleEditArticle = function() {
        setEdit(!edit);
        setConflict(false);
        touched.current = false;
        setResearch(null);
        setResearchLoadError(null);
        var request = ++researchRequest.current;
        // Ignored once Edit is closed or reopened: it belongs to that session.
        var current = function() {
            return request === researchRequest.current;
        };
        if (!edit && canOfferResearch) {
            (0,research_sponsorship/* fetchResearchSponsorshipAdmin */.w9)(data.id).then(function(row) {
                return current() && showResearchRow(row);
            }).catch(function() {
                return current() && setResearchLoadError(researchCopy.admin_load_failed);
            });
        }
        setLastEdit(null);
        if (!edit) {
            // On failure the form keeps the page's copy.
            loadLatest(current, function() {
                return !touched.current;
            }).catch(function() {});
        }
        fillForm(data);
        setUpdateError(null);
    };
    var handleUpdateArticle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var researchPending, templateError, researchChanged, updatedAlert, res, ref, alertError, saved, _body, savedBody, _intro, _questions, _status, _slug, _version, _slug1, researchSaveError, _tmp, researchError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // A second click before the first save returns would send the version that save replaces.
                        if (saving.current) return [
                            2
                        ];
                        if (isAdmin && !slugStatus.ok) {
                            setUpdateError(slugStatus.checking ? en/* news_alerts.create_alert.screen_1.slug_checking */.RA.It.n9.slug_checking : en/* news_alerts.create_alert.screen_1.slug_blocked */.RA.It.n9.slug_blocked);
                            return [
                                2
                            ];
                        }
                        researchPending = canOfferResearch && !research && !researchLoadError;
                        templateError = template && (0,alert_template/* alertTemplateError */.Fv)(template, isAdmin === true, data.intro, data.questions) || research && (0,research_sponsor/* researchOfferError */.Sh)(research, researchRow === null || researchRow === void 0 ? void 0 : researchRow.researchDetail) || researchPending && researchCopy.admin_loading;
                        if (templateError) {
                            setUpdateError(templateError);
                            return [
                                2
                            ];
                        }
                        saving.current = true;
                        // A reload still in flight must not change the version this save is checked against.
                        touched.current = true;
                        setLoading(true);
                        setUpdateError(null);
                        setConflict(false);
                        researchChanged = research && (0,research_sponsor/* researchOfferChanged */.dS)(research, researchRow);
                        updatedAlert = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data, source), {
                            deadline: moment_default()(deadline).toISOString(),
                            body: body,
                            title: title
                        }), template && {
                            intro: template.intro.trim(),
                            questions: (0,alert_template/* filledQuestions */.lp)(template.questions)
                        });
                        delete updatedAlert.expertise;
                        // `slug` stays the current address so the thunk revalidates it; the
                        // new one travels as newSlug and only an admin's is honoured.
                        if (isAdmin && slug && slug.trim() !== data.slug) {
                            updatedAlert.newSlug = slug.trim();
                        }
                        return [
                            4,
                            dispatch((0,store_alert/* updateAlert */.Cr)(updatedAlert))
                        ];
                    case 1:
                        res = _state.sent();
                        if (store_alert/* updateAlert.rejected.match */.Cr.rejected.match(res)) {
                            ;
                            alertError = (0,alert_slug/* apiErrorMessage */.bc)(res.payload, "The alert could not be saved.");
                            setUpdateError(alertError);
                            // A taken address is a 409 too; only a stale copy offers the latest version.
                            setConflict(((ref = res.payload) === null || ref === void 0 ? void 0 : ref.statusCode) === 409 && alertError.includes("after you opened it"));
                            saving.current = false;
                            setLoading(false);
                            return [
                                2
                            ];
                        }
                        saved = res.payload || {};
                        savedBody = template ? (_body = saved.body) !== null && _body !== void 0 ? _body : body : body;
                        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data, (0,source_page/* pickSource */.uO)(saved)), {
                            deadline: moment_default()(deadline).toISOString(),
                            body: savedBody,
                            intro: (_intro = saved.intro) !== null && _intro !== void 0 ? _intro : data.intro,
                            questions: (_questions = saved.questions) !== null && _questions !== void 0 ? _questions : data.questions,
                            title: title,
                            status: (_status = saved.status) !== null && _status !== void 0 ? _status : data.status,
                            slug: (_slug = saved.slug) !== null && _slug !== void 0 ? _slug : data.slug,
                            // The next save is checked against this one.
                            version: (_version = saved.version) !== null && _version !== void 0 ? _version : data.version
                        }));
                        if (saved.lastEditedByName) setLastEdit(saved);
                        setSlug((_slug1 = saved.slug) !== null && _slug1 !== void 0 ? _slug1 : data.slug);
                        setBody(savedBody);
                        setTemplate((0,alert_template/* alertTemplate */.hz)(saved.questions ? saved : data));
                        setDeadline(deadline);
                        if (!researchChanged) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            saveResearch()
                        ];
                    case 2:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _tmp = null;
                        _state.label = 4;
                    case 4:
                        researchSaveError = _tmp;
                        researchError = researchSaveError && "".concat(researchCopy.admin_saved_not_research, " ").concat(researchSaveError);
                        if (researchChanged) {
                            refreshResearch();
                        }
                        saving.current = false;
                        setLoading(false);
                        if (researchError) {
                            setUpdateError(researchError);
                        } else {
                            setEdit(false);
                        }
                        if (saved.slug && saved.slug !== data.slug) {
                            router.replace((0,alert_url/* alertPath */.E)(saved.slug));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdateArticle() {
            return _ref.apply(this, arguments);
        };
    }();
    var showResearchRow = function(row) {
        setResearchRow(row);
        setResearch((0,research_sponsor/* researchOfferDraft */.__)(row));
    };
    var saveResearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var err, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,research_sponsorship/* saveResearchOffer */.rH)(data.id, (0,research_sponsor/* researchOfferBody */.U6)(research))
                        ];
                    case 1:
                        showResearchRow.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            2,
                            null
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            2,
                            (0,alert_slug/* apiErrorMessage */.bc)(err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.data, researchCopy.admin_save_failed)
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function saveResearch() {
            return _ref.apply(this, arguments);
        };
    }();
    // The public view carries only a sold credit; the box asks for the offer itself.
    var refreshResearch = function() {
        return (0,research_sponsorship/* fetchResearchSponsorship */.N5)(data.id).then(function(researchSponsorship) {
            setData(function(current) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current), {
                    researchSponsorship: researchSponsorship
                });
            });
            setResearchVersion(function(version) {
                return version + 1;
            });
        }).catch(function() {});
    };
    var isFTEditorAlert = (data === null || data === void 0 ? void 0 : (ref4 = data.author) === null || ref4 === void 0 ? void 0 : ref4.isFTEditor) && !(data === null || data === void 0 ? void 0 : (ref5 = data.author) === null || ref5 === void 0 ? void 0 : ref5.isAnonymised);
    // A published story (Storify) sits above the raw alert and takes over the
    // page's title, description and Open Graph data. The URL stays the same.
    var story = ((ref6 = data.story) === null || ref6 === void 0 ? void 0 : ref6.publishedAt) ? data.story : null;
    var seo = story ? {
        title: story.seoTitle || story.headline,
        description: story.metaDescription || (0,text_truncate/* default */.Z)((0,tag_remove/* default */.Z)(story.body), 160, true)
    } : {
        title: data.title,
        description: (0,text_truncate/* default */.Z)((0,tag_remove/* default */.Z)(data.body), 160, true)
    };
    var lead = story && leadImage(story);
    var storyImage = story ? (0,utils_newsroom/* firstImage */.UK)(story.body) : null;
    var shareImage = lead ? leadImageOg(lead) : storyImage && {
        url: storyImage
    };
    var possibleToAddResponse = isAuthenticated && !isAdmin && !isJournalist && !isFTEditor && (isFTEditorAlert || data.responsesLeft > 0) && data.status === "active" && responsesList.filter(function(item) {
        return item.profile.slug === company;
    }).length === 0;
    // A published story leads; the alert and responses it came from fold away under it.
    var SourceWrapper = story ? "details" : "div";
    // The offer sits at the bottom of the alert, as briefed, for logged-in experts only
    // (admins too, to check it), and never once a story leads the page. Once sold, the
    // sponsor is credited at the top instead: under the alert's title, or in the story's byline.
    var researchSold = ((ref7 = data.researchSponsorship) === null || ref7 === void 0 ? void 0 : ref7.status) === "sold";
    var researchBox = !researchSold && !story && data.status === "active" && isAuthenticated && (isAdmin || !isJournalist) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_ResearchSponsorBox, {
        alertId: data.id
    }, researchVersion);
    var researchCredit = researchSold && !story && data.researchSponsorship.sponsorName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchCredit, {
        name: data.researchSponsorship.sponsorName,
        website: data.researchSponsorship.sponsorWebsite
    });
    // The price under the headline while the offer is for sale, to everyone who could buy it:
    // logged-out visitors go through the login, which sends them back to the box.
    var researchStrip = !researchSold && !story && data.status === "active" && (!isAuthenticated || isAdmin || !isJournalist) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResearchStrip, {
        alertId: data.id,
        deadline: deadline,
        loginHref: isAuthenticated ? null : "/login?redirect=".concat(encodeURIComponent("".concat((0,alert_url/* alertPath */.E)(data.slug), "#research-sponsor")))
    }, researchVersion);
    var deadlineComponent = edit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Deadline, {
        initialDate: deadline,
        setDeadline: setDeadline,
        setDateValid: setDateValid,
        setTimeValid: setTimeValid
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
        className: (Detail_module_default()).timer,
        close: handleCloseArticle,
        status: data.status,
        createdAt: data.createdAt,
        deadline: deadline,
        isFTEditor: isCreatedByFTEditor
    });
    var handleQuoteAll = function() {
        var result = '\n        <meta charset="utf-8">\n        ';
        responsesList.forEach(function(r) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            var profileAddresses = profilesWithAddresses[r.profile.id];
            result += server_browser.renderToString(/*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_ResponseQuote, {
                company: {
                    name: (r === null || r === void 0 ? void 0 : (ref = r.profile) === null || ref === void 0 ? void 0 : ref.employer) || (r === null || r === void 0 ? void 0 : (ref1 = r.profile) === null || ref1 === void 0 ? void 0 : ref1.name),
                    expertName: (r === null || r === void 0 ? void 0 : (ref2 = r.expert) === null || ref2 === void 0 ? void 0 : ref2.name) || (r === null || r === void 0 ? void 0 : (ref3 = r.profile) === null || ref3 === void 0 ? void 0 : ref3.name),
                    expertPosition: (r === null || r === void 0 ? void 0 : (ref4 = r.expert) === null || ref4 === void 0 ? void 0 : ref4.position) || (r === null || r === void 0 ? void 0 : (ref5 = r.profile) === null || ref5 === void 0 ? void 0 : ref5.position),
                    website: r === null || r === void 0 ? void 0 : (ref6 = r.profile) === null || ref6 === void 0 ? void 0 : ref6.website,
                    slug: r === null || r === void 0 ? void 0 : (ref7 = r.profile) === null || ref7 === void 0 ? void 0 : ref7.slug,
                    deactivated: r === null || r === void 0 ? void 0 : (ref8 = r.profile) === null || ref8 === void 0 ? void 0 : ref8.deactivated,
                    city: profileAddresses && profileAddresses.length > 0 ? profileAddresses[0].city : null
                },
                response: {
                    body: r.body
                },
                alertSlug: router.query.slug,
                planType: r === null || r === void 0 ? void 0 : (ref9 = r.author) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.plan) === null || ref10 === void 0 ? void 0 : ref10.type
            }));
            result += "<br/><br/>";
        });
        copyFormatted(result);
        setCopied(true);
        setTimeout(function() {
            setCopied(false);
        }, 1000);
    };
    var handleCopyArticle = function() {
        var result = '\n        <meta charset="utf-8">\n        '.concat(server_browser.renderToString(/*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_ResponseArticle, {
            body: body,
            title: title
        })), "\n        ");
        copyFormatted(result);
        setArticleCopied(true);
        setTimeout(function() {
            setArticleCopied(false);
        }, 1000);
    };
    var _slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarLayout/* default */.Z, {
        isAuthenticated: isAuthenticated,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default */.Z), {
                titleTemplate: story ? (0,seo_title/* default */.ZP)(seo.title) : (0,seo_title/* articleTitle */.mL)(seo.title),
                description: seo.description,
                canonical: (0,alert_url/* alertUrl */.v)(data.slug),
                // Daily Intel repeats the same words each day and a service announcement is a notice to
                // members: neither is a page for Google (both are left out of the sitemap too), nor is an
                // alert an editor took out of Google.
                noindex: /^newspage-intel-/.test((_slug = data.slug) !== null && _slug !== void 0 ? _slug : "") || data.announcementRecipients != null || Boolean(data.noindex),
                openGraph: story ? (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default.openGraph */.Z.openGraph), {
                    type: "article",
                    title: seo.title,
                    description: seo.description,
                    url: storyUrl(data.slug),
                    article: {
                        publishedTime: story.publishedAt,
                        modifiedTime: story.updatedAt || story.publishedAt
                    }
                }), shareImage ? {
                    images: [
                        shareImage
                    ]
                } : {}) : {
                    description: seo.description,
                    url: (0,alert_url/* alertUrl */.v)(data.slug)
                }
            }), lead && {
                twitter: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default.twitter */.Z.twitter), {
                    cardType: "summary_large_image"
                }),
                additionalMetaTags: [
                    {
                        name: "twitter:image",
                        content: shareImage.url
                    },
                    {
                        name: "twitter:image:alt",
                        content: shareImage.alt
                    }, 
                ]
            })),
            schema && !story && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0,safe_html/* jsonLd */.oL)(schema)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupConfirm/* default */.Z, {
                active: active,
                confirmTitle: "Confirm",
                onConfirm: handleRemoveArticle,
                onCancel: function() {
                    return setActive(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Detail_module_default()).container,
                children: [
                    removeError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Detail_module_default()).error,
                        children: removeError
                    }),
                    isAdmin === true || isJournalist === true || isFTEditor === true || isContributingEditor === true && (data === null || data === void 0 ? void 0 : data.authorId) === userId || (0,subscriptionAccess/* writesAlerts */.B3)(plan === null || plan === void 0 ? void 0 : plan.type) && (data === null || data === void 0 ? void 0 : data.authorId) === userId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_AdminButtons, {
                        status: data.status,
                        handleEditArticle: handleEditArticle,
                        handleCloseArticle: handleCloseArticle,
                        handleUpdateArticle: handleUpdateArticle,
                        loading: loading,
                        edit: edit,
                        setActive: setActive,
                        timeValid: timeValid,
                        dateValid: dateValid,
                        isAdmin: isAdmin,
                        isContributingEditor: isContributingEditor,
                        isFTEditor: isFTEditor,
                        plan: plan,
                        alertId: data.id,
                        noindex: Boolean(data.noindex),
                        onNoindexChange: function(noindex) {
                            return setData(function(current) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current), {
                                    noindex: noindex
                                });
                            });
                        }
                    }) : null,
                    edit && conflict && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Detail_module_default()).conflict,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Detail_module_default()).error,
                                children: updateError
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                theme: "secondary",
                                title: "Load the latest version",
                                onClick: handleLoadLatest
                            })
                        ]
                    }),
                    isAdmin === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Newsroom, {
                        alert: data,
                        researchOn: // The admin row covers an offer still for sale; the public view carries only a sale.
                        (0,research_sponsor/* researchKeepsSlotsOff */.uP)(researchRow) || Boolean(data.researchSponsorship),
                        responsesCount: responsesList.length,
                        onAlertChange: function(patch) {
                            return setData(function(current) {
                                return (0,_object_spread/* default */.Z)({}, current, patch);
                            });
                        },
                        onStoryChange: function(published) {
                            return setData(function(current) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current), {
                                    story: (published === null || published === void 0 ? void 0 : published.publishedAt) ? published : null
                                });
                            });
                        },
                        onEditingChange: setEditingStory
                    }),
                    story && !editingStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_Story, {
                        story: story,
                        alert: data,
                        responses: responsesList,
                        videoDates: videoDates
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SourceWrapper, {
                        ref: sourceRef,
                        onKeyDownCapture: markTouched,
                        onPointerDownCapture: markTouched,
                        onInputCapture: markTouched,
                        className: story ? (Detail_module_default()).source : undefined,
                        open: story && (edit || possibleToAddResponse) ? true : undefined,
                        children: [
                            story && /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                                className: (Detail_module_default()).sourceToggle,
                                children: "Show the original alert and ".concat(responsesList.length, " ").concat((0,pluralize/* default */.Z)(responsesList.length, "response"))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: [
                                    "mb-l",
                                    (Detail_module_default()).logo
                                ].join(" "),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Detail_module_default()).logoContainer,
                                        children: [
                                            isCreatedByFTEditor && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/img/news-story/ft_logo.webp",
                                                alt: "FT Logo",
                                                width: 134,
                                                height: 34,
                                                className: (Detail_module_default()).ftLogo
                                            }),
                                            isCreatedByFTEditor && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Detail_module_default()).logoDivider
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsAlertLogo/* default */.Z, {
                                                width: 168,
                                                height: 37
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: isAuthenticated && !articleCopied ? function() {
                                            return handleCopyArticle();
                                        } : null,
                                        className: [
                                            (Detail_module_default())["quote-all"],
                                            !isAuthenticated && "loginLocked", 
                                        ].filter(Boolean).join(" "),
                                        "data-hint": isAuthenticated ? undefined : en/* common.loginToCopy */.y0.loginToCopy,
                                        style: {
                                            margin: "unset"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: !articleCopied ? "Copy article" : "Copied to clipboard"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote2/* default */.Z, {
                                                fill: "#fff"
                                            })
                                        ]
                                    }),
                                    (0,utils_newsroom/* isReleasedRaw */.gI)(data) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: [
                                            (Detail_module_default()).logoContainer,
                                            (Detail_module_default()).rawMeta, 
                                        ].join(" "),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_RawBadge, {
                                                alert: data
                                            }),
                                            data.seededBy && /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCredit/* default */.Z, {
                                                seededBy: data.seededBy
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !liveSponsor(story) && ((ref8 = data.researchSponsorship) === null || ref8 === void 0 ? void 0 : ref8.status) !== "sold" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Banner, {
                                campaign: alert === null || alert === void 0 ? void 0 : alert.campaign
                            }),
                            edit && (lastEdit === null || lastEdit === void 0 ? void 0 : lastEdit.lastEditedByName) && (lastEdit === null || lastEdit === void 0 ? void 0 : lastEdit.lastEditedAt) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (Detail_module_default()).lastEdited,
                                children: [
                                    "Last edited by ",
                                    lastEdit.lastEditedByName,
                                    ",",
                                    " ",
                                    (0,utils_newsroom/* formatDateTime */.o0)(lastEdit.lastEditedAt)
                                ]
                            }),
                            edit && updateError && !conflict && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Detail_module_default()).error,
                                children: updateError
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PostAlert, {
                                editorKey: formKey,
                                titleVariant: story ? "h2" : "h1",
                                author: (data === null || data === void 0 ? void 0 : data.author) ? data.author : false,
                                title: title,
                                body: body,
                                edit: edit,
                                deadline: deadlineComponent,
                                setData: {
                                    setTitle: setTitle,
                                    setBody: setBody,
                                    setSlug: setSlug,
                                    setSlugStatus: setSlugStatus,
                                    setTemplate: setTemplate
                                },
                                template: template,
                                storedIntro: data.intro,
                                sponsorCredit: researchCredit,
                                sponsorStrip: researchStrip,
                                isAdmin: isAdmin === true,
                                slug: slug,
                                currentSlug: data.slug,
                                alertId: data.id,
                                source: edit ? source : (0,source_page/* pickSource */.uO)(data),
                                setSource: setSource,
                                research: research,
                                researchRow: researchRow,
                                setResearch: setResearch,
                                onResearchRowChange: function(row) {
                                    showResearchRow(row);
                                    refreshResearch();
                                },
                                researchError: researchLoadError
                            }),
                            edit && canOfferResearch && !editingStory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsroom_DirectoryTopicsPicker, {
                                alertId: data.id,
                                published: !!(story === null || story === void 0 ? void 0 : story.publishedAt)
                            }),
                            researchBox,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: [
                                    "mt-xxl",
                                    (Detail_module_default()).responses,
                                    isCreatedByFTEditor ? (Detail_module_default()).ftEditor : "", 
                                ].join(" "),
                                children: [
                                    possibleToAddResponse && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                                                variant: "h2",
                                                className: [
                                                    "mb-xs",
                                                    (Detail_module_default()).responsesTitle, 
                                                ].join(" "),
                                                children: "".concat(data === null || data === void 0 ? void 0 : data.responsesLeft, " ").concat((0,pluralize/* default */.Z)(data === null || data === void 0 ? void 0 : data.responsesLeft, "response"), " left, be one of them")
                                            }),
                                            isFTEditorAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                                                variant: "h3",
                                                className: [
                                                    "mb-xxl",
                                                    (Detail_module_default()).responsesTitle, 
                                                ].join(" "),
                                                children: "This is an FT Adviser-sponsored News Alert. Anyone can respond. For free. No credits will be used."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_AddResponse, {
                                                alertId: data.id,
                                                alertData: data
                                            }, data.id)
                                        ]
                                    }),
                                    !possibleToAddResponse && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typo/* default */.Z, {
                                                variant: "h2",
                                                className: [
                                                    "mb-xxl",
                                                    (Detail_module_default()).responsesTitle, 
                                                ].join(" "),
                                                children: [
                                                    "".concat(responsesList.length || 0, " ").concat((0,pluralize/* default */.Z)(data === null || data === void 0 ? void 0 : data.responses, "response"), " from the Newspage community"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: isAuthenticated ? handleQuoteAll : null,
                                                        className: [
                                                            (Detail_module_default())["quote-all"],
                                                            !isAuthenticated && "loginLocked", 
                                                        ].filter(Boolean).join(" "),
                                                        "data-hint": isAuthenticated ? undefined : en/* common.loginToCopy */.y0.loginToCopy,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: !copied ? "Copy all" : "Copied to clipboard"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Quote2/* default */.Z, {
                                                                fill: "#fff"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_Responses, {
                                                id: data.id,
                                                status: data.status,
                                                list: responsesList,
                                                alertSlug: router.query.slug
                                            })
                                        ]
                                    }),
                                    isAdmin === true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                                                variant: "h2",
                                                children: "Expertises:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            expertises && expertises.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RawTags/* default */.Z, {
                                                tags: expertises
                                            }) : "Sent to all"
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    isJournalist === true && data.rawAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Raw_RawBank, {
                        alertId: data.id
                    }),
                    isJournalist === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert_RanThis, {
                        alertId: data.id
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidescreen["default"], {
                onUpdate: function(val) {
                    dispatch((0,ux/* handleHideSidescreen */.Qb)());
                }
            })
        ]
    });
};
var __N_SSG = true;
// No wrapper.withRedux here — _app.js already wraps the tree, and on the server
// a page-level wrap gets a second store that never receives HYDRATE.
/* harmony default export */ var _slug_ = (NewsAlert);


/***/ }),

/***/ 5812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ht": function() { return /* binding */ countWords; },
/* harmony export */   "XO": function() { return /* binding */ websiteLabel; },
/* harmony export */   "ao": function() { return /* binding */ faqQuestionInputs; },
/* harmony export */   "jb": function() { return /* binding */ MAX_ANSWER_WORDS; },
/* harmony export */   "nU": function() { return /* binding */ sponsorCheckoutError; },
/* harmony export */   "oo": function() { return /* binding */ faqSponsorStatusLabel; },
/* harmony export */   "v7": function() { return /* binding */ faqIncomplete; }
/* harmony export */ });
/* unused harmony export FAQ_QUESTIONS */
/* harmony import */ var _newsroom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93889);

var FAQ_QUESTIONS = 5;
var MAX_ANSWER_WORDS = 130;
var countWords = function(text) {
    return (text || "").trim().split(/\s+/).filter(Boolean).length;
};
// The firm's name, or the site's own name when the profile has none to link.
var websiteLabel = function(firm, website) {
    if (firm) return firm;
    try {
        return new URL(website).hostname.replace(/^www\./, "");
    } catch (e) {
        return null;
    }
};
var ref;
// Always five inputs in the Storify form; blanks are dropped by the API.
var faqQuestionInputs = function(questions) {
    return Array.from({
        length: FAQ_QUESTIONS
    }, function(_, i) {
        return (ref = questions === null || questions === void 0 ? void 0 : questions[i]) !== null && ref !== void 0 ? ref : "";
    });
};
// The API refuses an offer with nothing to answer; caught before the save.
var faqIncomplete = function(param) {
    var faqOffer = param.faqOffer, faqHeading = param.faqHeading, faqQuestions = param.faqQuestions;
    return Boolean(faqOffer) && (!faqHeading.trim() || !faqQuestions.some(function(q) {
        return q.trim();
    }));
};
var STATUS_TEXT = {
    awaiting_answers: "Paid, waiting for the sponsor’s answers",
    in_review: "Answers in review",
    live: "Expert answers live",
    declined: "Declined",
    expired: "Expired"
};
// For the Storify panel: where the story's sponsorship is, if anyone has paid.
var faqSponsorStatusLabel = function(story) {
    var text = STATUS_TEXT[story === null || story === void 0 ? void 0 : story.faqSponsorStatus];
    if (!text) return null;
    var running = [
        "awaiting_answers",
        "in_review",
        "live"
    ].includes(story.faqSponsorStatus);
    var until = running && story.faqSponsorExpiresAt ? " \xb7 runs until ".concat((0,_newsroom_js__WEBPACK_IMPORTED_MODULE_0__/* .formatDate */ .p6)(story.faqSponsorExpiresAt)) : "";
    return "".concat(text).concat(until);
};
// What the pay page says when the API turns a responder away.
var sponsorCheckoutError = function(response) {
    var renewing = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    if ((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.code) === "ALREADY_SPONSOR") return "yours";
    if (renewing && (response === null || response === void 0 ? void 0 : response.status) === 404) return "nothingToRenew";
    if ((response === null || response === void 0 ? void 0 : response.status) === 409) return "taken";
    if ((response === null || response === void 0 ? void 0 : response.status) === 403) return "notResponder";
    if ((response === null || response === void 0 ? void 0 : response.status) === 404) return "notOffered";
    return "failed";
};


/***/ }),

/***/ 72638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fv": function() { return /* binding */ expertPersons; },
/* harmony export */   "PE": function() { return /* binding */ bylineAuthor; },
/* harmony export */   "kg": function() { return /* binding */ authorPageSchema; },
/* harmony export */   "tw": function() { return /* binding */ authorPath; },
/* harmony export */   "wo": function() { return /* binding */ webUrl; },
/* harmony export */   "xO": function() { return /* binding */ storyVideos; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var _newsroom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93889);
/* harmony import */ var _profile_seo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88300);
/* harmony import */ var _seo_title_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61055);







// Enough to credit every quoted expert on a busy alert without the JSON-LD
// outweighing the responses it describes.
var MAX_AUTHORS = 50;
// Same length as the page's meta description, which reads the same body.
var DESCRIPTION_MAX = 160;
// An alert is tagged with every expertise it was sent to, eighty on a busy one.
// Enough keywords to cover the topic, not the whole directory.
var MAX_KEYWORDS = 50;
var isoDateTime = function(value) {
    // `new Date(null)` is the epoch, not an invalid date — guard falsy first
    var date = value ? new Date(value) : null;
    return !date || Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};
var prune = function(node) {
    return Object.fromEntries(Object.entries(node).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), value = _param[1];
        return value !== undefined && value !== "" && !(Array.isArray(value) && value.length === 0);
    }));
};
var publisher = function(host) {
    return {
        "@type": "Organization",
        name: SITE_NAME,
        url: host,
        logo: {
            "@type": "ImageObject",
            url: "".concat(host, "/newspage.png")
        }
    };
};
// The firm's social profiles, as the profile's socialNetwork row holds them:
// one column per network, empty when not set. Only absolute http(s) links are
// worth a sameAs; anything else (a handle, a stray word) would mislead.
var socialUrls = function(socialNetwork) {
    return Object.entries(socialNetwork || {}).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), value = _param[1];
        return (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(value);
    }).filter(function(value) {
        return /^https?:\/\//i.test(value);
    });
};
var unique = function(values) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(values.filter(Boolean)));
};
// Profiles type their website as they like: "www.example.com" is common. A
// sameAs or Organization url has to be absolute, so add the scheme or leave
// the value out.
var webUrl = function(value) {
    var text = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(value);
    if (/^https?:\/\//i.test(text)) {
        return text;
    }
    return /^[\w-]+(\.[\w-]+)+(\/\S*)?$/.test(text) ? "https://".concat(text) : undefined;
};
// The firm an expert speaks for, as the response card words it: "{position} at
// {employer || profile name}" (Response.js). An Organization only when there is
// a name to give it.
var firmOf = function(profile, logo) {
    var name = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .orgOf */ .iC)(profile) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile.name);
    return name ? prune({
        "@type": "Organization",
        name: name,
        url: webUrl(profile.website),
        logo: logo
    }) : undefined;
};
// Each response is quoted under the expert's name when one was picked, and the
// company's otherwise — the same name the alert page shows. Both link to the
// company profile, which is the only public page either has. Reads name, role,
// firm, image and social links only: the response payload carries contact
// details the schema must not.
function expertPersons(responses, host) {
    var seen = new Set();
    return (Array.isArray(responses) ? responses : []).map(function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, expert = ref.expert, profile = ref.profile;
        var ref1, ref2;
        var name = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(expert === null || expert === void 0 ? void 0 : expert.name) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile === null || profile === void 0 ? void 0 : profile.name);
        if (!name) {
            return null;
        }
        // a deactivated responder's page answers 404: named, but not linked
        var linked = !(profile === null || profile === void 0 ? void 0 : profile.deactivated);
        var slug = linked ? (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile === null || profile === void 0 ? void 0 : profile.slug) : "";
        var url = slug ? "".concat(host, "/").concat(slug) : undefined;
        var logo = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile === null || profile === void 0 ? void 0 : (ref1 = profile.logo) === null || ref1 === void 0 ? void 0 : ref1.path) || undefined;
        return prune({
            "@type": "Person",
            name: name,
            url: url,
            jobTitle: (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(expert === null || expert === void 0 ? void 0 : expert.position) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile === null || profile === void 0 ? void 0 : profile.position),
            // the response card's picture: the expert's own, else the logo
            image: (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(expert === null || expert === void 0 ? void 0 : (ref2 = expert.image) === null || ref2 === void 0 ? void 0 : ref2.path) || logo,
            worksFor: profile ? firmOf(profile, logo) : undefined,
            sameAs: linked ? unique([
                url
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(socialUrls(profile === null || profile === void 0 ? void 0 : profile.socialNetwork)))) : undefined
        });
    }).filter(function(person) {
        var key = person && "".concat(person.name, "|").concat(person.url);
        if (!person || seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    }).slice(0, MAX_AUTHORS);
}
// Editors caption a video with an italic line straight after it.
var videoCaption = function(body, id) {
    var match = new RegExp("embed/".concat(id, "[^]*?</figure>\\s*<p>\\s*<(i|em)>([^]*?)</\\1>\\s*</p>")).exec(body || "");
    return match ? (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .cleanBio */ .N5)(match[2]) : "";
};
// A VideoObject per embedded YouTube video, so the story can show as a video
// result. uploadDates are YouTube's own, by video id (utils/youtube-upload-date.js).
// Google requires uploadDate, so without YouTube's the story's last save stands
// in: the video was on the page by then. hqdefault exists for every video,
// maxresdefault not.
var storyVideos = function(body, uploadDates, param) {
    var headline = param.headline, description = param.description, savedAt = param.savedAt;
    return (0,_newsroom_js__WEBPACK_IMPORTED_MODULE_0__/* .youtubeIds */ .cN)(body).map(function(id) {
        return prune({
            "@type": "VideoObject",
            name: (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(headline),
            description: videoCaption(body, id) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(description),
            thumbnailUrl: [
                "https://i.ytimg.com/vi/".concat(id, "/hqdefault.jpg")
            ],
            uploadDate: isoDateTime(uploadDates === null || uploadDates === void 0 ? void 0 : uploadDates[id]) || isoDateTime(savedAt),
            embedUrl: "https://www.youtube.com/embed/".concat(id),
            url: "https://www.youtube.com/watch?v=".concat(id)
        });
    });
};
var authorPath = function(slug) {
    return slug ? "/authors/".concat(encodeURIComponent(slug)) : null;
};
// A story's byline as schema.org reads it: the picked author with their page,
// photo, title and LinkedIn (the Newsdesk as an Organization), a typed byline
// as a bare Person, and null when the story has neither.
function bylineAuthor(story, host) {
    var author = story === null || story === void 0 ? void 0 : story.bylineAuthor;
    var name = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(author === null || author === void 0 ? void 0 : author.name) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(story === null || story === void 0 ? void 0 : story.byline);
    if (!name) {
        return null;
    }
    if (!author) {
        return {
            "@type": "Person",
            name: name
        };
    }
    return prune({
        "@type": author.isOrganization ? "Organization" : "Person",
        name: name,
        url: "".concat(host).concat(authorPath(author.slug)),
        image: webUrl(author.photoUrl),
        jobTitle: author.isOrganization ? undefined : (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(author.jobTitle),
        sameAs: unique([
            webUrl(author.linkedinUrl)
        ])
    });
}
// An author's page: Google reads ProfilePage as the page about that person.
var authorPageSchema = function(author, host) {
    return {
        "@context": "https://schema.org",
        "@type": "ProfilePage",
        mainEntity: bylineAuthor({
            bylineAuthor: author
        }, host)
    };
};
// The alert's tags (expertise) by level: the top of the tree is the sector the
// alert sits in, the master tags are its named topics, and the long tail of
// child tags is only worth a keyword.
var names = function(tags) {
    return unique(tags.map(function(tag) {
        return clean(tag === null || tag === void 0 ? void 0 : tag.name);
    }));
};
var topicsOf = function(alert) {
    var tags = Array.isArray(alert === null || alert === void 0 ? void 0 : alert.expertise) ? alert.expertise : [];
    var sections = names(tags.filter(function(tag) {
        return !(tag === null || tag === void 0 ? void 0 : tag.parentId);
    }));
    var masters = names(tags.filter(function(tag) {
        return tag === null || tag === void 0 ? void 0 : tag.isMaster;
    }));
    return {
        sections: sections,
        topics: masters.length ? masters : sections,
        keywords: names(_to_consumable_array(tags.filter(function(tag) {
            return tag === null || tag === void 0 ? void 0 : tag.isMaster;
        })).concat(_to_consumable_array(tags))).slice(0, MAX_KEYWORDS)
    };
};
function buildNewsArticleSchema(alert, responses, host) {
    var headline = clean(alert === null || alert === void 0 ? void 0 : alert.title);
    var slug = clean(alert === null || alert === void 0 ? void 0 : alert.slug);
    if (!headline || !slug) {
        return null;
    }
    var url = alertUrl(slug, host);
    // publicationDate is null on every alert today, see data/sitemapNews.mjs
    var published = isoDateTime(alert.publicationDate || alert.createdAt);
    var updated = isoDateTime(alert.updatedAt);
    var people = expertPersons(responses, host);
    var ref = topicsOf(alert), sections = ref.sections, topics = ref.topics, keywords = ref.keywords;
    // tags gone and entities decoded: JSON-LD text is not HTML
    var body = cleanBio(alert.body);
    return prune({
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        headline: headline,
        description: body ? truncate(body, DESCRIPTION_MAX, true) : undefined,
        url: url,
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        image: [
            "".concat(host, "/newspage.png")
        ],
        datePublished: published,
        // an alert never edited has no updatedAt, and one edited before its
        // publicationDate would otherwise predate itself
        dateModified: updated && published && updated > published ? updated : published,
        author: people.length ? people : [
            publisher(host)
        ],
        publisher: publisher(host),
        // the alert's sector, its main topics, and every tag as a keyword
        articleSection: sections,
        about: topics.map(function(name) {
            return {
                "@type": "Thing",
                name: name
            };
        }),
        keywords: keywords,
        isAccessibleForFree: true
    });
}


/***/ }),

/***/ 68545:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var pluralize = function(count, noun) {
    var suffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "s";
    return "".concat(noun).concat(count !== 1 ? suffix : "");
};
/* harmony default export */ __webpack_exports__["Z"] = (pluralize);


/***/ }),

/***/ 73269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressWrapper":"DateProgress_progressWrapper__4HHmJ","progress":"DateProgress_progress__166r9","line":"DateProgress_line__SKLMK","ftEditorProgress":"DateProgress_ftEditorProgress__uivwF"};

/***/ }),

/***/ 30909:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info":"LoginInfo_info__pg7Eb","popover":"LoginInfo_popover__B10QS"};

/***/ }),

/***/ 87382:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"post":"Post_post__4oGDa","postHead":"Post_postHead__6SFEZ","postBody":"Post_postBody__cynBm","demo-editor":"Post_demo-editor__lh6E2"};

/***/ }),

/***/ 20886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"PostAlert_editorContainer__1CRQb","title":"PostAlert_title__4cqXl","author":"PostAlert_author__fSBXd","anonymisedInfo":"PostAlert_anonymisedInfo__MM4R8","anonymisedPopover":"PostAlert_anonymisedPopover__19KC1","ftBannerContainer":"PostAlert_ftBannerContainer__YboLX","ftBanner":"PostAlert_ftBanner__JLBmM","metaWrapper":"PostAlert_metaWrapper__5LChy","input":"PostAlert_input__UtCv7","socialIcons":"PostAlert_socialIcons__m6pXD","disclaimer":"PostAlert_disclaimer__6UexX"};

/***/ }),

/***/ 86157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"ProfileTag_imgWrapper__NzQg_","img":"ProfileTag_img__dewNo","imgEmbed":"ProfileTag_imgEmbed__E4Mhh","avatarPlatinumEmbed":"ProfileTag_avatarPlatinumEmbed__UtA1s","avatarLegendEmbed":"ProfileTag_avatarLegendEmbed__d59PR","avatarPlatinum":"ProfileTag_avatarPlatinum__CwSRa","avatarLegend":"ProfileTag_avatarLegend__EcBji","imgTag":"ProfileTag_imgTag__bh4Wb","imgTagPlatinum":"ProfileTag_imgTagPlatinum__lbwoH","imgTagPremium":"ProfileTag_imgTagPremium__sR4Kg","imgTagLegend":"ProfileTag_imgTagLegend__vipjh"};

/***/ }),

/***/ 284:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rawBank":"RawBank_rawBank__OfZA_","button":"RawBank_button__sAIk3","banked":"RawBank_banked__jfC3_","note":"RawBank_note__SOJC5","error":"RawBank_error__Eqrvh"};

/***/ }),

/***/ 69561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Raws_wrapper__oJ1uV","head":"Raws_head__mAUeS","authorStories":"Raws_authorStories__2WVQQ","intro":"Raws_intro__krOhY","reviewLink":"Raws_reviewLink__yKDmz","adminSection":"Raws_adminSection__KcDt2","adminBlock":"Raws_adminBlock__D1z_n","adminTool":"Raws_adminTool__kc5sb","search":"Raws_search__i6xdv","clear":"Raws_clear__KW_XF","srOnly":"Raws_srOnly__DRhZh","count":"Raws_count__WAAX_","empty":"Raws_empty__j0D6T","error":"Raws_error__4gr7n","list":"Raws_list__ciMDF","item":"Raws_item__35M_h","reviewItem":"Raws_reviewItem__hZKE9","reviewActions":"Raws_reviewActions__82iHx","tabs":"Raws_tabs__yAUCg","coverageFields":"Raws_coverageFields__RUxA4","itemMeta":"Raws_itemMeta__Vt4x8","reraw":"Raws_reraw__nJOzN","itemSource":"Raws_itemSource__6mlk8","thin":"Raws_thin__y31qG","itemTitle":"Raws_itemTitle__aVsPX","itemTitleRan":"Raws_itemTitleRan__pNeQL","ran":"Raws_ran__uhYf1","ranLabel":"Raws_ranLabel__XgfnS","excerpt":"Raws_excerpt__BQRVb","tags":"Raws_tags__IZx_5","tagOverflow":"Raws_tagOverflow__w_e6K","tagsExpanded":"Raws_tagsExpanded__gdHJs","pager":"Raws_pager__m_zW8","bankButton":"Raws_bankButton__9pAek","bankedBefore":"Raws_bankedBefore__ruAAO","myBanks":"Raws_myBanks__3e7HR","unbank":"Raws_unbank__M3fQC","bankStats":"Raws_bankStats__p6_7V","bankStat":"Raws_bankStat__4d_rm"};

/***/ }),

/***/ 89073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"descriptionText":"SmartText_descriptionText__p8r17","data":"SmartText_data__hd0hx","doubleQuoted":"SmartText_doubleQuoted__0PrJE","shadow":"SmartText_shadow__vEDiH","shadowOpened":"SmartText_shadowOpened__CCLQd","link":"SmartText_link__5KakI","opened":"SmartText_opened__xpCyI"};

/***/ }),

/***/ 2642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"Detail_logo__h6_r2","logoContainer":"Detail_logoContainer__oJ8hp","rawMeta":"Detail_rawMeta__zSSPK","ftLogo":"Detail_ftLogo__jx5v1","logoDivider":"Detail_logoDivider__JY1RC","banner":"Detail_banner__sDVxV","dashlyLogo":"Detail_dashlyLogo__6vWr6","title":"Detail_title__87VE4","header":"Detail_header__fHquZ","cta":"Detail_cta__s9SxK","upgradeCta":"Detail_upgradeCta__36eqy","button":"Detail_button__lT9EZ","userInfo":"Detail_userInfo__pDrxo","userInfoInner":"Detail_userInfoInner__JOSNg","addCta":"Detail_addCta__cLKO9","logoWrapper":"Detail_logoWrapper__sLM6H","userImage":"Detail_userImage__jXS3_","logoTag":"Detail_logoTag__1G_AG","error":"Detail_error__O_Gbo","lastEdited":"Detail_lastEdited__5ihLa","conflict":"Detail_conflict__iN9YP","adminButtons":"Detail_adminButtons__lZIKP","noindexNote":"Detail_noindexNote__NIrnb","subscription":"Detail_subscription__ObmK_","editor":"Detail_editor__U4XPx","timer":"Detail_timer__dLpKL","timerActive":"Detail_timerActive__xwQ6t","dateWrapper":"Detail_dateWrapper__bqoz9","responses":"Detail_responses__vE01z","ftEditor":"Detail_ftEditor__T9v9J","source":"Detail_source__N36fk","sourceToggle":"Detail_sourceToggle__usyXC","responsesTitle":"Detail_responsesTitle__pl2hv","circle":"Detail_circle__qkRQD","circleGray":"Detail_circleGray__L0CuL","responseInfo":"Detail_responseInfo__5B2lu","name":"Detail_name__EmZrP","expert":"Detail_expert__r8sl2","experts":"Detail_experts__sErzm","responseBox":"Detail_responseBox__w0CWJ","quote-all":"Detail_quote-all__ZXlHi","videoUpload":"Detail_videoUpload__TJgEQ","videoInput":"Detail_videoInput__2eeoN","uploadArea":"Detail_uploadArea__m47f8","uploadIcon":"Detail_uploadIcon__ODXGl","dragging":"Detail_dragging__F61zv","disabled":"Detail_disabled__iSnFK","uploadText":"Detail_uploadText__6Jgiu","errorContainer":"Detail_errorContainer__YguJJ","tryAgain":"Detail_tryAgain__TNTSC","videoPreview":"Detail_videoPreview__ws4fb","previewVideo":"Detail_previewVideo__6PK2A","removeVideo":"Detail_removeVideo__hDIir","uploadingState":"Detail_uploadingState__m1_ld","uploadingSpinner":"Detail_uploadingSpinner__yochW","spin":"Detail_spin__W_tax","uploadStatus":"Detail_uploadStatus__ZRdai","uploadWarning":"Detail_uploadWarning___KvAa"};

/***/ }),

/***/ 54537:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ranThis":"RanThis_ranThis__WkW24","label":"RanThis_label__RDwCZ","form":"RanThis_form__85A5x","error":"RanThis_error__tC1Sq","thanks":"RanThis_thanks__O0gna"};

/***/ }),

/***/ 94013:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"ResearchSponsor_box__YEzfw","credit":"ResearchSponsor_credit__CYR_u","strip":"ResearchSponsor_strip__thIWd","stripButton":"ResearchSponsor_stripButton__lFfCX","creditLabel":"ResearchSponsor_creditLabel__JniRl","heading":"ResearchSponsor_heading__MkpF4","text":"ResearchSponsor_text__kY3HS","includes":"ResearchSponsor_includes__uVfiz","list":"ResearchSponsor_list__rGZc_","reserved":"ResearchSponsor_reserved__0T14e","small":"ResearchSponsor_small__ayy7n","form":"ResearchSponsor_form__LHliu","field":"ResearchSponsor_field__kYTl_","error":"ResearchSponsor_error__PJSKf"};

/***/ }),

/***/ 1932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Response_videoWrapper__R_7rb","video":"Response_video__igRZ2","premiumWrapper":"Response_premiumWrapper__47g4e","legendWrapper":"Response_legendWrapper__vJDBr","platinumWrapper":"Response_platinumWrapper__tJJ9W","pinLegend":"Response_pinLegend__55NjZ","platinumBadge":"Response_platinumBadge__o8tAJ","wrapper":"Response_wrapper__S_PMb","footer":"Response_footer__UuQfJ","controls":"Response_controls__guSQb","pin":"Response_pin__zyEET","copy":"Response_copy__yCaSi","headerWrapper":"Response_headerWrapper__65Gef","pinned":"Response_pinned__AQYhc","pinnedLegend":"Response_pinnedLegend__UySGF","pinFree":"Response_pinFree__mPvLe","pinLegend2":"Response_pinLegend2__Q02Iq","pinPlatinum":"Response_pinPlatinum__9V5S9","editor":"Response_editor___NIck","header":"Response_header__rDk_V","logoWrapper":"Response_logoWrapper__r6PS7","logo":"Response_logo__1b6q_","logoTag":"Response_logoTag__hf2LQ","html":"Response_html__73RaK","responseBox":"Response_responseBox__nCY9h","name":"Response_name__qHDec","verifiedBadge":"Response_verifiedBadge__lWCLX","expert":"Response_expert__p_pm8","circle":"Response_circle__wvTjI","circleWrapper":"Response_circleWrapper__QCkt1","contacts":"Response_contacts__JObcZ","contactsLocked":"Response_contactsLocked__cRTRv","button":"Response_button__Cgc9_","experts":"Response_experts__niSCy","footerActive":"Response_footerActive__Urxpe","footerButtons":"Response_footerButtons__NY0q5","loadingState":"Response_loadingState__sKfLQ","errorState":"Response_errorState__YTWui","loadingSpinner":"Response_loadingSpinner__PcI0m","spin":"Response_spin__lvaOj","contributingEditorWrapper":"Response_contributingEditorWrapper__nvDGx","pinnedContributingEditor":"Response_pinnedContributingEditor__77lCy","pinContributingEditor":"Response_pinContributingEditor__i5Eon"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4885,2678,1036,2283,9747,1345,1462,185,2017,8300,362,7883,355,1666,6873,2888,179], function() { return __webpack_exec__(17881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);